/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** Human readable version of a Jane's account access status, cast to String */
  AccessStatusScalar: { input: any; output: any };
  /** Human readable version of an activity event */
  ActivityEventScalar: { input: any; output: any };
  /** represent a value that can be any type - should be paired with a field which denotes the runtime type of the actual object */
  AnyTypeScalar: { input: any; output: any };
  /** Human readable version of an callout not notified reason */
  CalloutNotNotifiedReasonScalar: { input: any; output: any };
  CalloutStatusScalar: { input: any; output: any };
  /** human readable clock in status for displaying to a user */
  ClockInStatusScalar: { input: any; output: any };
  /** human readable clock out status for displaying to a user */
  ClockOutStatusScalar: { input: any; output: any };
  /** A simple value representing a dollar amount, not meant to be used for accounting purpose - only display */
  CurrencyValueScalar: { input: any; output: any };
  FormattedCancelledByScalar: { input: any; output: any };
  FormattedPenaltyTextScalar: { input: any; output: any };
  GroupedOrderKeyScalar: { input: any; output: any };
  GroupedPositionKeyScalar: { input: any; output: any };
  /** A simple value representing a dollar amount, not meant to be used for accounting purpose - only display */
  HoursIntervalScalar: { input: any; output: any };
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: any; output: any };
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any };
  OrderHourlyRateScalar: { input: any; output: any };
  /** A value representing the status of an order. Case insensitive. valid values: - 'In Progress' - 'Unfulfilled' - 'Completed' - 'Requested' - 'Open' - 'Pending Reapply' - 'Rejected' - 'Assigned' - 'Cancelled' - 'Accepted' - 'Swapped' - 'Absent' */
  OrderStatusScalar: { input: any; output: any };
  /** A value representing a human readable version of a Time Off title example values: - 'Time Off' - 'Vacation' - 'Personal' - 'Sick' - 'Stat' - 'Float' */
  TimeOffTitleScalar: { input: any; output: any };
  /** A value representing the status of a time sheet example values: - 'Pending' - 'Approved' - 'No Show' */
  TimeSheetStatusScalar: { input: any; output: any };
  /** A human readable value for the employment status of a user */
  UserEmploymentStatusScalar: { input: any; output: any };
};

/** an entity which has created/update timestamps */
export type AbstractGroup = {
  createdAt: Scalars['ISO8601DateTime']['output'];
  displayId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** janes that belong to a given group, if you are querying this field through a ShiftDistributionRule (ie. shiftDistributionRule.groups.groupJanes) it will only include janes that match the position for that shift distribution rule. If the ShiftDistribution rule is a default rule, (ie. no position) then it will return all janes in the group. If you are not querying this field through a ShiftDistributionRule, it will also include all janes without position filtering. */
  janes: JaneConnection;
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** an entity which has created/update timestamps */
export type AbstractGroupJanesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AcceptedFor = {
  __typename?: 'AcceptedFor';
  jane?: Maybe<Jane>;
  janeId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** User account access status, used to determine which step of the registration process a user is in or if they are blocked */
export type AccessStatus = {
  __typename?: 'AccessStatus';
  name: AccessStatusEnum;
  value: Scalars['AccessStatusScalar']['output'];
};

export enum AccessStatusEnum {
  approved = 'approved',
  blocked = 'blocked',
  incomplete = 'incomplete',
  not_approved = 'not_approved',
  on_hold = 'on_hold',
  pending_signup = 'pending_signup',
  rejected = 'rejected',
}

export enum ActionsRequiredEnum {
  award_shift = 'award_shift',
  callout_completed = 'callout_completed',
  waiting_for_approval = 'waiting_for_approval',
}

export type ActivitiesMetaValue = {
  __typename?: 'ActivitiesMetaValue';
  acceptedFor?: Maybe<AcceptedFor>;
  calloutListId?: Maybe<Scalars['ID']['output']>;
  feedableEdits?: Maybe<Array<FeedableEditMetaValue>>;
  qualifiedAgencyJanesCount?: Maybe<Scalars['Int']['output']>;
  reasonCategory?: Maybe<Scalars['String']['output']>;
  reasonMessage?: Maybe<Scalars['String']['output']>;
};

export type Activity = {
  __typename?: 'Activity';
  createdAt: Scalars['ISO8601DateTime']['output'];
  event: ActivityEventEnum;
};

export enum ActivityEventEnum {
  accepted = 'accepted',
  accepted_by_bookjane = 'accepted_by_bookjane',
  acknowledged = 'acknowledged',
  agency_assigned = 'agency_assigned',
  assigned = 'assigned',
  auto_extend_bid = 'auto_extend_bid',
  auto_released = 'auto_released',
  awarded_shift = 'awarded_shift',
  bidding_end = 'bidding_end',
  callout_list_created = 'callout_list_created',
  callout_paused = 'callout_paused',
  cancelled = 'cancelled',
  clocked_in = 'clocked_in',
  clocked_out = 'clocked_out',
  continued_call_out = 'continued_call_out',
  created = 'created',
  custom_field_created = 'custom_field_created',
  custom_field_disabled = 'custom_field_disabled',
  custom_field_edited = 'custom_field_edited',
  customer_released = 'customer_released',
  declined = 'declined',
  deny_all_bids = 'deny_all_bids',
  feature_disabled = 'feature_disabled',
  feature_enabled = 'feature_enabled',
  jane_released = 'jane_released',
  new_callout_list_created = 'new_callout_list_created',
  not_clocked_in = 'not_clocked_in',
  not_clocked_out = 'not_clocked_out',
  pending = 'pending',
  placed_bid = 'placed_bid',
  requested = 'requested',
  scheduled_send_to_agencies = 'scheduled_send_to_agencies',
  send_to_agencies = 'send_to_agencies',
  sent_to_bookjane = 'sent_to_bookjane',
  sent_to_select_agencies = 'sent_to_select_agencies',
  swap_expired = 'swap_expired',
  swap_initiated = 'swap_initiated',
  swapped = 'swapped',
  unaccepted_by_bookjane = 'unaccepted_by_bookjane',
  updated = 'updated',
  vaccination_required = 'vaccination_required',
}

/** different types of users which can trigger an activity */
export type ActivityUserUnion = Admin | AgencyUser | B2bCustomer | Jane | SecondaryUser | User;

export type Admin = HasTimestamps & {
  __typename?: 'Admin';
  avatarUrls: AvatarUrl;
  createdAt: Scalars['ISO8601DateTime']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Agency = HasTimestamps & {
  __typename?: 'Agency';
  agencyCommunities: Array<AgencyCommunity>;
  avatarUrls: AvatarUrl;
  communityPositions: Array<AgencyPositionDetails>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  directDeposit?: Maybe<DirectDeposit>;
  id: Scalars['Int']['output'];
  lastEditedBy?: Maybe<AgencyUserUnion>;
  liability?: Maybe<Liability>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type AgencyAgencyCommunitiesArgs = {
  filter?: InputMaybe<ForAgencyCommunityAttributes>;
};

export type AgencyCommunity = HasTimestamps & {
  __typename?: 'AgencyCommunity';
  agency: Agency;
  agencyPositionDetails: Array<AgencyPositionDetails>;
  availableJanes: AvailableJanes;
  avatarUrls: AvatarUrl;
  averageRating: AverageRating;
  contactEmail: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  contactPhone: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  janes: Array<Jane>;
  location?: Maybe<Location>;
  locationCode?: Maybe<Scalars['String']['output']>;
  main: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  positions: Array<PositionDetails>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  wsib?: Maybe<Wsib>;
};

export type AgencyCommunityAgencyPositionDetailsArgs = {
  filter?: InputMaybe<FilterableAgencyPositionDetailsAttributes>;
};

/** The connection type for AgencyCommunity. */
export type AgencyCommunityConnection = {
  __typename?: 'AgencyCommunityConnection';
  currentPage?: Maybe<Scalars['Int']['output']>;
  /** A list of edges. */
  edges: Array<AgencyCommunityEdge>;
  /** A list of nodes. */
  nodes: Array<AgencyCommunity>;
  pageCount: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AgencyCommunityEdge = {
  __typename?: 'AgencyCommunityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AgencyCommunity>;
};

export enum AgencyCommunitySortableFieldsEnum {
  createdAt = 'createdAt',
  id = 'id',
  name = 'name',
  openRate = 'openRate',
}

/** The connection type for Agency. */
export type AgencyConnection = {
  __typename?: 'AgencyConnection';
  currentPage?: Maybe<Scalars['Int']['output']>;
  /** A list of edges. */
  edges: Array<AgencyEdge>;
  /** A list of nodes. */
  nodes: Array<Agency>;
  pageCount: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AgencyEdge = {
  __typename?: 'AgencyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Agency>;
};

export type AgencyPositionDetails = {
  __typename?: 'AgencyPositionDetails';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  /** the amount a jane is paid per hour or an open shift */
  openPayout: Scalars['CurrencyValueScalar']['output'];
  /** the rate charged to the customer for an open shift */
  openRate: Scalars['CurrencyValueScalar']['output'];
  positionDetails: PositionDetails;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum AgencySortableFieldsEnum {
  createdAt = 'createdAt',
  id = 'id',
  name = 'name',
}

export type AgencyUser = HasFirstLastName &
  HasTimestamps & {
    __typename?: 'AgencyUser';
    accessLevelId: Scalars['Int']['output'];
    accessStatus: AccessStatus;
    agency?: Maybe<Agency>;
    agencyId?: Maybe<Scalars['Int']['output']>;
    avatar?: Maybe<Scalars['String']['output']>;
    avatarUrls: AvatarUrl;
    createdAt: Scalars['ISO8601DateTime']['output'];
    email: Scalars['String']['output'];
    firstName: Scalars['String']['output'];
    gender?: Maybe<Scalars['Int']['output']>;
    hasPools: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    janes?: Maybe<Array<Jane>>;
    lastName: Scalars['String']['output'];
    locale: Scalars['String']['output'];
    payrollManagement: Scalars['Boolean']['output'];
    phone?: Maybe<Scalars['String']['output']>;
    pushReceivingChannels: Array<PushReceivingChannelEnum>;
    tcAndPrivacy: Scalars['Boolean']['output'];
    title?: Maybe<Scalars['String']['output']>;
    type: Scalars['String']['output'];
    updatedAt: Scalars['ISO8601DateTime']['output'];
  };

/** different types of users which can trigger an activity */
export type AgencyUserUnion = AgencyUser | User;

export type AggregateJanesByTypes = {
  __typename?: 'AggregateJanesByTypes';
  agency: Scalars['Int']['output'];
  internal: Scalars['Int']['output'];
  shared: Scalars['Int']['output'];
};

/** Autogenerated input type of AssignOrder */
export type AssignOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  janeId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
};

/** Autogenerated return type of AssignOrder */
export type AssignOrderPayload = {
  __typename?: 'AssignOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  jane: Jane;
  order: Order;
  status: MutationOutcomeStatusEnum;
};

/**
 * enum to indicate which audit trail algorithm was used to create the order
 *
 */
export enum AuditTrailVersionEnum {
  /** legacy bookjane tiering/audit trail */
  v1 = 'v1',
  /** transparent callout lists and validation */
  v2 = 'v2',
}

export type AvailableJanes = {
  __typename?: 'AvailableJanes';
  count: Scalars['Int']['output'];
  janes: JaneConnection;
};

export type AvailableJanesJanesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** parameters needed in order to return which janes are available for a given agency community */
export type AvailableJanesAttributes = {
  filter?: InputMaybe<FilterableJaneAttributes>;
  relevantForOrder: RelevantForOrderAttributes;
};

export type AvatarUrl = {
  __typename?: 'AvatarUrl';
  large?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  small?: Maybe<Scalars['String']['output']>;
};

export type AverageRating = {
  __typename?: 'AverageRating';
  count: Scalars['Int']['output'];
  reviews: Array<Review>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type B2bCustomer = HasFirstLastName &
  HasTimestamps & {
    __typename?: 'B2bCustomer';
    accessLevelId: Scalars['Int']['output'];
    accessStatus: AccessStatus;
    adpCustomIdentifier?: Maybe<Scalars['String']['output']>;
    agencyCustomer: Scalars['Boolean']['output'];
    availabilityStatus: Scalars['String']['output'];
    avatarUrls: AvatarUrl;
    communities: Array<Community>;
    completedOnboardingSteps: Scalars['Int']['output'];
    createdAt: Scalars['ISO8601DateTime']['output'];
    email: Scalars['String']['output'];
    firstName: Scalars['String']['output'];
    hasPools: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    industry?: Maybe<Scalars['String']['output']>;
    lastName: Scalars['String']['output'];
    locale: Scalars['String']['output'];
    payrollManagement: Scalars['Boolean']['output'];
    phone?: Maybe<Scalars['String']['output']>;
    serviceablePositions: Array<PositionDetails>;
    tieringStatus: Scalars['String']['output'];
    type: Scalars['String']['output'];
    unreadConversations?: Maybe<Scalars['Int']['output']>;
    updatedAt: Scalars['ISO8601DateTime']['output'];
    userRole: Scalars['String']['output'];
    userType: Scalars['String']['output'];
  };

export type BelongingToTeamAttributes = {
  /** consider teams for these positions */
  forPositions: Array<Scalars['Int']['input']>;
  /** only consider teams belonging to these communities */
  inCommunities: Array<Scalars['Int']['input']>;
};

export type BiddingTime = HasTimestamps & {
  __typename?: 'BiddingTime';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  leadTime: Scalars['Int']['output'];
  priorityTime: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type BudgetAllocation = HasTimestamps & {
  __typename?: 'BudgetAllocation';
  community: Community;
  createdAt: Scalars['ISO8601DateTime']['output'];
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  eveningErrorMargin: Scalars['Int']['output'];
  eveningRatio?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  morningErrorMargin: Scalars['Int']['output'];
  morningRatio?: Maybe<Scalars['Int']['output']>;
  nightErrorMargin: Scalars['Int']['output'];
  nightRatio?: Maybe<Scalars['Int']['output']>;
  occupancy: Scalars['Int']['output'];
  position: PositionDetails;
  startDate: Scalars['ISO8601Date']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type CalloutList = HasTimestamps &
  Node & {
    __typename?: 'CalloutList';
    calloutListJanes: CalloutListJaneConnection;
    createdAt: Scalars['ISO8601DateTime']['output'];
    estimatedCompletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
    id: Scalars['ID']['output'];
    isCompleted: Scalars['Boolean']['output'];
    lastCallJanes: Array<LastCallJane>;
    manualApprovalIndexes: Array<ManualApprovalIndex>;
    manualApprovals: Array<ManualApproval>;
    order: Order;
    totalJanes: Scalars['Int']['output'];
    totalNotifiedAndSkipped: Scalars['Int']['output'];
    updatedAt: Scalars['ISO8601DateTime']['output'];
    waitingForManualApproval: Scalars['Boolean']['output'];
  };

export type CalloutListCalloutListJanesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CalloutListJane = HasTimestamps &
  Node & {
    __typename?: 'CalloutListJane';
    calloutList: CalloutList;
    calloutStatus: CalloutStatus;
    createdAt: Scalars['ISO8601DateTime']['output'];
    estimatedCalloutTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
    /** ID of the object. */
    id: Scalars['ID']['output'];
    jane: Jane;
    manualApproval?: Maybe<ManualApproval>;
    notNotifiedLogs: Array<CalloutNotNotifiedLog>;
    notifiedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
    rank: Scalars['Int']['output'];
    updatedAt: Scalars['ISO8601DateTime']['output'];
  };

/** The connection type for CalloutListJane. */
export type CalloutListJaneConnection = {
  __typename?: 'CalloutListJaneConnection';
  currentPage?: Maybe<Scalars['Int']['output']>;
  /** A list of edges. */
  edges: Array<CalloutListJaneEdge>;
  /** A list of nodes. */
  nodes: Array<CalloutListJane>;
  pageCount: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CalloutListJaneEdge = {
  __typename?: 'CalloutListJaneEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CalloutListJane>;
};

export type CalloutNotNotifiedLog = HasTimestamps & {
  __typename?: 'CalloutNotNotifiedLog';
  createdAt: Scalars['ISO8601DateTime']['output'];
  reason: CalloutNotNotifiedReason;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type CalloutNotNotifiedReason = HasTimestamps & {
  __typename?: 'CalloutNotNotifiedReason';
  createdAt: Scalars['ISO8601DateTime']['output'];
  name: CalloutNotNotifiedReasonEnum;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  value: Scalars['CalloutNotNotifiedReasonScalar']['output'];
};

export enum CalloutNotNotifiedReasonEnum {
  already_notified = 'already_notified',
  gap_time_between_shifts = 'gap_time_between_shifts',
  invalid_employment_status = 'invalid_employment_status',
  invalid_status = 'invalid_status',
  missing_position = 'missing_position',
  multi_location_callout_disabled = 'multi_location_callout_disabled',
  order_accepted = 'order_accepted',
  out_of_area = 'out_of_area',
  overtime_not_allowed = 'overtime_not_allowed',
  pending_signup = 'pending_signup',
  schedule_conflict = 'schedule_conflict',
  sharing_disabled = 'sharing_disabled',
  time_off_conflict = 'time_off_conflict',
}

export type CalloutStatus = {
  __typename?: 'CalloutStatus';
  name: Scalars['CalloutStatusScalar']['output'];
  value: CalloutStatusEnum;
};

export enum CalloutStatusEnum {
  already_notified = 'already_notified',
  gap_time_between_shifts = 'gap_time_between_shifts',
  in_line = 'in_line',
  invalid_employment_status = 'invalid_employment_status',
  invalid_status = 'invalid_status',
  missing_position = 'missing_position',
  multi_location_callout_disabled = 'multi_location_callout_disabled',
  not_notified = 'not_notified',
  notified = 'notified',
  order_accepted = 'order_accepted',
  out_of_area = 'out_of_area',
  overtime_allowed_in_line = 'overtime_allowed_in_line',
  overtime_allowed_notified = 'overtime_allowed_notified',
  overtime_not_allowed = 'overtime_not_allowed',
  pending_signup = 'pending_signup',
  schedule_conflict = 'schedule_conflict',
  sharing_disabled = 'sharing_disabled',
  time_off_conflict = 'time_off_conflict',
}

export type CancelReasonMetadata = IdWithDisplayText & {
  __typename?: 'CancelReasonMetadata';
  displayText: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type ClockInStatus = {
  __typename?: 'ClockInStatus';
  /** pretty value for ClockInStatus, concrete value always String */
  prettyValue: Scalars['ClockInStatusScalar']['output'];
  value: ClockInStatusEnum;
};

export enum ClockInStatusEnum {
  clocked_in = 'clocked_in',
  late_clock_in = 'late_clock_in',
  not_clocked_in = 'not_clocked_in',
}

export type ClockOutStatus = {
  __typename?: 'ClockOutStatus';
  /** pretty value for ClockOutStatus, concrete value always String */
  prettyValue: Scalars['ClockOutStatusScalar']['output'];
  value: ClockOutStatusEnum;
};

export enum ClockOutStatusEnum {
  clocked_out = 'clocked_out',
  not_clocked_out = 'not_clocked_out',
}

export type CommunitiesPosition = Node & {
  __typename?: 'CommunitiesPosition';
  community: Community;
  id: Scalars['Int']['output'];
  position: PositionDetails;
  relayId: Scalars['ID']['output'];
  shiftCancellationWorkerMetadata: ShiftCancellationWorkerMetadata;
};

export type Community = HasTimestamps & {
  __typename?: 'Community';
  activeBudgetAllocation?: Maybe<BudgetAllocation>;
  availabilityStatus: Scalars['Int']['output'];
  avatarUrls?: Maybe<AvatarUrl>;
  b2bUserShiftEditThreshold?: Maybe<Scalars['Int']['output']>;
  biddingTimes?: Maybe<Array<BiddingTime>>;
  checkInProcedure?: Maybe<Scalars['String']['output']>;
  communitiesPositions: Array<CommunitiesPosition>;
  communityFeatures?: Maybe<Array<CommunityFeature>>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customFields: Array<CustomField>;
  customer: B2bCustomer;
  displayId: Scalars['String']['output'];
  document?: Maybe<Scalars['String']['output']>;
  /** String */
  dressCode?: Maybe<Scalars['String']['output']>;
  escalationTimes?: Maybe<Array<EscalationTime>>;
  /** Fetch community groups */
  groups: GroupUnionConnection;
  /** @deprecated id is deprecated, use displayId instead */
  id: Scalars['Int']['output'];
  identifier: Scalars['String']['output'];
  isTest: Scalars['Boolean']['output'];
  leadTimes?: Maybe<Array<LeadTime>>;
  location?: Maybe<Location>;
  locationHistory?: Maybe<Scalars['String']['output']>;
  locationPositions: Array<PositionDetails>;
  main: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nextBudgetAllocation?: Maybe<BudgetAllocation>;
  organization?: Maybe<Organization>;
  parking?: Maybe<Scalars['String']['output']>;
  /** String */
  policies?: Maybe<Scalars['String']['output']>;
  positionSchedulingSettings: Array<SchedulingSettings>;
  positions: Array<PositionDetails>;
  schedulingSettings?: Maybe<SchedulingSettings>;
  secondaryUserShiftEditThreshold?: Maybe<Scalars['Int']['output']>;
  shiftDistributionRules: Array<ShiftDistributionRule>;
  timeFrame: TimeFrame;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  vaccinationRequired: Scalars['Boolean']['output'];
  vaccinationRequiredLastUpdated?: Maybe<Scalars['ISO8601DateTime']['output']>;
  vaccinationRequiredLastUpdatedBy?: Maybe<Scalars['String']['output']>;
  welcomeMessage?: Maybe<Scalars['String']['output']>;
};

export type CommunityActiveBudgetAllocationArgs = {
  forPosition: Scalars['Int']['input'];
};

export type CommunityGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterableGroupAttributes>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CommunityNextBudgetAllocationArgs = {
  forPosition: Scalars['Int']['input'];
};

/** attributes for community */
export type CommunityAttributes = {
  checkInProcedure?: InputMaybe<Scalars['String']['input']>;
  communityFeaturesAttributes?: InputMaybe<Array<CommunityFeaturesAttributes>>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  dressCode?: InputMaybe<Scalars['String']['input']>;
  escalationTimesAttributes?: InputMaybe<Array<EscalationTimesAttributes>>;
  leadTimesAttributes?: InputMaybe<Array<LeadTimesAttributes>>;
  locationHistory?: InputMaybe<Scalars['String']['input']>;
  main?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parking?: InputMaybe<Scalars['String']['input']>;
  policies?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for Community. */
export type CommunityConnection = {
  __typename?: 'CommunityConnection';
  currentPage?: Maybe<Scalars['Int']['output']>;
  /** A list of edges. */
  edges: Array<CommunityEdge>;
  /** A list of nodes. */
  nodes: Array<Community>;
  pageCount: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CommunityEdge = {
  __typename?: 'CommunityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Community>;
};

export type CommunityFeature = HasTimestamps & {
  __typename?: 'CommunityFeature';
  createdAt: Scalars['ISO8601DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  feature?: Maybe<Feature>;
  id: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** community features to turn on */
export type CommunityFeaturesAttributes = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
};

export enum CommunitySortableFieldsEnum {
  id = 'id',
  name = 'name',
}

export type Counted = {
  __typename?: 'Counted';
  subGroups: Array<Reflected>;
  value: Scalars['Int']['output'];
};

export type Currency = {
  __typename?: 'Currency';
  currency?: Maybe<Scalars['CurrencyValueScalar']['output']>;
  rawCurrency?: Maybe<Scalars['Float']['output']>;
};

/** different types of users it is possible to log in as */
export type CurrentUserUnion = AgencyUser | B2bCustomer | Jane | SecondaryUser;

export type CustomField = {
  __typename?: 'CustomField';
  activities: Array<Activity>;
  allFacilities: Scalars['Boolean']['output'];
  communities?: Maybe<Array<Community>>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  customFieldOptions?: Maybe<Array<CustomFieldOption>>;
  fieldType: CustomFieldTypeEnum;
  id: Scalars['Int']['output'];
  lastEditedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  mobile: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  placeholder: Scalars['String']['output'];
  prefillDefault: Scalars['Boolean']['output'];
};

/** The connection type for CustomField. */
export type CustomFieldConnection = {
  __typename?: 'CustomFieldConnection';
  currentPage?: Maybe<Scalars['Int']['output']>;
  /** A list of edges. */
  edges: Array<CustomFieldEdge>;
  /** A list of nodes. */
  nodes: Array<CustomField>;
  pageCount: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomFieldEdge = {
  __typename?: 'CustomFieldEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CustomField>;
};

export type CustomFieldOption = {
  __typename?: 'CustomFieldOption';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  value: Scalars['String']['output'];
};

export enum CustomFieldTypeEnum {
  dropdown = 'dropdown',
  input = 'input',
  text_area = 'text_area',
}

export type CustomFieldTypeMetadata = IdWithDisplayText & {
  __typename?: 'CustomFieldTypeMetadata';
  displayText: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type CustomFieldValue = {
  __typename?: 'CustomFieldValue';
  customFieldId: Scalars['Int']['output'];
  mobile: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CustomerReviews = {
  __typename?: 'CustomerReviews';
  averageRating?: Maybe<Scalars['Float']['output']>;
  count: Scalars['Int']['output'];
  reviews: Array<Review>;
};

export type DashboardWeeklyOverview = {
  __typename?: 'DashboardWeeklyOverview';
  /** Total amount spent by agency for the current week */
  agencySpent: Scalars['Float']['output'];
  /** Change in agency spent compared to the previous week */
  agencySpentChange: Scalars['Float']['output'];
  /** Total number of daily overtime hours worked for the current week */
  dailyOvertimeHours: Scalars['Float']['output'];
  /** Percentage of fulfilled shifts for the current week */
  fulfillmentRate: Scalars['Float']['output'];
  /** Change in shift fulfillment rate compared to the previous week */
  fulfillmentRateChange: Scalars['Float']['output'];
  /** Number of pending orders for the current week */
  pendingOrders: Scalars['Int']['output'];
  /** Number of pending orders for today */
  pendingOrdersToday: Scalars['Int']['output'];
  /** The end date of the current week of the pay period */
  weekEndsAt: Scalars['ISO8601DateTime']['output'];
  /** The start date of the current week of the pay period */
  weekStartsAt: Scalars['ISO8601DateTime']['output'];
  /** Total number of overtime hours worked for the current week */
  weeklyOvertimeHours: Scalars['Float']['output'];
  /** Change in overtime hours compared to the previous week */
  weeklyOvertimeHoursChange: Scalars['Float']['output'];
};

export type DateRangeAttributes = {
  from: Scalars['ISO8601DateTime']['input'];
  to: Scalars['ISO8601DateTime']['input'];
};

/** a date range which does not require an upper bound */
export type DateRangeUnboundAttributes = {
  from: Scalars['ISO8601DateTime']['input'];
  to?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Autogenerated input type of DeleteTimeOff */
export type DeleteTimeOffInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  timeOffId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteTimeOff */
export type DeleteTimeOffPayload = {
  __typename?: 'DeleteTimeOffPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  status: MutationOutcomeStatusEnum;
};

export type Department = {
  __typename?: 'Department';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  status: DepartmentStatusEnum;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum DepartmentStatusEnum {
  active = 'active',
  inactive = 'inactive',
}

export type DirectDeposit = {
  __typename?: 'DirectDeposit';
  chequeImageUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  hstNumber: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Document = {
  __typename?: 'Document';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type DocumentUrl = {
  __typename?: 'DocumentUrl';
  large?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  small?: Maybe<Scalars['String']['output']>;
};

export type DraftShift = {
  __typename?: 'DraftShift';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

export type DynamicGroup = AbstractGroup &
  HasTimestamps &
  Node & {
    __typename?: 'DynamicGroup';
    createdAt: Scalars['ISO8601DateTime']['output'];
    criteria: DynamicGroupCriteria;
    displayId: Scalars['Int']['output'];
    id: Scalars['ID']['output'];
    /** janes that belong to a given group, if you are querying this field through a ShiftDistributionRule (ie. shiftDistributionRule.groups.groupJanes) it will only include janes that match the position for that shift distribution rule. If the ShiftDistribution rule is a default rule, (ie. no position) then it will return all janes in the group. If you are not querying this field through a ShiftDistributionRule, it will also include all janes without position filtering. */
    janes: JaneConnection;
    name: Scalars['String']['output'];
    updatedAt: Scalars['ISO8601DateTime']['output'];
  };

export type DynamicGroupJanesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type DynamicGroupCriteria = HasTimestamps & {
  __typename?: 'DynamicGroupCriteria';
  createdAt: Scalars['ISO8601DateTime']['output'];
  displayId: Scalars['Int']['output'];
  employmentStatuses: Array<GroupEmploymentStatusEnum>;
  locationDistribution: LocationDistributionEnum;
  maximumPerDayMinutes?: Maybe<Scalars['Int']['output']>;
  maximumPerPeriodMinutes?: Maybe<Scalars['Int']['output']>;
  minimumPerDayMinutes: Scalars['Int']['output'];
  minimumPerPeriodMinutes: Scalars['Int']['output'];
  positionTypes: Array<PositionTypeEnum>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type DynamicGroupCriteriaEmploymentStatusMetadata = IdWithDisplayText & {
  __typename?: 'DynamicGroupCriteriaEmploymentStatusMetadata';
  displayText: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type EditReasonMetadata = IdWithDisplayText & {
  __typename?: 'EditReasonMetadata';
  displayText: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type Education = {
  __typename?: 'Education';
  degree?: Maybe<Scalars['String']['output']>;
  fieldOfStudy?: Maybe<Scalars['String']['output']>;
  fromDate?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  school?: Maybe<Scalars['String']['output']>;
  toDate?: Maybe<Scalars['ISO8601Date']['output']>;
};

export type EmploymentStatus = {
  __typename?: 'EmploymentStatus';
  description: Scalars['UserEmploymentStatusScalar']['output'];
  name: UserEmploymentStatusEnum;
};

export type EmploymentStatusMetadata = IdWithDisplayText & {
  __typename?: 'EmploymentStatusMetadata';
  displayText: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

/**
 * indicates how to proceed with callout after enabling overtime
 *
 */
export enum EnableOvertimeStrategyEnum {
  /** do not restart callout, continue from the current position */
  NO_RESTART = 'NO_RESTART',
  /** restart callout and notify all eligible team members */
  RESTART_NOTIFY = 'RESTART_NOTIFY',
  /** restart callout but do not notify team members that were previously notified */
  RESTART_NO_NOTIFY = 'RESTART_NO_NOTIFY',
}

/** different types of users which can trigger an activity */
export type EnterpriseUserUnion = B2bCustomer | SecondaryUser | User;

export type EscalationTime = HasTimestamps & {
  __typename?: 'EscalationTime';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  priority: EscalationTimePriorityEnum;
  priorityTime: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum EscalationTimePriorityEnum {
  critical = 'critical',
  high_priority = 'high_priority',
  shift_exchange = 'shift_exchange',
  vacation_loa = 'vacation_loa',
}

/** settings for escalation time */
export type EscalationTimesAttributes = {
  id?: InputMaybe<Scalars['Int']['input']>;
  priorityTime?: InputMaybe<Scalars['Int']['input']>;
};

export type Event = {
  __typename?: 'Event';
  name: ActivityEventEnum;
  value: Scalars['ActivityEventScalar']['output'];
};

export type ExperienceSource = {
  __typename?: 'ExperienceSource';
  company?: Maybe<Scalars['String']['output']>;
  fromDate?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  position?: Maybe<Scalars['String']['output']>;
  toDate?: Maybe<Scalars['ISO8601Date']['output']>;
};

export type FacilityAttributes = {
  id: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

export type Feature = HasTimestamps & {
  __typename?: 'Feature';
  createdAt: Scalars['ISO8601DateTime']['output'];
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum FeedableEditDropdownEnum {
  checkbox = 'checkbox',
  dropdown = 'dropdown',
  input = 'input',
  text_area = 'text_area',
}

export type FeedableEditMetaValue = {
  __typename?: 'FeedableEditMetaValue';
  fieldName?: Maybe<Scalars['String']['output']>;
  fieldNamePretty?: Maybe<Scalars['String']['output']>;
  fieldType?: Maybe<FeedableEditDropdownEnum>;
  newValue?: Maybe<Scalars['String']['output']>;
  newValuePretty?: Maybe<Scalars['String']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
  oldValuePretty?: Maybe<Scalars['String']['output']>;
};

/** Attributes that agencies can be filtered by */
export type FilterableAgencyAttributes = {
  byName?: InputMaybe<Scalars['String']['input']>;
};

/** Attributes that agency community can be filtered by */
export type FilterableAgencyCommunityAttributes = {
  forAgencyCommunities?: InputMaybe<ForAgencyCommunityAttributes>;
};

/** Attributes that positions can be filtered by. */
export type FilterableAgencyPositionDetailsAttributes = {
  /** Filter agency position by ID */
  byId?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** filter agency positions to those can service the provided Order */
  servicingOrder?: InputMaybe<Scalars['ID']['input']>;
};

/**
 *       backend doesn't support filtering by "falsey" values by default
 *       so this enum exists as a workaround to be able to do "negative filtering"
 *
 *       ie. orders => has_assigned_jane: false
 *
 *       with a boolean would not work, but using 'f' with this enum will
 *
 */
export enum FilterableBooleanEnum {
  /** false */
  f = 'f',
  /** true */
  t = 't',
}

export type FilterableCommunitiesAttributes = {
  /** Filter by name of the community */
  byName?: InputMaybe<Scalars['String']['input']>;
  /** Only return locations that have the specified features enabled */
  withEnabledFeatures?: InputMaybe<Array<Scalars['String']['input']>>;
  /** return communities only with the given id */
  withId?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Only return locations that do not have the specified features enabled */
  withoutEnabledFeatures?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FilterableCustomFieldAttributes = {
  /** Filter by community id */
  withCommunity?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Attributes that employee positions can be filtered by. */
export type FilterableEmployeePositionAttributes = {
  /** filter by attributes on the details of the position */
  forDetails?: InputMaybe<FilterablePositionAttributes>;
};

/** Attributes that groups can be filtered by when querying groups. */
export type FilterableGroupAttributes = {
  /** return groups with the exact name */
  withExactName?: InputMaybe<Scalars['String']['input']>;
  /** filter by id */
  withId?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** filter by matching to similar name */
  withName?: InputMaybe<Scalars['String']['input']>;
  /** return only groups with the given polymorphic type */
  withType?: InputMaybe<Array<GroupTypeEnum>>;
};

/** Attributes that janes can be filtered by when querying janes for a B2B or Agency user. */
export type FilterableJaneAttributes = {
  /** filter janes belonging only to dedicated teams for a specific positions across communities */
  belongingToTeam?: InputMaybe<BelongingToTeamAttributes>;
  /** Filter janes by agency id, will exclude all b2b janes automatically */
  byAgency?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter janes by agency community id, will exclude all b2b janes automatically */
  byAgencyCommunity?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter by any access status, i.e. from the AccessStatus enum */
  byEmploymentStatus?: InputMaybe<Array<UserEmploymentStatusEnum>>;
  /** Filter by first name or last name */
  byFullName?: InputMaybe<Scalars['String']['input']>;
  /** filter according to janes belonging to given groups */
  byGroupIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** filter by janes with all given IDs */
  byId?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by name or email or phone */
  byMultipleFields?: InputMaybe<Scalars['String']['input']>;
  /** Filter janes by pending signup */
  byPendingSignup?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Filter by any position id */
  byPosition?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter janes by community id, will exclude all agency janes automatically */
  byPrimaryCommunity?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter agency janes having rate less than or equal to the specified value. if requesting_for_order.is_dedicated is true dedicated rate is considered, or else, open rate is considered */
  byRateLessThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
  /** Filter by any access status, i.e. from the AccessStatus enum */
  byStatus?: InputMaybe<Array<AccessStatusEnum>>;
  /** Filter janes that have either primary or secondary community, will exclude all agency janes automatically */
  withServiceableCommunity?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** attributes that orders can be filtered by */
export type FilterableOrderAttributes = {
  forAgencyCommunities?: InputMaybe<ForAgencyCommunityAttributes>;
  forJanes?: InputMaybe<FilterableJaneAttributes>;
  forOrders?: InputMaybe<ForOrderAttributes>;
};

/** Attributes that positions can be filtered by. */
export type FilterablePositionAttributes = {
  /** Only positions that are allocated to the given community IDs */
  allocatedToCommunities?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** only bookjane positions that are serviced by the given agency community ids */
  byAgencyCommunity?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** only include positions that are serviced by agencies for the given community position id */
  byAgencyServicedPosition?: InputMaybe<Scalars['Int']['input']>;
  /** Filter positions by ID */
  byId?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter by name of the position */
  byName?: InputMaybe<Scalars['String']['input']>;
};

/** attributes that shift distribution rules can be filtered by */
export type FilterableShiftDistributionRuleAttributes = {
  /** return only shift distribution rules that are not for a given position, is mutually exclusive with using the `forPositions` filter - will raise an error if defaultRules: true and any forPositions filters are given */
  defaultRules?: InputMaybe<Scalars['Boolean']['input']>;
  forCommunities?: InputMaybe<FilterableCommunitiesAttributes>;
  forPositions?: InputMaybe<FilterablePositionAttributes>;
};

/** available filters for time off */
export type FilterableTimeOffAttributes = {
  forTimeOff?: InputMaybe<ForTimeOffAttributes>;
};

/** Attributes on timesheets/shifts which can be filtered */
export type FilterableTimeSheetAttributes = {
  forJanes?: InputMaybe<FilterableJaneAttributes>;
  forOrders?: InputMaybe<ForOrderAttributes>;
  forTimeSheets?: InputMaybe<ForTimeSheetAttributes>;
};

/** attributes that agencies can be filtered by, when used with a non-Agency query will result in a join and will exclude the parent objects which do not match the agency filter */
export type ForAgencyCommunityAttributes = {
  byName?: InputMaybe<Scalars['String']['input']>;
  withAgencyId?: InputMaybe<Array<Scalars['Int']['input']>>;
  withId?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Attributes that orders can be filtered by when querying orders for a B2B or Agency user. */
export type ForOrderAttributes = {
  createdBetween?: InputMaybe<DateRangeUnboundAttributes>;
  createdOnDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  sentToAgencies?: InputMaybe<FilterableBooleanEnum>;
  sentToAgenciesWthoutInternal?: InputMaybe<FilterableBooleanEnum>;
  startBetweenTimeRange?: InputMaybe<DateRangeAttributes>;
  startsAfter?: InputMaybe<DateRangeUnboundAttributes>;
  withActionsRequired?: InputMaybe<Array<ActionsRequiredEnum>>;
  withBiddable?: InputMaybe<Scalars['String']['input']>;
  withCaregiverName?: InputMaybe<Scalars['String']['input']>;
  withClientName?: InputMaybe<Scalars['String']['input']>;
  withCommunity?: InputMaybe<Array<Scalars['Int']['input']>>;
  withJaneType?: InputMaybe<Array<JaneTypeEnum>>;
  withOverlappingTimeRange?: InputMaybe<DateRangeAttributes>;
  withPositions?: InputMaybe<Array<Scalars['Int']['input']>>;
  withStaff?: InputMaybe<OrderWithStaffAttributes>;
  withStatus?: InputMaybe<Array<OrderStatusEnum>>;
  withTimeFrame?: InputMaybe<Array<TimeFrameEnum>>;
  withinBounds?: InputMaybe<LocationBoundingBoxAttributes>;
};

/** filters for only time off */
export type ForTimeOffAttributes = {
  occursDuring?: InputMaybe<DateRangeAttributes>;
  startsBetween?: InputMaybe<DateRangeAttributes>;
  withJanes?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** attributes that shifts can be filtered by */
export type ForTimeSheetAttributes = {
  autoApproved?: InputMaybe<Scalars['Boolean']['input']>;
  byFlaggedIssue?: InputMaybe<Array<TimeSheetFlaggedIssueEnum>>;
  byStatus?: InputMaybe<Array<TimeSheetStatusEnum>>;
  endingBetweenWithTimeSheet?: InputMaybe<DateRangeAttributes>;
  withShiftStatus?: InputMaybe<Array<ShiftStatusForTimeSheetsEnum>>;
};

export enum GenderEnum {
  female = 'female',
  male = 'male',
  not_applicable = 'not_applicable',
  not_known = 'not_known',
}

export type GroupCountableOrderAttributes = {
  field: GroupCountableOrderAttributesEnum;
};

export enum GroupCountableOrderAttributesEnum {
  startDate = 'startDate',
  status = 'status',
}

export type GroupCountedOrders = {
  __typename?: 'GroupCountedOrders';
  counted: Array<Counted>;
  group: Reflected;
};

export enum GroupEmploymentStatusEnum {
  casual = 'casual',
  flex = 'flex',
  full_time = 'full_time',
  part_time = 'part_time',
}

export type GroupJane = HasTimestamps &
  Node & {
    __typename?: 'GroupJane';
    createdAt: Scalars['ISO8601DateTime']['output'];
    displayId: Scalars['Int']['output'];
    /** ID of the object. */
    id: Scalars['ID']['output'];
    jane: Jane;
    relayId: Scalars['ID']['output'];
    updatedAt: Scalars['ISO8601DateTime']['output'];
  };

/** The connection type for GroupJane. */
export type GroupJaneConnection = {
  __typename?: 'GroupJaneConnection';
  currentPage?: Maybe<Scalars['Int']['output']>;
  /** A list of edges. */
  edges: Array<GroupJaneEdge>;
  /** A list of nodes. */
  nodes: Array<GroupJane>;
  pageCount: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GroupJaneEdge = {
  __typename?: 'GroupJaneEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GroupJane>;
};

/** shift distribution group rules */
export type GroupRule = HasTimestamps &
  Node & {
    __typename?: 'GroupRule';
    createdAt: Scalars['ISO8601DateTime']['output'];
    displayId: Scalars['Int']['output'];
    group: GroupUnion;
    /** ID of the object. */
    id: Scalars['ID']['output'];
    rank: Scalars['Int']['output'];
    updatedAt: Scalars['ISO8601DateTime']['output'];
    waitTimeMinutes?: Maybe<Scalars['Int']['output']>;
  };

export enum GroupTypeEnum {
  DYNAMIC = 'DYNAMIC',
  STATIC = 'STATIC',
}

/** different types of groups in the system */
export type GroupUnion = DynamicGroup | StaticGroup;

/** The connection type for GroupUnion. */
export type GroupUnionConnection = {
  __typename?: 'GroupUnionConnection';
  currentPage?: Maybe<Scalars['Int']['output']>;
  /** A list of edges. */
  edges: Array<GroupUnionEdge>;
  /** A list of nodes. */
  nodes: Array<GroupUnion>;
  pageCount: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GroupUnionEdge = {
  __typename?: 'GroupUnionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GroupUnion>;
};

export type GroupableOrderAttributes = {
  field: GroupableOrderAttributesEnum;
  sort?: InputMaybe<SortDirectionEnum>;
};

export enum GroupableOrderAttributesEnum {
  createdAt = 'createdAt',
  startDate = 'startDate',
  status = 'status',
}

export type GroupablePositionAttributes = {
  field: GroupablePositionAttributesEnum;
  sort?: InputMaybe<SortDirectionEnum>;
};

export enum GroupablePositionAttributesEnum {
  /** Groups by department name if present or else groups by work team. */
  departmentOrWorkTeam = 'departmentOrWorkTeam',
}

export type GroupedOrders = {
  __typename?: 'GroupedOrders';
  group: Scalars['GroupedOrderKeyScalar']['output'];
  items: Array<Order>;
};

/** The connection type for GroupedOrders. */
export type GroupedOrdersConnection = {
  __typename?: 'GroupedOrdersConnection';
  currentPage?: Maybe<Scalars['Int']['output']>;
  /** A list of edges. */
  edges: Array<GroupedOrdersEdge>;
  /** A list of nodes. */
  nodes: Array<GroupedOrders>;
  pageCount: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GroupedOrdersEdge = {
  __typename?: 'GroupedOrdersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GroupedOrders>;
};

export type GroupedPositions = {
  __typename?: 'GroupedPositions';
  group: Scalars['GroupedPositionKeyScalar']['output'];
  items: Array<PositionDetails>;
};

/** The connection type for GroupedPositions. */
export type GroupedPositionsConnection = {
  __typename?: 'GroupedPositionsConnection';
  currentPage?: Maybe<Scalars['Int']['output']>;
  /** A list of edges. */
  edges: Array<GroupedPositionsEdge>;
  /** A list of nodes. */
  nodes: Array<GroupedPositions>;
  pageCount: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GroupedPositionsEdge = {
  __typename?: 'GroupedPositionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GroupedPositions>;
};

/** an entity which has a first_name and last_name */
export type HasFirstLastName = {
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

/** an entity which has created/update timestamps */
export type HasTimestamps = {
  createdAt: Scalars['ISO8601DateTime']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** a metadata entity with an id descriptor and a text field for displaying to users */
export type IdWithDisplayText = {
  displayText: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export enum InRotationalPoolEnum {
  no = 'no',
  yes = 'yes',
}

export type Industry = {
  __typename?: 'Industry';
  kind: Scalars['String']['output'];
  positions: Array<PositionDetails>;
  users: Array<User>;
};

export type InsuranceDocument = {
  __typename?: 'InsuranceDocument';
  archived: Scalars['Boolean']['output'];
  documentUrls: DocumentUrl;
  id: Scalars['ID']['output'];
};

export type Invitation = {
  __typename?: 'Invitation';
  community?: Maybe<Community>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expiry?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['Int']['output'];
  invitationId: Scalars['String']['output'];
  inviteType: InvitationTypeEnum;
  inviteUrl?: Maybe<Scalars['String']['output']>;
  invitedBy?: Maybe<User>;
  lastSendAttempt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  newJaneType?: Maybe<InvitationNewJaneTypeEnum>;
  phone?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
};

export enum InvitationNewJaneTypeEnum {
  agency_jane = 'agency_jane',
  b2b_jane = 'b2b_jane',
}

export enum InvitationTypeEnum {
  email = 'email',
  organization = 'organization',
  phone = 'phone',
  spreadsheet = 'spreadsheet',
}

export type Jane = HasFirstLastName &
  HasTimestamps & {
    __typename?: 'Jane';
    acceptedByAgency: Scalars['Boolean']['output'];
    accessStatus: AccessStatus;
    agencyCommunity?: Maybe<AgencyCommunity>;
    avatarUrls: AvatarUrl;
    /** This boolean field is used to show the tick on the Agency Members */
    belongsToPool: Scalars['Boolean']['output'];
    /** Description of the jane */
    bio?: Maybe<Scalars['String']['output']>;
    birthDay?: Maybe<Scalars['Int']['output']>;
    birthMonth?: Maybe<Scalars['Int']['output']>;
    canEdit?: Maybe<Scalars['Boolean']['output']>;
    /** Agency Community name for agency janes and Primary Community name for internal team members */
    communityName: Scalars['String']['output'];
    /** get all of the existing shifts that conflict with the given arguments */
    conflictingDays: Array<OrderSchedule>;
    createdAt: Scalars['ISO8601DateTime']['output'];
    customerReviews: CustomerReviews;
    displayId: Scalars['String']['output'];
    documents?: Maybe<Array<Document>>;
    /** Educational qualifications of the jane */
    educations?: Maybe<Array<Education>>;
    email: Scalars['String']['output'];
    /** Employee ID */
    employeeNumber?: Maybe<Scalars['String']['output']>;
    employeeStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
    employmentStatus: EmploymentStatus;
    /** Work experiences of the jane */
    experiences?: Maybe<Array<ExperienceSource>>;
    firstName: Scalars['String']['output'];
    gender: GenderEnum;
    hasPools: Scalars['Boolean']['output'];
    hourlyRate?: Maybe<Scalars['Float']['output']>;
    /** @deprecated use displayId instead */
    id: Scalars['ID']['output'];
    invitation?: Maybe<Invitation>;
    /** Date Time on which the invitation to create the account was accepted. */
    invitationAcceptedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
    isBlocked: Scalars['Boolean']['output'];
    isMobile: Scalars['Boolean']['output'];
    lastActivityAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
    lastName: Scalars['String']['output'];
    licenseNumber?: Maybe<Scalars['String']['output']>;
    locale: Scalars['String']['output'];
    /** Address of the jane */
    location?: Maybe<Location>;
    /** Jane Callout Rank */
    orderRank?: Maybe<Scalars['Int']['output']>;
    organizationSeniorityRanking?: Maybe<Scalars['Int']['output']>;
    /** This boolean field is used to show user is sign up or not */
    pendingSignup: Scalars['Boolean']['output'];
    phone?: Maybe<Scalars['String']['output']>;
    /** All the positions satisfied by the jane. Can be [] for jane whose profile is still incomplete. */
    positions: Array<Position>;
    primaryCommunity?: Maybe<Community>;
    /** Primary position of the jane. Can be null for jane whose profile is still incomplete. */
    primaryPosition?: Maybe<Position>;
    profileCompletion: JaneProfileCompletionStatus;
    rankingSeniorityDate?: Maybe<RankingSeniorityDate>;
    relayId: Scalars['ID']['output'];
    reviews?: Maybe<Array<Review>>;
    /** @deprecated user userCommunities field instead */
    secondaryCommunities: Array<Community>;
    /** only secondary positions for this Jane */
    secondaryPositions: Array<Position>;
    shorthandName: Scalars['String']['output'];
    /** fetch all static groups the team member belongs to */
    staticGroups: Array<StaticGroup>;
    /** Total Weekly hours of the jane with given order Id */
    totalWeeklyHours?: Maybe<WeeklyHours>;
    updatedAt: Scalars['ISO8601DateTime']['output'];
    usersCommunities: Array<UsersCommunity>;
  };

export type JaneConflictingDaysArgs = {
  recurring: RecurringOrderAttributes;
};

export type JanePositionsArgs = {
  filter?: InputMaybe<FilterableEmployeePositionAttributes>;
};

export type JaneSecondaryPositionsArgs = {
  filter?: InputMaybe<FilterableEmployeePositionAttributes>;
};

export type JaneStaticGroupsArgs = {
  filter: FilterableGroupAttributes;
};

export type JaneTotalWeeklyHoursArgs = {
  orderId: Scalars['Int']['input'];
};

/** The connection type for Jane. */
export type JaneConnection = {
  __typename?: 'JaneConnection';
  currentPage?: Maybe<Scalars['Int']['output']>;
  /** A list of edges. */
  edges: Array<JaneEdge>;
  /** A list of nodes. */
  nodes: Array<Jane>;
  pageCount: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type JaneEdge = {
  __typename?: 'JaneEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Jane>;
};

export type JaneProfileCompletionStatus = {
  __typename?: 'JaneProfileCompletionStatus';
  accessLevel: AccessStatusEnum;
  isComplete: Scalars['Boolean']['output'];
};

export enum JaneSortableFieldsEnum {
  accessStatus = 'accessStatus',
  agencyCommunityName = 'agencyCommunityName',
  agencyName = 'agencyName',
  createdAt = 'createdAt',
  employmentStatus = 'employmentStatus',
  firstName = 'firstName',
  id = 'id',
  lastName = 'lastName',
  positionName = 'positionName',
}

export enum JaneTypeEnum {
  external_agency_staff = 'external_agency_staff',
  external_shared_staff = 'external_shared_staff',
  flex = 'flex',
  internal_casual = 'internal_casual',
  internal_full_time = 'internal_full_time',
  internal_part_time = 'internal_part_time',
}

export type LastCallJane = HasTimestamps &
  Node & {
    __typename?: 'LastCallJane';
    calloutList?: Maybe<CalloutList>;
    createdAt: Scalars['ISO8601DateTime']['output'];
    displayId: Scalars['Int']['output'];
    id: Scalars['ID']['output'];
    jane: Jane;
    updatedAt: Scalars['ISO8601DateTime']['output'];
  };

export type LeadTime = HasTimestamps & {
  __typename?: 'LeadTime';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  priority: LeadTimePriorityEnum;
  priorityTime: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum LeadTimePriorityEnum {
  critical = 'critical',
  high_priority = 'high_priority',
  vacation_loa = 'vacation_loa',
}

/** settings for lead time */
export type LeadTimesAttributes = {
  id?: InputMaybe<Scalars['Int']['input']>;
  priorityTime?: InputMaybe<Scalars['Int']['input']>;
};

export type Liability = {
  __typename?: 'Liability';
  coverageAmount?: Maybe<Scalars['CurrencyValueScalar']['output']>;
  expiryDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  insuranceDocuments: Array<InsuranceDocument>;
  insuranceNumber?: Maybe<Scalars['String']['output']>;
  licenceNumber?: Maybe<Scalars['String']['output']>;
};

export type Location = {
  __typename?: 'Location';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  flat?: Maybe<Scalars['String']['output']>;
  fullAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

/** attributes to specify a single location point */
export type LocationAttributes = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

/** attributes that specify the bounding box for the location */
export type LocationBoundingBoxAttributes = {
  northEast: LocationAttributes;
  southWest: LocationAttributes;
};

export enum LocationDistributionEnum {
  all = 'all',
  primary = 'primary',
  secondary = 'secondary',
}

export type ManualApproval = HasTimestamps & {
  __typename?: 'ManualApproval';
  /** The date and time the callout was manually approved to continue, alias for `created_at` */
  approvedAt: Scalars['ISO8601DateTime']['output'];
  approvedBy: User;
  createdAt: Scalars['ISO8601DateTime']['output'];
  displayId: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ManualApprovalIndex = {
  __typename?: 'ManualApprovalIndex';
  groupName: Scalars['String']['output'];
  index: Scalars['Int']['output'];
};

/** Autogenerated input type of ManuallyApprove */
export type ManuallyApproveInput = {
  calloutListId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  enableOvertime?: InputMaybe<EnableOvertimeStrategyEnum>;
};

/** Autogenerated return type of ManuallyApprove */
export type ManuallyApprovePayload = {
  __typename?: 'ManuallyApprovePayload';
  calloutList: CalloutList;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  status: MutationOutcomeStatusEnum;
};

export type Metadata = {
  __typename?: 'Metadata';
  cancellationReasons: Array<CancelReasonMetadata>;
  customFieldTypes: Array<CustomFieldTypeMetadata>;
  dynamicGroupCriteriaEmploymentStatuses: Array<DynamicGroupCriteriaEmploymentStatusMetadata>;
  editReasons: Array<EditReasonMetadata>;
  employmentStatuses: Array<EmploymentStatusMetadata>;
  flaggedIssues: Array<TimesheetFlaggedIssueMetadata>;
  notificationMethods: Array<NotificationMethodMetadata>;
  orderEnumStatuses: Array<OrderEnumStatusMetadata>;
  positionWorkTeams: Array<PositionWorkTeamMetadata>;
  reacceptanceOrCancellationThresholdValues: Array<Scalars['Int']['output']>;
  releaseReasons: Array<ReleaseReasonMetadata>;
  timesheetStatuses: Array<TimesheetStatusMetadata>;
  userAccessStatuses: Array<UserAccessStatusMetadata>;
};

export type MetadataUserAccessStatusesArgs = {
  input?: InputMaybe<UserAccessStatusInputAttributes>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** manually approve the callout to continue callout escalation */
  approveCallout?: Maybe<ManuallyApprovePayload>;
  /** agency users assign orders to a given jane */
  assignOrder: AssignOrderPayload;
  /** delete a time off by id */
  deleteTimeOff?: Maybe<DeleteTimeOffPayload>;
  dummy?: Maybe<Scalars['String']['output']>;
  /** b2b_customer updates community features */
  updateCommunity?: Maybe<UpdateCommunityPayload>;
  /** b2b_customer updates organization */
  updateOrganization?: Maybe<UpdateOrganizationPayload>;
};

export type MutationApproveCalloutArgs = {
  input: ManuallyApproveInput;
};

export type MutationAssignOrderArgs = {
  input: AssignOrderInput;
};

export type MutationDeleteTimeOffArgs = {
  input: DeleteTimeOffInput;
};

export type MutationUpdateCommunityArgs = {
  input: UpdateCommunityInput;
};

export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};

export enum MutationOutcomeStatusEnum {
  accepted = 'accepted',
  created = 'created',
  forbidden = 'forbidden',
  notFound = 'notFound',
  ok = 'ok',
  unauthorized = 'unauthorized',
  unprocessableEntity = 'unprocessableEntity',
}

export type NeedsReview = {
  __typename?: 'NeedsReview';
  /** count all  flagged time sheets for current user */
  flaggedTimeSheets: Scalars['Int']['output'];
  /** count all new messages for the current user */
  newMessages: Scalars['Int']['output'];
  /** count all new threads for the current user */
  newThreads: Scalars['Int']['output'];
  /** count all pending team members for the current user */
  pendingSignups: Scalars['Int']['output'];
  /** count all unpublished shifts for the current user */
  unpublishedShifts: Scalars['Int']['output'];
};

/** An object with an ID. */
export type Node = {
  /** ID of the object. */
  id: Scalars['ID']['output'];
};

export type NotificationMethodMetadata = IdWithDisplayText & {
  __typename?: 'NotificationMethodMetadata';
  displayText: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export enum NullPlacementEnum {
  first = 'first',
  last = 'last',
}

export enum OpenShiftPolicyEnum {
  bidding_required = 'bidding_required',
  tiering_call_out = 'tiering_call_out',
}

/** orders */
export type Order = {
  __typename?: 'Order';
  acceptedBySharedTeamMember?: Maybe<Scalars['Boolean']['output']>;
  activities: Array<OrderActivity>;
  allowOvertime: Scalars['Boolean']['output'];
  auditTrailVersion: AuditTrailVersionEnum;
  autoRebid: Scalars['Boolean']['output'];
  awardingTimeStartsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  biddable: Scalars['Boolean']['output'];
  bidders: Array<Jane>;
  biddingTimeEndsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  calloutLists?: Maybe<Array<CalloutList>>;
  canAssign: Scalars['Boolean']['output'];
  canSendToAgency: Scalars['Boolean']['output'];
  community: Community;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentlyActiveCalloutList?: Maybe<CalloutList>;
  customFields: Array<CustomFieldValue>;
  customer: B2bCustomer;
  dedicated: Scalars['Boolean']['output'];
  dedicatedPool?: Maybe<Pool>;
  description?: Maybe<Scalars['String']['output']>;
  displayId: Scalars['Int']['output'];
  draftShift?: Maybe<DraftShift>;
  duration?: Maybe<TimeInterval>;
  durationWithoutBreak?: Maybe<TimeInterval>;
  endAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** total rate charged to the customer */
  estimatedTotalCharge?: Maybe<OrderRate>;
  fulfillmentStatus: OrderFulfillmentStatusEnum;
  futureShifts: Array<Order>;
  /** @deprecated use displayId instead */
  id: Scalars['Int']['output'];
  isAway?: Maybe<Scalars['Boolean']['output']>;
  isB2b: Scalars['Boolean']['output'];
  isDeletable: Scalars['Boolean']['output'];
  isEditable: Scalars['Boolean']['output'];
  isJaneReleaseAllowed: Scalars['Boolean']['output'];
  isRecurring: Scalars['Boolean']['output'];
  isReviewAllowed: Scalars['Boolean']['output'];
  location?: Maybe<Location>;
  mainJane?: Maybe<Jane>;
  noShow: Scalars['Boolean']['output'];
  orderAvailabilities: OrderAvailabilityConnection;
  orderSchedule: OrderSchedule;
  /** @deprecated an Order can only have 1 OrderSchedule, use Order.orderSchedule instead */
  orderSchedules: Array<OrderSchedule>;
  orderSchedulesCount: Scalars['Int']['output'];
  overrideRestriction: Scalars['Boolean']['output'];
  position: PositionDetails;
  priority: OrderPriorityEnum;
  /** hourly rate charged to the customer */
  rate?: Maybe<OrderRate>;
  reacceptOrDeclineThreshold?: Maybe<Scalars['Float']['output']>;
  recurrence?: Maybe<Recurrence>;
  relayId: Scalars['ID']['output'];
  resident?: Maybe<Scalars['String']['output']>;
  review?: Maybe<Review>;
  room?: Maybe<Room>;
  sentToAgencies: Scalars['Boolean']['output'];
  startAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  status: OrderStatus;
  swap: OrderSwapStatusEnum;
  /** @deprecated use duration instead */
  totalDuration?: Maybe<Scalars['Float']['output']>;
  /** @deprecated use durationWithoutBreak instead */
  totalDurationWithoutBreak?: Maybe<Scalars['Float']['output']>;
  totalPrice?: Maybe<Scalars['Float']['output']>;
  training: Scalars['Boolean']['output'];
};

/** orders */
export type OrderBiddersArgs = {
  filter?: InputMaybe<FilterableJaneAttributes>;
};

/** orders */
export type OrderOrderAvailabilitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderActivity = {
  __typename?: 'OrderActivity';
  community?: Maybe<Community>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  event: Event;
  flag?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<ActivitiesMetaValue>;
  order: Order;
  user?: Maybe<ActivityUserUnion>;
};

export type OrderAvailability = {
  __typename?: 'OrderAvailability';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  ignore: Scalars['Boolean']['output'];
  jane: Jane;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for OrderAvailability. */
export type OrderAvailabilityConnection = {
  __typename?: 'OrderAvailabilityConnection';
  currentPage?: Maybe<Scalars['Int']['output']>;
  /** A list of edges. */
  edges: Array<OrderAvailabilityEdge>;
  /** A list of nodes. */
  nodes: Array<OrderAvailability>;
  pageCount: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrderAvailabilityEdge = {
  __typename?: 'OrderAvailabilityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OrderAvailability>;
};

/** The connection type for Order. */
export type OrderConnection = {
  __typename?: 'OrderConnection';
  currentPage?: Maybe<Scalars['Int']['output']>;
  /** A list of edges. */
  edges: Array<OrderEdge>;
  estimatedTotalHours?: Maybe<TimeInterval>;
  /** A list of nodes. */
  nodes: Array<Order>;
  pageCount: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrderEdge = {
  __typename?: 'OrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Order>;
};

export type OrderEnumStatusMetadata = IdWithDisplayText & {
  __typename?: 'OrderEnumStatusMetadata';
  displayText: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export enum OrderFulfillmentStatusEnum {
  amica = 'amica',
  bookjane = 'bookjane',
}

/** order jane */
export type OrderJane = {
  __typename?: 'OrderJane';
  assignedBy?: Maybe<User>;
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  jane: Jane;
  main: Scalars['Boolean']['output'];
  order: Order;
  status: OrderJaneStatusEnum;
  updatedAt: Scalars['String']['output'];
};

export enum OrderJaneStatusEnum {
  accepted = 'accepted',
  assigned = 'assigned',
  cancelled = 'cancelled',
  pending = 'pending',
  pending_reapply = 'pending_reapply',
  rejected = 'rejected',
}

export type OrderLocationAggregateGroup = {
  __typename?: 'OrderLocationAggregateGroup';
  communityId: Scalars['Int']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type OrderLocationAggregateResult = {
  __typename?: 'OrderLocationAggregateResult';
  count: Scalars['Int']['output'];
  /** Group containing a facility with its co-ordinates */
  group: OrderLocationAggregateGroup;
};

export enum OrderPriorityEnum {
  critical = 'critical',
  critical_overnight = 'critical_overnight',
  high_priority = 'high_priority',
  shift_exchange = 'shift_exchange',
  urgent = 'urgent',
  vacation_loa = 'vacation_loa',
}

export type OrderRate = {
  __typename?: 'OrderRate';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  rateLabel: Scalars['OrderHourlyRateScalar']['output'];
};

/** order schedules */
export type OrderSchedule = {
  __typename?: 'OrderSchedule';
  acceptedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  actualEnd?: Maybe<Scalars['ISO8601DateTime']['output']>;
  actualStart?: Maybe<Scalars['ISO8601DateTime']['output']>;
  breakTime: Scalars['String']['output'];
  cancelledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  dispatchTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  endTime: Scalars['ISO8601DateTime']['output'];
  fifteenMinReminded: Scalars['Boolean']['output'];
  flexStartTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  hourReminded: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  invoiceNumber: Scalars['Int']['output'];
  isDispatched?: Maybe<Scalars['Boolean']['output']>;
  lastError?: Maybe<Scalars['String']['output']>;
  mainJane?: Maybe<Jane>;
  mainOrderJane?: Maybe<OrderJane>;
  mileage: Scalars['Float']['output'];
  order: Order;
  orderJanes?: Maybe<Array<OrderJane>>;
  originalStartTime: Scalars['ISO8601DateTime']['output'];
  paymentStatus?: Maybe<Scalars['Int']['output']>;
  payrollCycle: Scalars['ISO8601DateTime']['output'];
  pushToPayrollProvider?: Maybe<Scalars['Boolean']['output']>;
  startTime: Scalars['ISO8601DateTime']['output'];
  status: OrderScheduleStatusEnum;
  stripeChargeId?: Maybe<Scalars['String']['output']>;
  timeSheet?: Maybe<TimeSheet>;
  /** @deprecated this field will be removed in the future and is no longer valid */
  totalPayout: Scalars['Float']['output'];
  totalPrice: Scalars['Float']['output'];
  totalTime?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for OrderSchedule. */
export type OrderScheduleConnection = {
  __typename?: 'OrderScheduleConnection';
  currentPage?: Maybe<Scalars['Int']['output']>;
  /** A list of edges. */
  edges: Array<OrderScheduleEdge>;
  /** A list of nodes. */
  nodes: Array<OrderSchedule>;
  pageCount: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrderScheduleEdge = {
  __typename?: 'OrderScheduleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OrderSchedule>;
};

export enum OrderScheduleStatusEnum {
  accepted = 'accepted',
  assigned = 'assigned',
  cancelled = 'cancelled',
  pending = 'pending',
}

export enum OrderSortableFieldsEnum {
  createdAt = 'createdAt',
  endAt = 'endAt',
  facilityCity = 'facilityCity',
  facilityName = 'facilityName',
  id = 'id',
  janeFirstName = 'janeFirstName',
  janeLastName = 'janeLastName',
  janeName = 'janeName',
  maxRate = 'maxRate',
  minRate = 'minRate',
  positionName = 'positionName',
  startAt = 'startAt',
  totalDuration = 'totalDuration',
  unpaidBreakTime = 'unpaidBreakTime',
}

export type OrderStatus = {
  __typename?: 'OrderStatus';
  name: Scalars['OrderStatusScalar']['output'];
  value: OrderStatusEnum;
};

export enum OrderStatusEnum {
  absent = 'absent',
  accepted = 'accepted',
  assigned = 'assigned',
  cancelled = 'cancelled',
  completed = 'completed',
  in_progress = 'in_progress',
  pending = 'pending',
  rejected = 'rejected',
  requested = 'requested',
  swapped = 'swapped',
  unfulfilled = 'unfulfilled',
}

export enum OrderSwapStatusEnum {
  cancelled = 'cancelled',
  completed = 'completed',
  disabled = 'disabled',
  requested = 'requested',
}

export type OrderWithStaffAttributes = {
  facility: FacilityAttributes;
  types: Array<WithStaffEnum>;
};

export type OrdersWithJanesMetadata = {
  __typename?: 'OrdersWithJanesMetadata';
  aggregateJanesByTypes: AggregateJanesByTypes;
  orders: OrderConnection;
};

export type OrdersWithJanesMetadataOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type Organization = HasTimestamps &
  Node & {
    __typename?: 'Organization';
    createdAt: Scalars['ISO8601DateTime']['output'];
    customFields: Array<CustomField>;
    id: Scalars['Int']['output'];
    lastEditedBy?: Maybe<EnterpriseUserUnion>;
    name: Scalars['String']['output'];
    relayId: Scalars['ID']['output'];
    seniorityMethod: SeniorityMethodEnum;
    updatedAt: Scalars['ISO8601DateTime']['output'];
  };

/** attributes that can be changed on the organization */
export type OrganizationAttributes = {
  seniorityMethod?: InputMaybe<SeniorityMethodEnum>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Penalty = {
  __typename?: 'Penalty';
  amount: Scalars['CurrencyValueScalar']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  dedicated: Scalars['Boolean']['output'];
  facility: Scalars['String']['output'];
  formattedCancelledBy: Scalars['FormattedCancelledByScalar']['output'];
  formattedDateRange: Scalars['String']['output'];
  formattedPenaltyText: Scalars['FormattedPenaltyTextScalar']['output'];
  id: Scalars['Int']['output'];
  penaltyType: Scalars['String']['output'];
  position: Scalars['String']['output'];
  shiftEndTime: Scalars['ISO8601DateTime']['output'];
  shiftId: Scalars['Int']['output'];
  shiftStartTime: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for Penalty. */
export type PenaltyConnection = {
  __typename?: 'PenaltyConnection';
  currentPage?: Maybe<Scalars['Int']['output']>;
  /** A list of edges. */
  edges: Array<PenaltyEdge>;
  /** A list of nodes. */
  nodes: Array<Penalty>;
  pageCount: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PenaltyEdge = {
  __typename?: 'PenaltyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Penalty>;
};

export type Pool = {
  __typename?: 'Pool';
  estimatedHourlyRate?: Maybe<PriceRange>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  totalJanes: Scalars['Int']['output'];
};

export type Position = {
  __typename?: 'Position';
  agencyDetails?: Maybe<AgencyPositionDetails>;
  details: PositionDetails;
  id: Scalars['Int']['output'];
  inRotationalPool: InRotationalPoolEnum;
  type: PositionTypeEnum;
};

export type PositionDetails = {
  __typename?: 'PositionDetails';
  /** the rate charged to the customer for an open shift */
  clientCost: Scalars['CurrencyValueScalar']['output'];
  code?: Maybe<Scalars['String']['output']>;
  community?: Maybe<Community>;
  configuredShifts: OrderConnection;
  createdAt: Scalars['ISO8601DateTime']['output'];
  delta?: Maybe<Scalars['Float']['output']>;
  department?: Maybe<Department>;
  hasPools: Scalars['Boolean']['output'];
  hasResident: Scalars['Boolean']['output'];
  hasRoom: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  importance?: Maybe<Scalars['Int']['output']>;
  /** the amount a jane is paid for an open shift */
  janePayout: Scalars['CurrencyValueScalar']['output'];
  marketRate?: Maybe<Scalars['Float']['output']>;
  maximumPrice?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  openPriceRange?: Maybe<PriceRange>;
  openShiftPolicy: OpenShiftPolicyEnum;
  pools: Array<Pool>;
  prettyOpenShiftPolicy: Scalars['String']['output'];
  prettyWorkTeam: Scalars['String']['output'];
  responsibilities?: Maybe<Scalars['String']['output']>;
  serviceableCommunities: Array<Community>;
  status: PositionStatusEnum;
  teamMembers: JaneConnection;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
  workTeam: WorkTeamEnum;
};

export type PositionDetailsConfiguredShiftsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterableOrderAttributes>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortableOrderAttributes>>;
};

export type PositionDetailsHasPoolsArgs = {
  communityId?: InputMaybe<Scalars['Int']['input']>;
};

export type PositionDetailsTeamMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterableJaneAttributes>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortableJanesAttributes>>;
  type?: InputMaybe<PositionTypeEnum>;
};

/** The connection type for PositionDetails. */
export type PositionDetailsConnection = {
  __typename?: 'PositionDetailsConnection';
  currentPage?: Maybe<Scalars['Int']['output']>;
  /** A list of edges. */
  edges: Array<PositionDetailsEdge>;
  /** A list of nodes. */
  nodes: Array<PositionDetails>;
  pageCount: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PositionDetailsEdge = {
  __typename?: 'PositionDetailsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PositionDetails>;
};

export enum PositionStatusEnum {
  active = 'active',
  inactive = 'inactive',
}

export enum PositionTypeEnum {
  additional = 'additional',
  primary = 'primary',
}

export type PositionWorkTeamMetadata = IdWithDisplayText & {
  __typename?: 'PositionWorkTeamMetadata';
  displayText: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type PriceRange = {
  __typename?: 'PriceRange';
  max?: Maybe<Scalars['CurrencyValueScalar']['output']>;
  min?: Maybe<Scalars['CurrencyValueScalar']['output']>;
  rangeLabel?: Maybe<Scalars['String']['output']>;
  rawMax?: Maybe<Scalars['Float']['output']>;
  rawMin?: Maybe<Scalars['Float']['output']>;
};

export enum PushReceivingChannelEnum {
  apn = 'apn',
  email = 'email',
  gcm = 'gcm',
  pusher = 'pusher',
  twilio = 'twilio',
}

export type Query = {
  __typename?: 'Query';
  aggregateOrdersByLocation: Array<OrderLocationAggregateResult>;
  dashboardWeeklyOverview: DashboardWeeklyOverview;
  fastGroupOrders: GroupedOrdersConnection;
  fetchAgencies: AgencyConnection;
  fetchAgency: Agency;
  /** returns all agency communities for the current user */
  fetchAgencyCommunities: AgencyCommunityConnection;
  /** returns all communities for the current user */
  fetchCommunities: CommunityConnection;
  /** find a Community by ID */
  fetchCommunity: Community;
  /** find a custom_field by id */
  fetchCustomField: CustomField;
  /** returns all custom fields for users organization */
  fetchCustomFields: CustomFieldConnection;
  /** find a single jane */
  fetchJane: Jane;
  /** find all janes */
  fetchJanes: JaneConnection;
  fetchMetadata: Metadata;
  /** Find an order by ID */
  fetchOrder: Order;
  /** find all orders for the current user */
  fetchOrders: OrderConnection;
  fetchOrdersWithJanesMetadata: OrdersWithJanesMetadata;
  /** find all penalties */
  fetchPenalties: PenaltyConnection;
  fetchPosition: PositionDetails;
  fetchPositions: PositionDetailsConnection;
  fetchShiftDistributionRules: ShiftDistributionRuleConnection;
  /** fetch a single time off by id */
  fetchTimeOff: TimeOff;
  /** fetch multiple time offs */
  fetchTimeOffs: TimeOffConnection;
  /** find a timesheet by order schedule id */
  fetchTimeSheet: OrderSchedule;
  fetchTimeSheets: OrderScheduleConnection;
  groupCountOrders: Array<GroupCountedOrders>;
  /** @deprecated this endpoint is slow and innefficient, user fastGroupOrders instead */
  groupOrders: GroupedOrdersConnection;
  groupPositions: GroupedPositionsConnection;
  /** returns the currently authenticated user */
  me: CurrentUserUnion;
  needsReview: NeedsReview;
  /** Fetches an object given its ID. */
  node?: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  requestJanes: JaneConnection;
};

export type QueryAggregateOrdersByLocationArgs = {
  bounds?: InputMaybe<LocationBoundingBoxAttributes>;
  filter: FilterableOrderAttributes;
};

export type QueryDashboardWeeklyOverviewArgs = {
  communityId: Scalars['Int']['input'];
};

export type QueryFastGroupOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterableOrderAttributes>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupBy: GroupableOrderAttributes;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortOrders?: InputMaybe<Array<SortableOrderAttributes>>;
};

export type QueryFetchAgenciesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterableAgencyAttributes>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  relevantForOrder?: InputMaybe<RelevantForOrderAttributes>;
  sort?: InputMaybe<Array<SortableAgenciesAttributes>>;
};

export type QueryFetchAgencyArgs = {
  id: Scalars['ID']['input'];
};

export type QueryFetchAgencyCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  availableJaneFilters?: InputMaybe<AvailableJanesAttributes>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterableAgencyCommunityAttributes>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortableAgencyCommunityAttributes>>;
};

export type QueryFetchCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterableCommunitiesAttributes>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeSharedCommunities?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortableCommunityAttributes>>;
};

export type QueryFetchCommunityArgs = {
  id: Scalars['Int']['input'];
};

export type QueryFetchCustomFieldArgs = {
  id: Scalars['Int']['input'];
};

export type QueryFetchCustomFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterableCustomFieldAttributes>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryFetchJaneArgs = {
  id: Scalars['ID']['input'];
};

export type QueryFetchJanesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  external?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<FilterableJaneAttributes>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortableJanesAttributes>>;
};

export type QueryFetchOrderArgs = {
  id: Scalars['Int']['input'];
};

export type QueryFetchOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterableOrderAttributes>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortableOrderAttributes>>;
};

export type QueryFetchOrdersWithJanesMetadataArgs = {
  communityId: Scalars['Int']['input'];
  filter?: InputMaybe<FilterableOrderAttributes>;
  sort?: InputMaybe<Array<SortableOrderAttributes>>;
};

export type QueryFetchPenaltiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communityId: Scalars['Int']['input'];
  endDate: Scalars['ISO8601DateTime']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['ISO8601DateTime']['input'];
};

export type QueryFetchPositionArgs = {
  id: Scalars['ID']['input'];
};

export type QueryFetchPositionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterablePositionAttributes>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryFetchShiftDistributionRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterableShiftDistributionRuleAttributes>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryFetchTimeOffArgs = {
  timeOffId: Scalars['ID']['input'];
};

export type QueryFetchTimeOffsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterableTimeOffAttributes>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort: Array<SortableTimeOffAttributes>;
};

export type QueryFetchTimeSheetArgs = {
  id: Scalars['Int']['input'];
};

export type QueryFetchTimeSheetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterableTimeSheetAttributes>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SortableTimeSheetAttributes>>;
};

export type QueryGroupCountOrdersArgs = {
  filter?: InputMaybe<FilterableOrderAttributes>;
  groupBy: Array<GroupCountableOrderAttributes>;
};

export type QueryGroupOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterableOrderAttributes>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupBy: GroupableOrderAttributes;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortOrders?: InputMaybe<Array<SortableOrderAttributes>>;
};

export type QueryGroupPositionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterablePositionAttributes>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupBy: GroupablePositionAttributes;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortAllocatedPositionsByCommunity?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryNeedsReviewArgs = {
  communityId: Scalars['Int']['input'];
};

export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};

export type QueryNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type QueryRequestJanesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  external?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<FilterableJaneAttributes>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  relevantForOrder: RelevantForOrderAttributes;
  sort?: InputMaybe<Array<SortableJanesAttributes>>;
};

export type RankingSeniorityDate = {
  __typename?: 'RankingSeniorityDate';
  seniorityDays: Scalars['Int']['output'];
  seniorityHours: Scalars['Int']['output'];
  seniorityMonths: Scalars['Int']['output'];
  seniorityYears: Scalars['Int']['output'];
};

export type Recurrence = {
  __typename?: 'Recurrence';
  day?: Maybe<Scalars['Int']['output']>;
  expirationDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  frequency?: Maybe<RecurringFrequencyEnum>;
  id: Scalars['Int']['output'];
  interval?: Maybe<Scalars['Int']['output']>;
  mainJane?: Maybe<Jane>;
  recurrenceLabel?: Maybe<Scalars['String']['output']>;
  status: RecurringStatusEnum;
  weekdays?: Maybe<Array<WeekdaysEnum>>;
};

export enum RecurringFrequencyEnum {
  /** shifts recur daily */
  day = 'day',
  /** shifts recur monthly, on the specified day */
  month = 'month',
  /** shifts recur weekly, on selected days */
  week = 'week',
}

export type RecurringOrderAttributes = {
  /** the end time of the shift */
  endTime: Scalars['ISO8601DateTime']['input'];
  /** when the recurrence stops, either a date or null is "Never" */
  expirationDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** the frequency of the recurring shift */
  frequency: RecurringFrequencyEnum;
  /** the length of time between recurring shifts, used as a multiplier with frequency */
  interval: Scalars['Int']['input'];
  /** the start time of the shift */
  startTime: Scalars['ISO8601DateTime']['input'];
};

export enum RecurringStatusEnum {
  active = 'active',
  inactive = 'inactive',
}

export type Reflected = {
  __typename?: 'Reflected';
  fieldName: Scalars['String']['output'];
  fieldType: Scalars['String']['output'];
  fieldValue: Scalars['AnyTypeScalar']['output'];
};

export type ReleaseReasonMetadata = IdWithDisplayText & {
  __typename?: 'ReleaseReasonMetadata';
  displayText: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

/** Attributes while requesting janes for orders which exist or do not exist. */
export type RelevantForOrderAttributes = {
  /** Whether overtime needs to be considered */
  allowOvertime?: InputMaybe<Scalars['Boolean']['input']>;
  /** End time when janes need to be requested for an order which is not yet created */
  byEndTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Community id when janes need to be requested for an order which is not yet created */
  byFacilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Position id when janes need to be requested for an order which is not yet created */
  byPositionId?: InputMaybe<Scalars['Int']['input']>;
  /** Start time when janes need to be requested for an order which is not yet created */
  byStartTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Whether the janes need to be requested for a dedicated pool for an order which is not yet created */
  isDedicated?: InputMaybe<Scalars['Boolean']['input']>;
  /** relay id of the existing order, i.e. when requesting janes for an order which already exists, pass order id here. */
  orderId?: InputMaybe<Scalars['ID']['input']>;
  /** the length of the break on the requested shift */
  withBreakTime?: InputMaybe<Scalars['String']['input']>;
};

export type Review = {
  __typename?: 'Review';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  jane: Jane;
  order?: Maybe<Order>;
  rating?: Maybe<Scalars['Int']['output']>;
  reviewer: B2bCustomer;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Room = {
  __typename?: 'Room';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type SchedulingSettings = HasTimestamps & {
  __typename?: 'SchedulingSettings';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  maxHoursDay: Scalars['Float']['output'];
  maxHoursWeek: Scalars['Float']['output'];
  minHoursBetweenShifts: Scalars['Float']['output'];
  minHoursIncludeCallout: Scalars['Boolean']['output'];
  overtimePeriodInWeeks: Scalars['Int']['output'];
  overtimePeriodInitialStartAt?: Maybe<Scalars['ISO8601Date']['output']>;
  position?: Maybe<PositionDetails>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type SecondaryUser = HasFirstLastName &
  HasTimestamps & {
    __typename?: 'SecondaryUser';
    accessLevelId: Scalars['Int']['output'];
    accessStatus: AccessStatus;
    adpCustomIdentifier?: Maybe<Scalars['String']['output']>;
    agencyCustomer: Scalars['Boolean']['output'];
    availabilityStatus: Scalars['String']['output'];
    avatarUrls: AvatarUrl;
    communities: Array<Community>;
    completedOnboardingSteps: Scalars['Int']['output'];
    createdAt: Scalars['ISO8601DateTime']['output'];
    email: Scalars['String']['output'];
    firstName: Scalars['String']['output'];
    hasPools: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    industry?: Maybe<Scalars['String']['output']>;
    invitedBy?: Maybe<B2bCustomer>;
    lastName: Scalars['String']['output'];
    locale: Scalars['String']['output'];
    payrollManagement: Scalars['Boolean']['output'];
    phone?: Maybe<Scalars['String']['output']>;
    serviceablePositions: Array<PositionDetails>;
    tieringStatus: Scalars['String']['output'];
    type: Scalars['String']['output'];
    unreadConversations?: Maybe<Scalars['Int']['output']>;
    updatedAt: Scalars['ISO8601DateTime']['output'];
    userRole: Scalars['String']['output'];
    userType: Scalars['String']['output'];
  };

export enum SeniorityMethodEnum {
  hours = 'hours',
  years_months_days = 'years_months_days',
}

export type ShiftCancellationWorkerMetadata = {
  __typename?: 'ShiftCancellationWorkerMetadata';
  errorMessages?: Maybe<Array<Scalars['String']['output']>>;
  status?: Maybe<ShiftCancellationWorkerStatusEnum>;
};

export enum ShiftCancellationWorkerStatusEnum {
  completed = 'completed',
  failed = 'failed',
  in_progress = 'in_progress',
}

/** shift distribution rules */
export type ShiftDistributionRule = HasTimestamps &
  Node & {
    __typename?: 'ShiftDistributionRule';
    community: Community;
    createdAt: Scalars['ISO8601DateTime']['output'];
    /** id for http api calls */
    displayId: Scalars['Int']['output'];
    groupRules: Array<GroupRule>;
    id: Scalars['ID']['output'];
    position?: Maybe<PositionDetails>;
    skipWaitTimeThresholdMinutes: Scalars['Int']['output'];
    updatedAt: Scalars['ISO8601DateTime']['output'];
  };

/** The connection type for ShiftDistributionRule. */
export type ShiftDistributionRuleConnection = {
  __typename?: 'ShiftDistributionRuleConnection';
  currentPage?: Maybe<Scalars['Int']['output']>;
  /** A list of edges. */
  edges: Array<ShiftDistributionRuleEdge>;
  /** A list of nodes. */
  nodes: Array<ShiftDistributionRule>;
  pageCount: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ShiftDistributionRuleEdge = {
  __typename?: 'ShiftDistributionRuleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ShiftDistributionRule>;
};

export enum ShiftParticipationEnum {
  all = 'all',
  callout = 'callout',
  scheduling = 'scheduling',
}

export enum ShiftStatusForTimeSheetsEnum {
  completed = 'completed',
  lateCancellation = 'lateCancellation',
}

export enum SortDirectionEnum {
  asc = 'asc',
  desc = 'desc',
}

export type SortableAgenciesAttributes = {
  direction?: InputMaybe<SortDirectionEnum>;
  field: AgencySortableFieldsEnum;
  nulls?: InputMaybe<NullPlacementEnum>;
};

export type SortableAgencyCommunityAttributes = {
  direction?: InputMaybe<SortDirectionEnum>;
  field: AgencyCommunitySortableFieldsEnum;
};

export type SortableCommunityAttributes = {
  direction?: InputMaybe<SortDirectionEnum>;
  field: CommunitySortableFieldsEnum;
  nulls?: InputMaybe<NullPlacementEnum>;
};

export type SortableJanesAttributes = {
  direction?: InputMaybe<SortDirectionEnum>;
  field: JaneSortableFieldsEnum;
};

export type SortableOrderAttributes = {
  direction?: InputMaybe<SortDirectionEnum>;
  field: OrderSortableFieldsEnum;
  nulls?: InputMaybe<NullPlacementEnum>;
};

export type SortableTimeOffAttributes = {
  direction?: InputMaybe<SortDirectionEnum>;
  field: TimeOffSortableFieldsEnum;
};

export type SortableTimeSheetAttributes = {
  direction?: InputMaybe<SortDirectionEnum>;
  field: TimeSheetSortableFieldsEnum;
  nulls?: InputMaybe<NullPlacementEnum>;
};

export type StaticGroup = AbstractGroup &
  HasTimestamps &
  Node & {
    __typename?: 'StaticGroup';
    createdAt: Scalars['ISO8601DateTime']['output'];
    displayId: Scalars['Int']['output'];
    groupJanes: GroupJaneConnection;
    id: Scalars['ID']['output'];
    /** janes that belong to a given group, if you are querying this field through a ShiftDistributionRule (ie. shiftDistributionRule.groups.groupJanes) it will only include janes that match the position for that shift distribution rule. If the ShiftDistribution rule is a default rule, (ie. no position) then it will return all janes in the group. If you are not querying this field through a ShiftDistributionRule, it will also include all janes without position filtering. */
    janes: JaneConnection;
    name: Scalars['String']['output'];
    updatedAt: Scalars['ISO8601DateTime']['output'];
  };

export type StaticGroupGroupJanesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StaticGroupJanesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TimeFrame = Node & {
  __typename?: 'TimeFrame';
  eveningStartsAt: Scalars['String']['output'];
  /** ID of the object. */
  id: Scalars['ID']['output'];
  morningStartsAt: Scalars['String']['output'];
  nightStartsAt: Scalars['String']['output'];
};

export enum TimeFrameEnum {
  evening = 'evening',
  morning = 'morning',
  night = 'night',
}

export type TimeInterval = {
  __typename?: 'TimeInterval';
  rawTime?: Maybe<Scalars['Float']['output']>;
  rawTimeInSeconds?: Maybe<Scalars['Int']['output']>;
  time?: Maybe<Scalars['HoursIntervalScalar']['output']>;
};

export type TimeOff = HasTimestamps &
  Node & {
    __typename?: 'TimeOff';
    activities: Array<TimeOffActivity>;
    community: Community;
    createdAt: Scalars['ISO8601DateTime']['output'];
    customFields: Array<CustomFieldValue>;
    displayId: Scalars['Int']['output'];
    endTime: Scalars['ISO8601DateTime']['output'];
    id: Scalars['ID']['output'];
    isEditable: Scalars['Boolean']['output'];
    jane: Jane;
    notes: Scalars['String']['output'];
    startTime: Scalars['ISO8601DateTime']['output'];
    title: TimeOffTitle;
    updatedAt: Scalars['ISO8601DateTime']['output'];
  };

export type TimeOffActivity = {
  __typename?: 'TimeOffActivity';
  createdAt: Scalars['ISO8601DateTime']['output'];
  event: Event;
  metadata?: Maybe<ActivitiesMetaValue>;
  user?: Maybe<ActivityUserUnion>;
};

/** The connection type for TimeOff. */
export type TimeOffConnection = {
  __typename?: 'TimeOffConnection';
  currentPage?: Maybe<Scalars['Int']['output']>;
  /** A list of edges. */
  edges: Array<TimeOffEdge>;
  /** A list of nodes. */
  nodes: Array<TimeOff>;
  pageCount: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TimeOffEdge = {
  __typename?: 'TimeOffEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TimeOff>;
};

export enum TimeOffSortableFieldsEnum {
  startTime = 'startTime',
}

export type TimeOffTitle = {
  __typename?: 'TimeOffTitle';
  name: TimeOffTitleEnum;
  value: Scalars['TimeOffTitleScalar']['output'];
};

export enum TimeOffTitleEnum {
  float = 'float',
  personal = 'personal',
  sick = 'sick',
  stat = 'stat',
  time_off = 'time_off',
  vacation = 'vacation',
}

export type TimeSheet = {
  __typename?: 'TimeSheet';
  acceptedHourlyRate?: Maybe<Currency>;
  approvedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  approvedBy?: Maybe<Scalars['String']['output']>;
  approvedCustomerCost?: Maybe<Currency>;
  approvedEndTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  approvedStartTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  approvedTotalTime?: Maybe<TimeInterval>;
  approvedUnpaidBreakTime?: Maybe<Scalars['String']['output']>;
  autoApproved: Scalars['Boolean']['output'];
  clockIn?: Maybe<Scalars['ISO8601DateTime']['output']>;
  clockInDistance?: Maybe<Scalars['Float']['output']>;
  clockInOffSite: Scalars['Boolean']['output'];
  clockInStatus?: Maybe<ClockInStatus>;
  clockOut?: Maybe<Scalars['ISO8601DateTime']['output']>;
  clockOutDistance?: Maybe<Scalars['Float']['output']>;
  clockOutOffSite: Scalars['Boolean']['output'];
  clockOutStatus?: Maybe<ClockOutStatus>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  isEdited: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  serviceFee?: Maybe<Scalars['Float']['output']>;
  status: TimeSheetStatus;
  totalTime?: Maybe<TimeInterval>;
  unpaidBreakTime: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum TimeSheetFlaggedIssueEnum {
  late = 'late',
  not_clocked_in = 'not_clocked_in',
  offsite = 'offsite',
}

export enum TimeSheetSortableFieldsEnum {
  customerCost = 'customerCost',
  endTime = 'endTime',
  id = 'id',
  price = 'price',
  startTime = 'startTime',
  status = 'status',
  totalPayout = 'totalPayout',
  totalPrice = 'totalPrice',
}

export type TimeSheetStatus = {
  __typename?: 'TimeSheetStatus';
  name: Scalars['TimeSheetStatusScalar']['output'];
  value: TimeSheetStatusEnum;
};

export enum TimeSheetStatusEnum {
  approved = 'approved',
  no_show = 'no_show',
  pending = 'pending',
}

export type TimesheetFlaggedIssueMetadata = IdWithDisplayText & {
  __typename?: 'TimesheetFlaggedIssueMetadata';
  displayText: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type TimesheetStatusMetadata = IdWithDisplayText & {
  __typename?: 'TimesheetStatusMetadata';
  displayText: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

/** Autogenerated input type of UpdateCommunity */
export type UpdateCommunityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  communityAttributes: CommunityAttributes;
  communityId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateCommunity */
export type UpdateCommunityPayload = {
  __typename?: 'UpdateCommunityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  community: Community;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  status: MutationOutcomeStatusEnum;
};

/** Autogenerated input type of UpdateOrganization */
export type UpdateOrganizationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationAttributes: OrganizationAttributes;
  organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateOrganization */
export type UpdateOrganizationPayload = {
  __typename?: 'UpdateOrganizationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  organization: Organization;
  status: MutationOutcomeStatusEnum;
};

export type User = HasFirstLastName &
  HasTimestamps & {
    __typename?: 'User';
    acceptedPrivacyPolicy: Scalars['Boolean']['output'];
    acceptedTos: Scalars['Boolean']['output'];
    accessLevel: UserAccessLevel;
    accountLevel: UserAccountLevel;
    adpCustomIdentifier?: Maybe<Scalars['String']['output']>;
    applicant: Scalars['Boolean']['output'];
    availabilityStatus: Scalars['Int']['output'];
    avatarUrls: AvatarUrl;
    bio: Scalars['String']['output'];
    /** Agency Community name for agency janes and Primary Community name for internal team members */
    communityName: Scalars['String']['output'];
    companyExperienceVal?: Maybe<Scalars['Int']['output']>;
    contactName?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['ISO8601DateTime']['output'];
    dateOfBirth?: Maybe<Scalars['ISO8601Date']['output']>;
    deletedAt: Scalars['ISO8601DateTime']['output'];
    displayId: Scalars['String']['output'];
    email: Scalars['String']['output'];
    employeeNumber?: Maybe<Scalars['String']['output']>;
    employmentStatus: Array<UserEmploymentStatusEnum>;
    experience?: Maybe<Scalars['Int']['output']>;
    failedAttempts: Scalars['Int']['output'];
    firstName: Scalars['String']['output'];
    gender?: Maybe<Scalars['Int']['output']>;
    /** @deprecated use displayId instead */
    id: Scalars['String']['output'];
    industry?: Maybe<Industry>;
    introductionVideo?: Maybe<Scalars['String']['output']>;
    invitation?: Maybe<Invitation>;
    isMobile: Scalars['Boolean']['output'];
    isTest: Scalars['Boolean']['output'];
    language: Scalars['Int']['output'];
    lastName: Scalars['String']['output'];
    lockedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    onboardingInitiated: Scalars['Boolean']['output'];
    payrollId?: Maybe<Scalars['String']['output']>;
    payrollManagement: Scalars['Boolean']['output'];
    phone?: Maybe<Scalars['String']['output']>;
    phoneExtension?: Maybe<Scalars['String']['output']>;
    previewIntroductionVideo: Scalars['String']['output'];
    primaryCommunity?: Maybe<Community>;
    probation: Scalars['Boolean']['output'];
    provider: Scalars['Int']['output'];
    providerId?: Maybe<Scalars['String']['output']>;
    pseudoJane: Scalars['Boolean']['output'];
    pushReceivingChannels: Array<PushReceivingChannelEnum>;
    rating?: Maybe<Scalars['Float']['output']>;
    recurringEnabled: Scalars['Boolean']['output'];
    relayId: Scalars['ID']['output'];
    seniorityDate: Scalars['ISO8601Date']['output'];
    tieringStatus: Scalars['Int']['output'];
    timeAndAttendanceIndicator: Scalars['Boolean']['output'];
    title: Scalars['String']['output'];
    updatedAt: Scalars['ISO8601DateTime']['output'];
    workingRadius?: Maybe<Scalars['Int']['output']>;
  };

export type UserAccessLevel = {
  __typename?: 'UserAccessLevel';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  users: Array<User>;
};

/** attributes that orders can be filtered by */
export type UserAccessStatusInputAttributes = {
  withFacilityIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UserAccessStatusMetadata = IdWithDisplayText & {
  __typename?: 'UserAccessStatusMetadata';
  count: Scalars['Int']['output'];
  displayText: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type UserAccountLevel = {
  __typename?: 'UserAccountLevel';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  users: Array<User>;
};

export enum UserEmploymentStatusEnum {
  casual = 'casual',
  flex = 'flex',
  full_time = 'full_time',
  not_sure = 'not_sure',
  part_time = 'part_time',
  terminated = 'terminated',
}

export type UsersCommunity = {
  __typename?: 'UsersCommunity';
  community: Community;
  displayId: Scalars['Int']['output'];
  shiftParticipation: ShiftParticipationEnum;
};

export enum WeekdaysEnum {
  dimanche = 'dimanche',
  friday = 'friday',
  jeudi = 'jeudi',
  lundi = 'lundi',
  mardi = 'mardi',
  mercredi = 'mercredi',
  monday = 'monday',
  samedi = 'samedi',
  saturday = 'saturday',
  sunday = 'sunday',
  thursday = 'thursday',
  tuesday = 'tuesday',
  vendredi = 'vendredi',
  wednesday = 'wednesday',
}

export type WeeklyHours = {
  __typename?: 'WeeklyHours';
  weeklyHours?: Maybe<Scalars['Float']['output']>;
};

export enum WithStaffEnum {
  agency_marketplace = 'agency_marketplace',
  internal = 'internal',
  shared = 'shared',
}

export enum WorkTeamEnum {
  child_care = 'child_care',
  custom = 'custom',
  general_position = 'general_position',
  medical = 'medical',
  nurse_practitioner = 'nurse_practitioner',
  physician = 'physician',
  psychology_therapy = 'psychology_therapy',
  registered_nurse = 'registered_nurse',
  registered_practical_nurse = 'registered_practical_nurse',
  senior_care = 'senior_care',
  us_childcare = 'us_childcare',
  us_healthcare = 'us_healthcare',
}

export type Wsib = HasTimestamps & {
  __typename?: 'Wsib';
  createdAt: Scalars['ISO8601DateTime']['output'];
  documents: Array<WsibDocument>;
  id: Scalars['Int']['output'];
  regulatoryId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type WsibDocument = HasTimestamps & {
  __typename?: 'WsibDocument';
  archive: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  originalFilename: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  urls: DocumentUrl;
};

export type Mutation_AssignAgencyTeamMemberAssignOrderMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  janeId: Scalars['ID']['input'];
}>;

export type Mutation_AssignAgencyTeamMemberAssignOrderMutation = {
  __typename?: 'Mutation';
  assignOrder: {
    __typename?: 'AssignOrderPayload';
    clientMutationId?: string | null;
    errors?: Array<string> | null;
    status: MutationOutcomeStatusEnum;
  };
};

export type Mutation_DeleteTimeOffByIdMutationVariables = Exact<{
  timeOffId: Scalars['ID']['input'];
}>;

export type Mutation_DeleteTimeOffByIdMutation = {
  __typename?: 'Mutation';
  deleteTimeOff?: {
    __typename?: 'DeleteTimeOffPayload';
    clientMutationId?: string | null;
    errors?: Array<string> | null;
    status: MutationOutcomeStatusEnum;
  } | null;
};

export type Mutation_ManuallyApproveCalloutMutationVariables = Exact<{
  calloutListId: Scalars['ID']['input'];
  enableOvertime?: InputMaybe<EnableOvertimeStrategyEnum>;
}>;

export type Mutation_ManuallyApproveCalloutMutation = {
  __typename?: 'Mutation';
  approveCallout?: {
    __typename?: 'ManuallyApprovePayload';
    clientMutationId?: string | null;
    errors?: Array<string> | null;
    status: MutationOutcomeStatusEnum;
  } | null;
};

export type Mutation_UpdateOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  seniorityMethod?: InputMaybe<SeniorityMethodEnum>;
}>;

export type Mutation_UpdateOrganizationMutation = {
  __typename?: 'Mutation';
  updateOrganization?: {
    __typename?: 'UpdateOrganizationPayload';
    errors?: Array<string> | null;
    status: MutationOutcomeStatusEnum;
    organization: {
      __typename?: 'Organization';
      id: number;
      seniorityMethod: SeniorityMethodEnum;
      createdAt: any;
      updatedAt: any;
    };
  } | null;
};

export type Query_AgencyFilterQueryVariables = Exact<{
  byName?: InputMaybe<Scalars['String']['input']>;
}>;

export type Query_AgencyFilterQuery = {
  __typename?: 'Query';
  fetchAgencies: {
    __typename?: 'AgencyConnection';
    nodes: Array<{ __typename?: 'Agency'; name: string; id: number }>;
  };
};

export type AgencyMemberPageQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  external?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<FilterableJaneAttributes>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortableJanesAttributes> | SortableJanesAttributes>;
}>;

export type AgencyMemberPageQuery = {
  __typename?: 'Query';
  fetchJanes: {
    __typename?: 'JaneConnection';
    pageCount: number;
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      startCursor?: string | null;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
    edges: Array<{
      __typename?: 'JaneEdge';
      node?: {
        __typename?: 'Jane';
        firstName: string;
        lastName: string;
        isMobile: boolean;
        pendingSignup: boolean;
        phone?: string | null;
        email: string;
        id: string;
        agencyCommunity?: { __typename?: 'AgencyCommunity'; name: string } | null;
        avatarUrls: { __typename?: 'AvatarUrl'; origin?: string | null };
        primaryPosition?: {
          __typename?: 'Position';
          details: { __typename?: 'PositionDetails'; name: string };
        } | null;
        positions: Array<{
          __typename?: 'Position';
          details: { __typename?: 'PositionDetails'; name: string };
        }>;
        employmentStatus: { __typename?: 'EmploymentStatus'; name: UserEmploymentStatusEnum };
        accessStatus: { __typename?: 'AccessStatus'; name: AccessStatusEnum };
      } | null;
    }>;
  };
};

export type AssignToAgencyTeamMemberFetchAgencyJaneAvailabilityByJaneIdOrderIdQueryVariables =
  Exact<{
    janeId: Scalars['ID']['input'];
    orderRelayId?: InputMaybe<Scalars['ID']['input']>;
    orderId: Scalars['Int']['input'];
    breakTime?: InputMaybe<Scalars['String']['input']>;
  }>;

export type AssignToAgencyTeamMemberFetchAgencyJaneAvailabilityByJaneIdOrderIdQuery = {
  __typename?: 'Query';
  fetchOrder: { __typename?: 'Order'; canAssign: boolean; id: number };
  requestJanes: {
    __typename?: 'JaneConnection';
    nodes: Array<{ __typename?: 'Jane'; id: string }>;
  };
};

export type AssignToAgencyTeamMemberFetchAgencyJaneByIdQueryVariables = Exact<{
  janeId: Scalars['ID']['input'];
}>;

export type AssignToAgencyTeamMemberFetchAgencyJaneByIdQuery = {
  __typename?: 'Query';
  fetchJane: {
    __typename?: 'Jane';
    relayId: string;
    firstName: string;
    lastName: string;
    isMobile: boolean;
    pendingSignup: boolean;
    avatarUrls: { __typename?: 'AvatarUrl'; origin?: string | null; small?: string | null };
    agencyCommunity?: {
      __typename?: 'AgencyCommunity';
      agency: { __typename?: 'Agency'; name: string };
    } | null;
  };
};

export type AssignToAgencyTeamMemberFetchAgencyJanesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  byMultipleFields?: InputMaybe<Scalars['String']['input']>;
  byPositionId?: InputMaybe<Scalars['Int']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  byAgencyCommunityId?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  breakTime?: InputMaybe<Scalars['String']['input']>;
}>;

export type AssignToAgencyTeamMemberFetchAgencyJanesQuery = {
  __typename?: 'Query';
  requestJanes: {
    __typename?: 'JaneConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      startCursor?: string | null;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
    nodes: Array<{
      __typename?: 'Jane';
      firstName: string;
      lastName: string;
      isMobile: boolean;
      pendingSignup: boolean;
      id: string;
      agencyCommunity?: {
        __typename?: 'AgencyCommunity';
        name: string;
        agency: { __typename?: 'Agency'; name: string };
      } | null;
      customerReviews: {
        __typename?: 'CustomerReviews';
        averageRating?: number | null;
        count: number;
      };
      avatarUrls: { __typename?: 'AvatarUrl'; origin?: string | null };
      positions: Array<{
        __typename?: 'Position';
        details: { __typename?: 'PositionDetails'; janePayout: any };
        agencyDetails?: { __typename?: 'AgencyPositionDetails'; openRate: any } | null;
      }>;
    }>;
  };
};

export type AssignToAgencyTeamMemberFetchAgencyJanesCountQueryVariables = Exact<{
  orderId?: InputMaybe<Scalars['ID']['input']>;
  byAgencyCommunityId?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  breakTime?: InputMaybe<Scalars['String']['input']>;
}>;

export type AssignToAgencyTeamMemberFetchAgencyJanesCountQuery = {
  __typename?: 'Query';
  requestJanes: { __typename?: 'JaneConnection'; totalCount: number };
};

export type AvailableShiftsMapViewQueryVariables = Exact<{
  filter: FilterableOrderAttributes;
}>;

export type AvailableShiftsMapViewQuery = {
  __typename?: 'Query';
  aggregateOrdersByLocation: Array<{
    __typename?: 'OrderLocationAggregateResult';
    count: number;
    group: {
      __typename?: 'OrderLocationAggregateGroup';
      communityId: number;
      latitude: number;
      longitude: number;
    };
  }>;
};

export type AvailableTeamMembersQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;

export type AvailableTeamMembersQuery = {
  __typename?: 'Query';
  fetchOrder: {
    __typename?: 'Order';
    community: {
      __typename?: 'Community';
      location?: { __typename?: 'Location'; timeZone?: string | null } | null;
    };
    orderAvailabilities: {
      __typename?: 'OrderAvailabilityConnection';
      pageInfo: {
        __typename?: 'PageInfo';
        endCursor?: string | null;
        startCursor?: string | null;
        hasPreviousPage: boolean;
        hasNextPage: boolean;
      };
      nodes: Array<{
        __typename?: 'OrderAvailability';
        id: string;
        createdAt: any;
        jane: {
          __typename?: 'Jane';
          shorthandName: string;
          communityName: string;
          isMobile: boolean;
          pendingSignup: boolean;
          belongsToPool: boolean;
          id: string;
          avatarUrls: { __typename?: 'AvatarUrl'; origin?: string | null };
        };
      }>;
    };
  };
};

export type B2bDepartmentsNavigationFetchDepartmentsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type B2bDepartmentsNavigationFetchDepartmentsQuery = {
  __typename?: 'Query';
  me:
    | { __typename?: 'AgencyUser' }
    | {
        __typename?: 'B2bCustomer';
        serviceablePositions: Array<{
          __typename?: 'PositionDetails';
          department?: { __typename?: 'Department'; id: number; name: string } | null;
        }>;
      }
    | { __typename?: 'Jane' }
    | {
        __typename?: 'SecondaryUser';
        serviceablePositions: Array<{
          __typename?: 'PositionDetails';
          department?: { __typename?: 'Department'; id: number; name: string } | null;
        }>;
      };
};

export type B2bPositionsSettingsPageFetchLocationsPerPositionQueryVariables = Exact<{
  positionId: Scalars['ID']['input'];
}>;

export type B2bPositionsSettingsPageFetchLocationsPerPositionQuery = {
  __typename?: 'Query';
  fetchPosition: {
    __typename?: 'PositionDetails';
    serviceableCommunities: Array<{ __typename?: 'Community'; name: string; id: string }>;
  };
};

export type B2bPositionsSettingsPageFetchPositionsByDepartmentIdQueryVariables = Exact<{
  [key: string]: never;
}>;

export type B2bPositionsSettingsPageFetchPositionsByDepartmentIdQuery = {
  __typename?: 'Query';
  me:
    | { __typename?: 'AgencyUser' }
    | {
        __typename?: 'B2bCustomer';
        serviceablePositions: Array<{
          __typename?: 'PositionDetails';
          name: string;
          id: number;
          openShiftPolicy: OpenShiftPolicyEnum;
          updatedAt: any;
          department?: { __typename?: 'Department'; id: number; name: string } | null;
          serviceableCommunities: Array<{ __typename?: 'Community'; name: string; id: number }>;
        }>;
      }
    | { __typename?: 'Jane' }
    | {
        __typename?: 'SecondaryUser';
        serviceablePositions: Array<{
          __typename?: 'PositionDetails';
          name: string;
          id: number;
          openShiftPolicy: OpenShiftPolicyEnum;
          updatedAt: any;
          department?: { __typename?: 'Department'; id: number; name: string } | null;
          serviceableCommunities: Array<{ __typename?: 'Community'; name: string; id: number }>;
        }>;
      };
};

export type CommunityBudgetAllocationsForPositionQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
  positionId: Scalars['Int']['input'];
}>;

export type CommunityBudgetAllocationsForPositionQuery = {
  __typename?: 'Query';
  fetchCommunity: {
    __typename: 'Community';
    displayId: string;
    name: string;
    activeBudgetAllocation?: {
      __typename?: 'BudgetAllocation';
      id: string;
      startDate: any;
      occupancy: number;
      morningErrorMargin: number;
      morningRatio?: number | null;
      eveningErrorMargin: number;
      eveningRatio?: number | null;
      nightErrorMargin: number;
      nightRatio?: number | null;
    } | null;
    nextBudgetAllocation?: {
      __typename?: 'BudgetAllocation';
      id: string;
      startDate: any;
      occupancy: number;
      morningErrorMargin: number;
      morningRatio?: number | null;
      eveningErrorMargin: number;
      eveningRatio?: number | null;
      nightErrorMargin: number;
      nightRatio?: number | null;
    } | null;
  };
};

export type CommunityCustomFieldsQueryVariables = Exact<{
  filter?: InputMaybe<FilterableCustomFieldAttributes>;
}>;

export type CommunityCustomFieldsQuery = {
  __typename?: 'Query';
  fetchCustomFields: {
    __typename: 'CustomFieldConnection';
    nodes: Array<{
      __typename: 'CustomField';
      id: number;
      name: string;
      mobile: boolean;
      fieldType: CustomFieldTypeEnum;
      placeholder: string;
      prefillDefault: boolean;
      createdAt?: any | null;
      lastEditedAt?: any | null;
      customFieldOptions?: Array<{ __typename: 'CustomFieldOption'; value: string }> | null;
      communities?: Array<{ __typename: 'Community'; name: string }> | null;
      organization: { __typename: 'Organization'; name: string };
      activities: Array<{ __typename: 'Activity'; event: ActivityEventEnum; createdAt: any }>;
    }>;
  };
};

export type CommunityGroupsQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterableGroupAttributes>;
}>;

export type CommunityGroupsQuery = {
  __typename?: 'Query';
  fetchCommunity: {
    __typename: 'Community';
    id: number;
    name: string;
    groups: {
      __typename: 'GroupUnionConnection';
      pageCount: number;
      nodes: Array<
        | { __typename?: 'DynamicGroup'; id: string; displayId: number; name: string }
        | { __typename?: 'StaticGroup'; id: string; displayId: number; name: string }
      >;
      pageInfo: {
        __typename?: 'PageInfo';
        endCursor?: string | null;
        startCursor?: string | null;
        hasPreviousPage: boolean;
        hasNextPage: boolean;
      };
    };
  };
};

export type CommunityLocationsSettingsPageQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
  type?: InputMaybe<PositionTypeEnum>;
  orderFilter?: InputMaybe<FilterableOrderAttributes>;
  teamMemberFilter?: InputMaybe<FilterableJaneAttributes>;
}>;

export type CommunityLocationsSettingsPageQuery = {
  __typename?: 'Query';
  fetchCommunity: {
    __typename?: 'Community';
    locationPositions: Array<{
      __typename?: 'PositionDetails';
      id: number;
      name: string;
      department?: { __typename?: 'Department'; id: number; name: string } | null;
      teamMembers: { __typename?: 'JaneConnection'; totalCount: number };
      configuredShifts: { __typename?: 'OrderConnection'; totalCount: number };
    }>;
  };
};

export type CommunityTimeFramesQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
}>;

export type CommunityTimeFramesQuery = {
  __typename?: 'Query';
  fetchCommunity: {
    __typename: 'Community';
    displayId: string;
    name: string;
    timeFrame: {
      __typename?: 'TimeFrame';
      eveningStartsAt: string;
      morningStartsAt: string;
      nightStartsAt: string;
    };
  };
};

export type CompanyProfilePageQueryVariables = Exact<{ [key: string]: never }>;

export type CompanyProfilePageQuery = {
  __typename?: 'Query';
  me:
    | {
        __typename?: 'AgencyUser';
        agency?: {
          __typename?: 'Agency';
          id: number;
          name: string;
          createdAt: any;
          updatedAt: any;
          directDeposit?: {
            __typename?: 'DirectDeposit';
            chequeImageUrl?: string | null;
            hstNumber: string;
            id: string;
          } | null;
          liability?: {
            __typename?: 'Liability';
            coverageAmount?: any | null;
            expiryDate?: any | null;
            insuranceNumber?: string | null;
            id: string;
            licenceNumber?: string | null;
            insuranceDocuments: Array<{
              __typename?: 'InsuranceDocument';
              documentUrls: { __typename?: 'DocumentUrl'; origin?: string | null };
            }>;
          } | null;
          lastEditedBy?:
            | { __typename?: 'AgencyUser'; id: string; firstName: string; lastName: string }
            | { __typename?: 'User'; displayId: string; firstName: string; lastName: string }
            | null;
        } | null;
      }
    | {
        __typename?: 'B2bCustomer';
        communities: Array<{
          __typename?: 'Community';
          id: number;
          name: string;
          main: boolean;
          location?: {
            __typename?: 'Location';
            fullAddress?: string | null;
            flat?: string | null;
          } | null;
        }>;
      }
    | { __typename?: 'Jane' }
    | { __typename?: 'SecondaryUser' };
};

export type ContinueCalloutDialogQueryVariables = Exact<{
  orderId: Scalars['Int']['input'];
}>;

export type ContinueCalloutDialogQuery = {
  __typename?: 'Query';
  fetchOrder: {
    __typename?: 'Order';
    allowOvertime: boolean;
    id: number;
    currentlyActiveCalloutList?: {
      __typename?: 'CalloutList';
      id: string;
      manualApprovalIndexes: Array<{ __typename?: 'ManualApprovalIndex'; groupName: string }>;
    } | null;
  };
};

export type CreateCustomFieldFetchCommunitiesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  byName?: InputMaybe<Scalars['String']['input']>;
  withId?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortableCommunityAttributes> | SortableCommunityAttributes>;
}>;

export type CreateCustomFieldFetchCommunitiesQuery = {
  __typename: 'Query';
  fetchCommunities: {
    __typename: 'CommunityConnection';
    pageInfo: {
      __typename: 'PageInfo';
      endCursor?: string | null;
      startCursor?: string | null;
      hasPreviousPage: boolean;
      hasNextPage: boolean;
    };
    nodes: Array<{ __typename: 'Community'; id: number; name: string }>;
  };
};

export type RequestTeamMemberViewQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  external?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortableJanesAttributes> | SortableJanesAttributes>;
  byEmploymentStatus?: InputMaybe<Array<UserEmploymentStatusEnum> | UserEmploymentStatusEnum>;
  byMultipleFields?: InputMaybe<Scalars['String']['input']>;
  byPositionIdArray?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  byPositionIdInt?: InputMaybe<Scalars['Int']['input']>;
  byFacilityId?: InputMaybe<Scalars['Int']['input']>;
  byAgency?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  isDedicated?: InputMaybe<Scalars['Boolean']['input']>;
  byStartTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  byEndTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  allowOvertime?: InputMaybe<Scalars['Boolean']['input']>;
  breakTime?: InputMaybe<Scalars['String']['input']>;
}>;

export type RequestTeamMemberViewQuery = {
  __typename?: 'Query';
  requestJanes: {
    __typename?: 'JaneConnection';
    totalCount: number;
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      startCursor?: string | null;
      hasPreviousPage: boolean;
      hasNextPage: boolean;
    };
    nodes: Array<{
      __typename?: 'Jane';
      firstName: string;
      lastName: string;
      isMobile: boolean;
      pendingSignup: boolean;
      id: string;
      agencyCommunity?: {
        __typename?: 'AgencyCommunity';
        name: string;
        agency: { __typename?: 'Agency'; name: string };
      } | null;
      avatarUrls: { __typename?: 'AvatarUrl'; origin?: string | null };
      primaryCommunity?: { __typename?: 'Community'; name: string } | null;
      customerReviews: {
        __typename?: 'CustomerReviews';
        averageRating?: number | null;
        count: number;
      };
      primaryPosition?: {
        __typename?: 'Position';
        agencyDetails?: { __typename?: 'AgencyPositionDetails'; openRate: any } | null;
      } | null;
      positions: Array<{
        __typename?: 'Position';
        details: { __typename?: 'PositionDetails'; janePayout: any };
        agencyDetails?: { __typename?: 'AgencyPositionDetails'; openRate: any } | null;
      }>;
    }>;
  };
};

export type RequestTeamMemberRecurringViewQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  external?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortableJanesAttributes> | SortableJanesAttributes>;
  byEmploymentStatus?: InputMaybe<Array<UserEmploymentStatusEnum> | UserEmploymentStatusEnum>;
  byMultipleFields?: InputMaybe<Scalars['String']['input']>;
  byPositionIdArray?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  byPositionIdInt?: InputMaybe<Scalars['Int']['input']>;
  byFacilityId?: InputMaybe<Scalars['Int']['input']>;
  byAgency?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  recurring: RecurringOrderAttributes;
  isDedicated?: InputMaybe<Scalars['Boolean']['input']>;
  byStartTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  byEndTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  breakTime?: InputMaybe<Scalars['String']['input']>;
}>;

export type RequestTeamMemberRecurringViewQuery = {
  __typename?: 'Query';
  requestJanes: {
    __typename?: 'JaneConnection';
    totalCount: number;
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      startCursor?: string | null;
      hasPreviousPage: boolean;
      hasNextPage: boolean;
    };
    nodes: Array<{
      __typename?: 'Jane';
      firstName: string;
      lastName: string;
      isMobile: boolean;
      pendingSignup: boolean;
      id: string;
      agencyCommunity?: {
        __typename?: 'AgencyCommunity';
        name: string;
        agency: { __typename?: 'Agency'; name: string };
      } | null;
      avatarUrls: { __typename?: 'AvatarUrl'; origin?: string | null };
      primaryCommunity?: { __typename?: 'Community'; name: string } | null;
      customerReviews: {
        __typename?: 'CustomerReviews';
        averageRating?: number | null;
        count: number;
      };
      primaryPosition?: {
        __typename?: 'Position';
        agencyDetails?: { __typename?: 'AgencyPositionDetails'; openRate: any } | null;
      } | null;
      conflictingDays: Array<{ __typename?: 'OrderSchedule'; startTime: any }>;
      positions: Array<{
        __typename?: 'Position';
        details: { __typename?: 'PositionDetails'; janePayout: any };
        agencyDetails?: { __typename?: 'AgencyPositionDetails'; openRate: any } | null;
      }>;
    }>;
  };
};

export type CustomFieldsSettingsFetchCustomFieldsQueryVariables = Exact<{ [key: string]: never }>;

export type CustomFieldsSettingsFetchCustomFieldsQuery = {
  __typename?: 'Query';
  fetchCustomFields: {
    __typename?: 'CustomFieldConnection';
    nodes: Array<{
      __typename: 'CustomField';
      id: number;
      allFacilities: boolean;
      name: string;
      mobile: boolean;
      fieldType: CustomFieldTypeEnum;
      lastEditedAt?: any | null;
      communities?: Array<{ __typename: 'Community'; name: string }> | null;
    }>;
  };
};

export type FetchFacilitiesCountQueryVariables = Exact<{ [key: string]: never }>;

export type FetchFacilitiesCountQuery = {
  __typename: 'Query';
  fetchCommunities: { __typename: 'CommunityConnection'; totalCount: number };
};

export type DashboardAvailableShiftsPageQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  sortOrders?: InputMaybe<Array<SortableOrderAttributes> | SortableOrderAttributes>;
  filter?: InputMaybe<FilterableOrderAttributes>;
}>;

export type DashboardAvailableShiftsPageQuery = {
  __typename?: 'Query';
  fastGroupOrders: {
    __typename?: 'GroupedOrdersConnection';
    totalCount: number;
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      startCursor?: string | null;
      hasPreviousPage: boolean;
      hasNextPage: boolean;
    };
    nodes: Array<{
      __typename?: 'GroupedOrders';
      group: any;
      orders: Array<{
        __typename: 'Order';
        allowOvertime: boolean;
        dedicated: boolean;
        isReviewAllowed: boolean;
        canSendToAgency: boolean;
        canAssign: boolean;
        acceptedBySharedTeamMember?: boolean | null;
        sentToAgencies: boolean;
        startAt?: any | null;
        endAt?: any | null;
        id: number;
        orderSchedule: { __typename?: 'OrderSchedule'; id: number };
        status: { __typename?: 'OrderStatus'; name: any; value: OrderStatusEnum };
        community: {
          __typename: 'Community';
          id: number;
          name: string;
          location?: { __typename?: 'Location'; timeZone?: string | null } | null;
        };
        position: { __typename?: 'PositionDetails'; name: string; id: number };
        mainJane?: {
          __typename?: 'Jane';
          firstName: string;
          lastName: string;
          isMobile: boolean;
          pendingSignup: boolean;
          id: string;
          primaryCommunity?: { __typename?: 'Community'; id: string } | null;
          avatarUrls: {
            __typename?: 'AvatarUrl';
            small?: string | null;
            origin?: string | null;
            large?: string | null;
          };
          agencyCommunity?: { __typename?: 'AgencyCommunity'; id: number } | null;
        } | null;
        review?: { __typename?: 'Review'; rating?: number | null } | null;
        recurrence?: {
          __typename?: 'Recurrence';
          id: number;
          frequency?: RecurringFrequencyEnum | null;
        } | null;
      }>;
    }>;
  };
};

export type DashboardMyUpcomingShiftsPageQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  sortOrders?: InputMaybe<Array<SortableOrderAttributes> | SortableOrderAttributes>;
  filter?: InputMaybe<FilterableOrderAttributes>;
}>;

export type DashboardMyUpcomingShiftsPageQuery = {
  __typename?: 'Query';
  fastGroupOrders: {
    __typename?: 'GroupedOrdersConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      startCursor?: string | null;
      hasPreviousPage: boolean;
      hasNextPage: boolean;
    };
    nodes: Array<{
      __typename?: 'GroupedOrders';
      group: any;
      orders: Array<{
        __typename: 'Order';
        dedicated: boolean;
        isReviewAllowed: boolean;
        canSendToAgency: boolean;
        canAssign: boolean;
        acceptedBySharedTeamMember?: boolean | null;
        sentToAgencies: boolean;
        startAt?: any | null;
        endAt?: any | null;
        id: number;
        orderSchedule: { __typename?: 'OrderSchedule'; id: number };
        status: { __typename?: 'OrderStatus'; name: any; value: OrderStatusEnum };
        community: {
          __typename: 'Community';
          id: number;
          name: string;
          location?: { __typename?: 'Location'; timeZone?: string | null } | null;
        };
        position: { __typename?: 'PositionDetails'; name: string; id: number };
        mainJane?: {
          __typename?: 'Jane';
          firstName: string;
          lastName: string;
          isMobile: boolean;
          pendingSignup: boolean;
          id: string;
          primaryCommunity?: { __typename?: 'Community'; id: string } | null;
          avatarUrls: {
            __typename?: 'AvatarUrl';
            small?: string | null;
            origin?: string | null;
            large?: string | null;
          };
          agencyCommunity?: { __typename?: 'AgencyCommunity'; id: number } | null;
        } | null;
        review?: { __typename?: 'Review'; rating?: number | null } | null;
        recurrence?: {
          __typename?: 'Recurrence';
          id: number;
          frequency?: RecurringFrequencyEnum | null;
        } | null;
      }>;
    }>;
  };
};

export type DashboardPastShiftsPageQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  sortOrders?: InputMaybe<Array<SortableOrderAttributes> | SortableOrderAttributes>;
  filter?: InputMaybe<FilterableOrderAttributes>;
}>;

export type DashboardPastShiftsPageQuery = {
  __typename?: 'Query';
  fastGroupOrders: {
    __typename: 'GroupedOrdersConnection';
    pageInfo: {
      __typename: 'PageInfo';
      endCursor?: string | null;
      startCursor?: string | null;
      hasPreviousPage: boolean;
      hasNextPage: boolean;
    };
    nodes: Array<{
      __typename?: 'GroupedOrders';
      group: any;
      orders: Array<{
        __typename: 'Order';
        biddable: boolean;
        biddingTimeEndsAt?: any | null;
        awardingTimeStartsAt?: any | null;
        priority: OrderPriorityEnum;
        autoRebid: boolean;
        allowOvertime: boolean;
        auditTrailVersion: AuditTrailVersionEnum;
        canAssign: boolean;
        isReviewAllowed: boolean;
        canSendToAgency: boolean;
        acceptedBySharedTeamMember?: boolean | null;
        sentToAgencies: boolean;
        dedicated: boolean;
        startAt?: any | null;
        endAt?: any | null;
        id: number;
        currentlyActiveCalloutList?: {
          __typename?: 'CalloutList';
          id: string;
          isCompleted: boolean;
          createdAt: any;
          updatedAt: any;
          totalJanes: number;
          waitingForManualApproval: boolean;
          estimatedCompletedAt?: any | null;
          totalNotifiedAndSkipped: number;
        } | null;
        bidders: Array<{ __typename?: 'Jane'; firstName: string; lastName: string; id: string }>;
        orderSchedule: { __typename?: 'OrderSchedule'; id: number };
        activities: Array<{
          __typename?: 'OrderActivity';
          event: { __typename?: 'Event'; name: ActivityEventEnum };
        }>;
        status: { __typename: 'OrderStatus'; name: any; value: OrderStatusEnum };
        community: {
          __typename: 'Community';
          id: number;
          name: string;
          location?: { __typename?: 'Location'; timeZone?: string | null } | null;
        };
        position: { __typename: 'PositionDetails'; name: string; id: number };
        mainJane?: {
          __typename: 'Jane';
          firstName: string;
          lastName: string;
          isMobile: boolean;
          pendingSignup: boolean;
          id: string;
          primaryCommunity?: { __typename?: 'Community'; id: string } | null;
          avatarUrls: {
            __typename: 'AvatarUrl';
            small?: string | null;
            origin?: string | null;
            large?: string | null;
          };
          agencyCommunity?: { __typename: 'AgencyCommunity'; id: number } | null;
        } | null;
        review?: { __typename: 'Review'; rating?: number | null } | null;
        recurrence?: {
          __typename: 'Recurrence';
          id: number;
          frequency?: RecurringFrequencyEnum | null;
        } | null;
      }>;
    }>;
  };
};

export type DashboardRecentlyCreatedShiftsPageQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  sortOrders?: InputMaybe<Array<SortableOrderAttributes> | SortableOrderAttributes>;
  filter?: InputMaybe<FilterableOrderAttributes>;
}>;

export type DashboardRecentlyCreatedShiftsPageQuery = {
  __typename?: 'Query';
  fastGroupOrders: {
    __typename?: 'GroupedOrdersConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      startCursor?: string | null;
      hasPreviousPage: boolean;
      hasNextPage: boolean;
    };
    nodes: Array<{
      __typename?: 'GroupedOrders';
      group: any;
      orders: Array<{
        __typename: 'Order';
        biddable: boolean;
        biddingTimeEndsAt?: any | null;
        awardingTimeStartsAt?: any | null;
        priority: OrderPriorityEnum;
        autoRebid: boolean;
        allowOvertime: boolean;
        auditTrailVersion: AuditTrailVersionEnum;
        dedicated: boolean;
        isReviewAllowed: boolean;
        canSendToAgency: boolean;
        canAssign: boolean;
        acceptedBySharedTeamMember?: boolean | null;
        sentToAgencies: boolean;
        startAt?: any | null;
        endAt?: any | null;
        id: number;
        currentlyActiveCalloutList?: {
          __typename?: 'CalloutList';
          id: string;
          isCompleted: boolean;
          createdAt: any;
          updatedAt: any;
          totalJanes: number;
          waitingForManualApproval: boolean;
          estimatedCompletedAt?: any | null;
          totalNotifiedAndSkipped: number;
        } | null;
        bidders: Array<{ __typename?: 'Jane'; firstName: string; lastName: string; id: string }>;
        orderSchedule: { __typename?: 'OrderSchedule'; id: number };
        activities: Array<{
          __typename?: 'OrderActivity';
          event: { __typename?: 'Event'; name: ActivityEventEnum };
        }>;
        status: { __typename?: 'OrderStatus'; name: any; value: OrderStatusEnum };
        community: {
          __typename: 'Community';
          id: number;
          name: string;
          location?: { __typename?: 'Location'; timeZone?: string | null } | null;
        };
        position: { __typename?: 'PositionDetails'; name: string; id: number };
        mainJane?: {
          __typename?: 'Jane';
          firstName: string;
          lastName: string;
          isMobile: boolean;
          pendingSignup: boolean;
          id: string;
          primaryCommunity?: { __typename?: 'Community'; id: string } | null;
          avatarUrls: {
            __typename?: 'AvatarUrl';
            small?: string | null;
            origin?: string | null;
            large?: string | null;
          };
          agencyCommunity?: { __typename?: 'AgencyCommunity'; id: number } | null;
        } | null;
        review?: { __typename?: 'Review'; rating?: number | null } | null;
        recurrence?: {
          __typename?: 'Recurrence';
          id: number;
          frequency?: RecurringFrequencyEnum | null;
        } | null;
      }>;
    }>;
  };
};

export type TodaysTeamMemberTimeframesQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
}>;

export type TodaysTeamMemberTimeframesQuery = {
  __typename?: 'Query';
  fetchCommunity: {
    __typename?: 'Community';
    timeFrame: {
      __typename?: 'TimeFrame';
      id: string;
      morningStartsAt: string;
      eveningStartsAt: string;
      nightStartsAt: string;
    };
  };
};

export type DashboardUpcomingShiftsPageQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  sortOrders?: InputMaybe<Array<SortableOrderAttributes> | SortableOrderAttributes>;
  filter?: InputMaybe<FilterableOrderAttributes>;
}>;

export type DashboardUpcomingShiftsPageQuery = {
  __typename?: 'Query';
  fastGroupOrders: {
    __typename?: 'GroupedOrdersConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      startCursor?: string | null;
      hasPreviousPage: boolean;
      hasNextPage: boolean;
    };
    nodes: Array<{
      __typename?: 'GroupedOrders';
      group: any;
      orders: Array<{
        __typename: 'Order';
        biddable: boolean;
        biddingTimeEndsAt?: any | null;
        awardingTimeStartsAt?: any | null;
        priority: OrderPriorityEnum;
        autoRebid: boolean;
        allowOvertime: boolean;
        auditTrailVersion: AuditTrailVersionEnum;
        dedicated: boolean;
        isReviewAllowed: boolean;
        canSendToAgency: boolean;
        canAssign: boolean;
        acceptedBySharedTeamMember?: boolean | null;
        sentToAgencies: boolean;
        startAt?: any | null;
        endAt?: any | null;
        id: number;
        currentlyActiveCalloutList?: {
          __typename?: 'CalloutList';
          id: string;
          isCompleted: boolean;
          createdAt: any;
          updatedAt: any;
          totalJanes: number;
          waitingForManualApproval: boolean;
          estimatedCompletedAt?: any | null;
          totalNotifiedAndSkipped: number;
        } | null;
        bidders: Array<{ __typename?: 'Jane'; firstName: string; lastName: string; id: string }>;
        orderSchedule: { __typename?: 'OrderSchedule'; id: number };
        activities: Array<{
          __typename?: 'OrderActivity';
          event: { __typename?: 'Event'; name: ActivityEventEnum };
        }>;
        status: { __typename?: 'OrderStatus'; name: any; value: OrderStatusEnum };
        community: {
          __typename: 'Community';
          id: number;
          name: string;
          location?: { __typename?: 'Location'; timeZone?: string | null } | null;
        };
        position: { __typename?: 'PositionDetails'; name: string; id: number };
        mainJane?: {
          __typename?: 'Jane';
          firstName: string;
          lastName: string;
          isMobile: boolean;
          pendingSignup: boolean;
          id: string;
          primaryCommunity?: { __typename?: 'Community'; id: string } | null;
          avatarUrls: {
            __typename?: 'AvatarUrl';
            small?: string | null;
            origin?: string | null;
            large?: string | null;
          };
          agencyCommunity?: { __typename?: 'AgencyCommunity'; id: number } | null;
        } | null;
        review?: { __typename?: 'Review'; rating?: number | null } | null;
        recurrence?: {
          __typename?: 'Recurrence';
          id: number;
          frequency?: RecurringFrequencyEnum | null;
        } | null;
      }>;
    }>;
  };
};

export type EditCustomFieldFetchCustomFieldByIdQueryVariables = Exact<{
  fetchCustomFieldId: Scalars['Int']['input'];
}>;

export type EditCustomFieldFetchCustomFieldByIdQuery = {
  __typename?: 'Query';
  fetchCustomField: {
    __typename?: 'CustomField';
    id: number;
    allFacilities: boolean;
    name: string;
    mobile: boolean;
    fieldType: CustomFieldTypeEnum;
    placeholder: string;
    prefillDefault: boolean;
    communities?: Array<{ __typename?: 'Community'; id: number; name: string }> | null;
    customFieldOptions?: Array<{ __typename?: 'CustomFieldOption'; value: string }> | null;
  };
};

export type FetchAgencyCommunitiesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  byName?: InputMaybe<Scalars['String']['input']>;
}>;

export type FetchAgencyCommunitiesQuery = {
  __typename?: 'Query';
  fetchAgency: {
    __typename: 'Agency';
    id: number;
    agencyCommunities: Array<{
      __typename: 'AgencyCommunity';
      id: number;
      name: string;
      location?: {
        __typename?: 'Location';
        latitude?: number | null;
        longitude?: number | null;
        timeZone?: string | null;
        country?: string | null;
      } | null;
    }>;
  };
};

export type FetchCommunitiesQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortableCommunityAttributes> | SortableCommunityAttributes>;
  filter?: InputMaybe<FilterableCommunitiesAttributes>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;

export type FetchCommunitiesQuery = {
  __typename?: 'Query';
  fetchCommunities: {
    __typename?: 'CommunityConnection';
    edges: Array<{
      __typename?: 'CommunityEdge';
      node?: { __typename: 'Community'; id: number; name: string } | null;
    }>;
    pageInfo: {
      __typename: 'PageInfo';
      endCursor?: string | null;
      startCursor?: string | null;
      hasPreviousPage: boolean;
      hasNextPage: boolean;
    };
  };
};

export type FetchCommunitiesPaginatedQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  byName?: InputMaybe<Scalars['String']['input']>;
}>;

export type FetchCommunitiesPaginatedQuery = {
  __typename: 'Query';
  fetchCommunities: {
    __typename: 'CommunityConnection';
    currentPage?: number | null;
    pageCount: number;
    pageSize: number;
    totalCount: number;
    pageInfo: { __typename: 'PageInfo'; endCursor?: string | null; hasNextPage: boolean };
    nodes: Array<{
      __typename: 'Community';
      id: number;
      name: string;
      location?: {
        __typename?: 'Location';
        timeZone?: string | null;
        country?: string | null;
      } | null;
    }>;
  };
};

export type FetchCommunityBiddingPeriodQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
}>;

export type FetchCommunityBiddingPeriodQuery = {
  __typename?: 'Query';
  fetchCommunity: {
    __typename: 'Community';
    id: number;
    name: string;
    biddingTimes?: Array<{
      __typename?: 'BiddingTime';
      id: string;
      leadTime: number;
      priorityTime: number;
    }> | null;
    leadTimes?: Array<{
      __typename?: 'LeadTime';
      id: string;
      priority: LeadTimePriorityEnum;
      priorityTime: number;
    }> | null;
  };
};

export type FetchDynamicGroupEmploymentStatusesQueryVariables = Exact<{ [key: string]: never }>;

export type FetchDynamicGroupEmploymentStatusesQuery = {
  __typename?: 'Query';
  fetchMetadata: {
    __typename?: 'Metadata';
    dynamicGroupCriteriaEmploymentStatuses: Array<{
      __typename?: 'DynamicGroupCriteriaEmploymentStatusMetadata';
      displayText: string;
      id: string;
    }>;
  };
};

export type FetchFilteredCommunitiesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterableCommunitiesAttributes>;
}>;

export type FetchFilteredCommunitiesQuery = {
  __typename: 'Query';
  fetchCommunities: {
    __typename: 'CommunityConnection';
    currentPage?: number | null;
    pageCount: number;
    pageSize: number;
    totalCount: number;
    pageInfo: { __typename: 'PageInfo'; endCursor?: string | null; hasNextPage: boolean };
    nodes: Array<{
      __typename: 'Community';
      id: number;
      name: string;
      location?: { __typename?: 'Location'; timeZone?: string | null } | null;
    }>;
  };
};

export type FetchMeQueryVariables = Exact<{ [key: string]: never }>;

export type FetchMeQuery = {
  __typename?: 'Query';
  me:
    | {
        __typename?: 'AgencyUser';
        agencyId?: number | null;
        email: string;
        firstName: string;
        hasPools: boolean;
        id: string;
        payrollManagement: boolean;
        phone?: string | null;
        lastName: string;
        type: string;
        agency?: {
          __typename?: 'Agency';
          createdAt: any;
          id: number;
          name: string;
          updatedAt: any;
          agencyCommunities: Array<{ __typename?: 'AgencyCommunity'; id: number; name: string }>;
          communityPositions: Array<{
            __typename?: 'AgencyPositionDetails';
            id: number;
            openPayout: any;
            openRate: any;
            positionDetails: { __typename?: 'PositionDetails'; id: number; name: string };
          }>;
          directDeposit?: { __typename?: 'DirectDeposit'; id: string } | null;
          liability?: {
            __typename?: 'Liability';
            id: string;
            coverageAmount?: any | null;
            expiryDate?: any | null;
            insuranceNumber?: string | null;
            insuranceDocuments: Array<{
              __typename?: 'InsuranceDocument';
              archived: boolean;
              id: string;
              documentUrls: {
                __typename?: 'DocumentUrl';
                large?: string | null;
                origin?: string | null;
                small?: string | null;
              };
            }>;
          } | null;
        } | null;
        avatarUrls: {
          __typename?: 'AvatarUrl';
          small?: string | null;
          origin?: string | null;
          large?: string | null;
        };
        janes?: Array<{ __typename?: 'Jane'; id: string }> | null;
        accessStatus: { __typename?: 'AccessStatus'; name: AccessStatusEnum; value: any };
      }
    | {
        __typename?: 'B2bCustomer';
        accessLevelId: number;
        adpCustomIdentifier?: string | null;
        agencyCustomer: boolean;
        availabilityStatus: string;
        completedOnboardingSteps: number;
        email: string;
        firstName: string;
        hasPools: boolean;
        id: string;
        industry?: string | null;
        lastName: string;
        payrollManagement: boolean;
        phone?: string | null;
        tieringStatus: string;
        type: string;
        userRole: string;
        userType: string;
        accessStatus: { __typename?: 'AccessStatus'; name: AccessStatusEnum; value: any };
        avatarUrls: {
          __typename?: 'AvatarUrl';
          large?: string | null;
          origin?: string | null;
          small?: string | null;
        };
        communities: Array<{
          __typename?: 'Community';
          contactEmail?: string | null;
          contactName?: string | null;
          contactPhone?: string | null;
          location?: {
            __typename?: 'Location';
            city?: string | null;
            country?: string | null;
            description?: string | null;
            flat?: string | null;
            id: number;
            latitude?: number | null;
            longitude?: number | null;
            state?: string | null;
            street?: string | null;
            streetNumber?: string | null;
            timeZone?: string | null;
            zipCode?: string | null;
          } | null;
        }>;
        serviceablePositions: Array<{ __typename?: 'PositionDetails'; id: number }>;
      }
    | { __typename?: 'Jane' }
    | {
        __typename?: 'SecondaryUser';
        accessLevelId: number;
        adpCustomIdentifier?: string | null;
        agencyCustomer: boolean;
        availabilityStatus: string;
        completedOnboardingSteps: number;
        email: string;
        firstName: string;
        hasPools: boolean;
        id: string;
        industry?: string | null;
        lastName: string;
        payrollManagement: boolean;
        phone?: string | null;
        tieringStatus: string;
        type: string;
        unreadConversations?: number | null;
        userRole: string;
        userType: string;
        accessStatus: { __typename?: 'AccessStatus'; name: AccessStatusEnum; value: any };
        avatarUrls: {
          __typename?: 'AvatarUrl';
          large?: string | null;
          origin?: string | null;
          small?: string | null;
        };
        communities: Array<{
          __typename?: 'Community';
          contactEmail?: string | null;
          contactName?: string | null;
          contactPhone?: string | null;
          location?: {
            __typename?: 'Location';
            city?: string | null;
            country?: string | null;
            description?: string | null;
            flat?: string | null;
            id: number;
            latitude?: number | null;
            longitude?: number | null;
            state?: string | null;
            street?: string | null;
            streetNumber?: string | null;
            timeZone?: string | null;
            zipCode?: string | null;
          } | null;
        }>;
        invitedBy?: { __typename?: 'B2bCustomer'; id: string } | null;
        serviceablePositions: Array<{ __typename?: 'PositionDetails'; id: number }>;
      };
};

export type FetchOrderBiddersQueryVariables = Exact<{
  orderId: Scalars['Int']['input'];
  byMultipleFields?: InputMaybe<Scalars['String']['input']>;
  byEmploymentStatus?: InputMaybe<Array<UserEmploymentStatusEnum> | UserEmploymentStatusEnum>;
}>;

export type FetchOrderBiddersQuery = {
  __typename?: 'Query';
  fetchOrder: {
    __typename?: 'Order';
    biddable: boolean;
    biddingTimeEndsAt?: any | null;
    awardingTimeStartsAt?: any | null;
    id: number;
    orderSchedule: { __typename?: 'OrderSchedule'; id: number };
    status: { __typename?: 'OrderStatus'; name: any; value: OrderStatusEnum };
    bidders: Array<{
      __typename?: 'Jane';
      firstName: string;
      lastName: string;
      orderRank?: number | null;
      organizationSeniorityRanking?: number | null;
      id: string;
      avatarUrls: { __typename?: 'AvatarUrl'; origin?: string | null };
      employmentStatus: { __typename?: 'EmploymentStatus'; name: UserEmploymentStatusEnum };
      totalWeeklyHours?: { __typename?: 'WeeklyHours'; weeklyHours?: number | null } | null;
      primaryPosition?: {
        __typename?: 'Position';
        details: { __typename?: 'PositionDetails'; name: string };
      } | null;
    }>;
  };
};

export type FetchOrderCanAssignQueryVariables = Exact<{
  orderId: Scalars['Int']['input'];
}>;

export type FetchOrderCanAssignQuery = {
  __typename?: 'Query';
  fetchOrder: { __typename?: 'Order'; canAssign: boolean };
};

export type FetchSecondaryCommunitiesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  byName?: InputMaybe<Scalars['String']['input']>;
  withEnabledFeatures?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  withoutEnabledFeatures?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
}>;

export type FetchSecondaryCommunitiesQuery = {
  __typename: 'Query';
  fetchCommunities: {
    __typename: 'CommunityConnection';
    currentPage?: number | null;
    pageCount: number;
    pageSize: number;
    totalCount: number;
    pageInfo: { __typename: 'PageInfo'; endCursor?: string | null; hasNextPage: boolean };
    nodes: Array<{
      __typename: 'Community';
      id: number;
      name: string;
      location?: { __typename?: 'Location'; timeZone?: string | null } | null;
    }>;
  };
};

export type FetchTeamMemberByIdTeamMembersPageQueryVariables = Exact<{
  teamMemberId: Scalars['ID']['input'];
}>;

export type FetchTeamMemberByIdTeamMembersPageQuery = {
  __typename?: 'Query';
  fetchJane: {
    __typename?: 'Jane';
    firstName: string;
    lastName: string;
    isMobile: boolean;
    pendingSignup: boolean;
    phone?: string | null;
    email: string;
    id: string;
    invitation?: { __typename?: 'Invitation'; id: number } | null;
    avatarUrls: { __typename?: 'AvatarUrl'; origin?: string | null };
    primaryPosition?: {
      __typename?: 'Position';
      details: { __typename?: 'PositionDetails'; name: string };
    } | null;
    positions: Array<{
      __typename?: 'Position';
      details: { __typename?: 'PositionDetails'; name: string };
    }>;
    secondaryPositions: Array<{
      __typename?: 'Position';
      details: { __typename?: 'PositionDetails'; id: number; name: string };
    }>;
    employmentStatus: { __typename?: 'EmploymentStatus'; name: UserEmploymentStatusEnum };
    accessStatus: { __typename?: 'AccessStatus'; name: AccessStatusEnum };
  };
};

export type FetchTimeOffCustomFieldsQueryVariables = Exact<{
  filter?: InputMaybe<FilterableCustomFieldAttributes>;
}>;

export type FetchTimeOffCustomFieldsQuery = {
  __typename?: 'Query';
  fetchCustomFields: {
    __typename: 'CustomFieldConnection';
    nodes: Array<{
      __typename: 'CustomField';
      id: number;
      name: string;
      mobile: boolean;
      fieldType: CustomFieldTypeEnum;
      placeholder: string;
      prefillDefault: boolean;
      createdAt?: any | null;
      lastEditedAt?: any | null;
      customFieldOptions?: Array<{ __typename: 'CustomFieldOption'; value: string }> | null;
      communities?: Array<{ __typename: 'Community'; name: string }> | null;
      organization: { __typename: 'Organization'; name: string };
      activities: Array<{ __typename: 'Activity'; event: ActivityEventEnum; createdAt: any }>;
    }>;
  };
};

export type FetchLocaleQueryVariables = Exact<{ [key: string]: never }>;

export type FetchLocaleQuery = {
  __typename?: 'Query';
  me:
    | { __typename: 'AgencyUser'; locale: string }
    | { __typename: 'B2bCustomer'; locale: string }
    | { __typename?: 'Jane' }
    | { __typename: 'SecondaryUser'; locale: string };
};

export type GeneralAgencyLocationSettingsPageQueryVariables = Exact<{
  agencyId: Scalars['ID']['input'];
  agencyCommunityId?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;

export type GeneralAgencyLocationSettingsPageQuery = {
  __typename?: 'Query';
  fetchAgency: {
    __typename: 'Agency';
    agencyCommunities: Array<{
      __typename: 'AgencyCommunity';
      id: number;
      name: string;
      contactName: string;
      contactPhone: string;
      contactEmail: string;
      wsib?: {
        __typename: 'Wsib';
        regulatoryId?: string | null;
        documents: Array<{
          __typename: 'WsibDocument';
          originalFilename: string;
          archive: boolean;
          urls: {
            __typename: 'DocumentUrl';
            large?: string | null;
            origin?: string | null;
            small?: string | null;
          };
        }>;
      } | null;
      location?: {
        __typename: 'Location';
        id: number;
        city?: string | null;
        flat?: string | null;
        state?: string | null;
        street?: string | null;
        country?: string | null;
        zipCode?: string | null;
        timeZone?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        fullAddress?: string | null;
        description?: string | null;
        streetNumber?: string | null;
      } | null;
    }>;
  };
};

export type GeneralLocationSettingsPageQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
}>;

export type GeneralLocationSettingsPageQuery = {
  __typename?: 'Query';
  fetchCommunity: {
    __typename: 'Community';
    id: number;
    name: string;
    contactName?: string | null;
    contactPhone?: string | null;
    contactEmail?: string | null;
    location?: {
      __typename: 'Location';
      id: number;
      city?: string | null;
      flat?: string | null;
      state?: string | null;
      street?: string | null;
      country?: string | null;
      zipCode?: string | null;
      timeZone?: string | null;
      latitude?: number | null;
      longitude?: number | null;
      fullAddress?: string | null;
      description?: string | null;
      streetNumber?: string | null;
    } | null;
  };
};

export type GroupedPositionsSettingsPageQueryVariables = Exact<{
  byName?: InputMaybe<Scalars['String']['input']>;
  sortAllocatedPositionsByCommunity?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;

export type GroupedPositionsSettingsPageQuery = {
  __typename?: 'Query';
  groupPositions: {
    __typename: 'GroupedPositionsConnection';
    pageInfo: {
      __typename: 'PageInfo';
      endCursor?: string | null;
      startCursor?: string | null;
      hasPreviousPage: boolean;
      hasNextPage: boolean;
    };
    edges: Array<{
      __typename?: 'GroupedPositionsEdge';
      node?: {
        __typename?: 'GroupedPositions';
        group: any;
        items: Array<{
          __typename?: 'PositionDetails';
          name: string;
          id: number;
          department?: { __typename?: 'Department'; id: number; name: string } | null;
        }>;
      } | null;
    }>;
  };
};

export type JaneModalJaneDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type JaneModalJaneDetailsQuery = {
  __typename?: 'Query';
  fetchJane: {
    __typename?: 'Jane';
    firstName: string;
    lastName: string;
    communityName: string;
    isMobile: boolean;
    pendingSignup: boolean;
    employeeStartDate?: any | null;
    bio?: string | null;
    locale: string;
    lastActivityAt?: any | null;
    phone?: string | null;
    email: string;
    shorthandName: string;
    birthDay?: number | null;
    birthMonth?: number | null;
    hourlyRate?: number | null;
    employeeNumber?: string | null;
    organizationSeniorityRanking?: number | null;
    id: string;
    invitation?: {
      __typename?: 'Invitation';
      id: number;
      lastSendAttempt?: any | null;
      invitationId: string;
    } | null;
    agencyCommunity?: { __typename?: 'AgencyCommunity'; id: number; name: string } | null;
    avatarUrls: { __typename?: 'AvatarUrl'; origin?: string | null; small?: string | null };
    location?: { __typename?: 'Location'; fullAddress?: string | null } | null;
    usersCommunities: Array<{
      __typename?: 'UsersCommunity';
      displayId: number;
      shiftParticipation: ShiftParticipationEnum;
      community: { __typename?: 'Community'; name: string; displayId: string };
    }>;
    primaryPosition?: {
      __typename?: 'Position';
      id: number;
      type: PositionTypeEnum;
      details: { __typename?: 'PositionDetails'; name: string; id: number };
    } | null;
    positions: Array<{
      __typename?: 'Position';
      id: number;
      type: PositionTypeEnum;
      details: { __typename?: 'PositionDetails'; name: string; id: number };
    }>;
    secondaryPositions: Array<{
      __typename?: 'Position';
      id: number;
      type: PositionTypeEnum;
      details: { __typename?: 'PositionDetails'; id: number; name: string };
    }>;
    employmentStatus: { __typename?: 'EmploymentStatus'; name: UserEmploymentStatusEnum };
    accessStatus: { __typename?: 'AccessStatus'; name: AccessStatusEnum };
    customerReviews: {
      __typename?: 'CustomerReviews';
      averageRating?: number | null;
      count: number;
      reviews: Array<{
        __typename?: 'Review';
        comment?: string | null;
        createdAt: any;
        rating?: number | null;
        jane: {
          __typename?: 'Jane';
          shorthandName: string;
          communityName: string;
          avatarUrls: { __typename?: 'AvatarUrl'; origin?: string | null; small?: string | null };
        };
        reviewer: {
          __typename?: 'B2bCustomer';
          firstName: string;
          lastName: string;
          avatarUrls: { __typename?: 'AvatarUrl'; origin?: string | null; small?: string | null };
        };
        order?: {
          __typename?: 'Order';
          community: { __typename?: 'Community'; displayId: string; name: string };
        } | null;
      }>;
    };
    primaryCommunity?: { __typename?: 'Community'; name: string; id: string } | null;
    rankingSeniorityDate?: {
      __typename?: 'RankingSeniorityDate';
      seniorityDays: number;
      seniorityHours: number;
      seniorityMonths: number;
      seniorityYears: number;
    } | null;
  };
};

export type LocationDropdownDataQueryVariables = Exact<{ [key: string]: never }>;

export type LocationDropdownDataQuery = {
  __typename?: 'Query';
  me:
    | {
        __typename: 'AgencyUser';
        agency?: {
          __typename?: 'Agency';
          agencyCommunities: Array<{
            __typename?: 'AgencyCommunity';
            name: string;
            id: number;
            location?: {
              __typename?: 'Location';
              latitude?: number | null;
              longitude?: number | null;
              timeZone?: string | null;
              country?: string | null;
            } | null;
          }>;
        } | null;
      }
    | {
        __typename: 'B2bCustomer';
        communities: Array<{
          __typename?: 'Community';
          id: number;
          name: string;
          location?: {
            __typename?: 'Location';
            timeZone?: string | null;
            country?: string | null;
          } | null;
        }>;
      }
    | { __typename: 'Jane' }
    | {
        __typename: 'SecondaryUser';
        communities: Array<{
          __typename?: 'Community';
          id: number;
          name: string;
          location?: {
            __typename?: 'Location';
            timeZone?: string | null;
            country?: string | null;
          } | null;
        }>;
      };
};

export type LocationNameLabelQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type LocationNameLabelQuery = {
  __typename?: 'Query';
  fetchCommunity: { __typename?: 'Community'; id: number; name: string };
};

export type OrganizationSettingsPageSenorityMethodQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
}>;

export type OrganizationSettingsPageSenorityMethodQuery = {
  __typename?: 'Query';
  fetchCommunity: {
    __typename?: 'Community';
    organization?: {
      __typename?: 'Organization';
      relayId: string;
      name: string;
      seniorityMethod: SeniorityMethodEnum;
      createdAt: any;
      updatedAt: any;
      lastEditedBy?:
        | { __typename?: 'B2bCustomer'; id: string; firstName: string; lastName: string }
        | { __typename?: 'SecondaryUser'; id: string; firstName: string; lastName: string }
        | { __typename?: 'User'; displayId: string; firstName: string; lastName: string }
        | null;
    } | null;
  };
};

export type PositionByDepartmentSelectInputQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterablePositionAttributes>;
}>;

export type PositionByDepartmentSelectInputQuery = {
  __typename?: 'Query';
  groupPositions: {
    __typename: 'GroupedPositionsConnection';
    edges: Array<{
      __typename?: 'GroupedPositionsEdge';
      node?: {
        __typename?: 'GroupedPositions';
        group: any;
        positions: Array<{
          __typename: 'PositionDetails';
          name: string;
          id: number;
          openShiftPolicy: OpenShiftPolicyEnum;
        }>;
      } | null;
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      startCursor?: string | null;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  };
};

export type PositionNameLabelQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PositionNameLabelQuery = {
  __typename?: 'Query';
  fetchPosition: {
    __typename?: 'PositionDetails';
    id: number;
    name: string;
    openPriceRange?: { __typename?: 'PriceRange'; max?: any | null; min?: any | null } | null;
  };
};

export type PositionsByDepartmentQueryVariables = Exact<{
  filter?: InputMaybe<FilterablePositionAttributes>;
}>;

export type PositionsByDepartmentQuery = {
  __typename?: 'Query';
  groupPositions: {
    __typename: 'GroupedPositionsConnection';
    edges: Array<{
      __typename: 'GroupedPositionsEdge';
      node?: {
        __typename: 'GroupedPositions';
        group: any;
        positions: Array<{ __typename: 'PositionDetails'; name: string; id: number }>;
      } | null;
    }>;
  };
};

export type PositionsPriceRangesQueryVariables = Exact<{
  filter?: InputMaybe<FilterablePositionAttributes>;
  communityId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type PositionsPriceRangesQuery = {
  __typename?: 'Query';
  fetchPositions: {
    __typename?: 'PositionDetailsConnection';
    edges: Array<{
      __typename?: 'PositionDetailsEdge';
      node?: {
        __typename?: 'PositionDetails';
        id: number;
        name: string;
        hasPools: boolean;
        openShiftPolicy: OpenShiftPolicyEnum;
        openPriceRange?: { __typename?: 'PriceRange'; max?: any | null; min?: any | null } | null;
      } | null;
    }>;
  };
};

export type PositionsSettingsPageFetchCommunityByIdQueryVariables = Exact<{
  agencyId: Scalars['ID']['input'];
  filter?: InputMaybe<ForAgencyCommunityAttributes>;
}>;

export type PositionsSettingsPageFetchCommunityByIdQuery = {
  __typename?: 'Query';
  fetchAgency: {
    __typename?: 'Agency';
    agencyCommunities: Array<{
      __typename?: 'AgencyCommunity';
      id: number;
      name: string;
      positions: Array<{
        __typename?: 'PositionDetails';
        id: number;
        name: string;
        workTeam: WorkTeamEnum;
        clientCost: any;
        updatedAt: any;
      }>;
    }>;
  };
};

export type PositionsSettingsPageFetchPositionsQueryVariables = Exact<{
  communityId: Scalars['Int']['input'];
}>;

export type PositionsSettingsPageFetchPositionsQuery = {
  __typename?: 'Query';
  me:
    | {
        __typename?: 'AgencyUser';
        agency?: {
          __typename?: 'Agency';
          id: number;
          agencyCommunities: Array<{
            __typename?: 'AgencyCommunity';
            name: string;
            agencyPositionDetails: Array<{
              __typename?: 'AgencyPositionDetails';
              openRate: any;
              positionDetails: {
                __typename?: 'PositionDetails';
                id: number;
                name: string;
                prettyWorkTeam: string;
                workTeam: WorkTeamEnum;
                updatedAt: any;
              };
            }>;
          }>;
        } | null;
      }
    | { __typename?: 'B2bCustomer' }
    | { __typename?: 'Jane' }
    | { __typename?: 'SecondaryUser' };
};

export type RequestTeamMembersQueryVariables = Exact<{
  orderId?: InputMaybe<Scalars['ID']['input']>;
  positionId: Scalars['Int']['input'];
  filter?: InputMaybe<FilterableJaneAttributes>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  breakTime?: InputMaybe<Scalars['String']['input']>;
}>;

export type RequestTeamMembersQuery = {
  __typename?: 'Query';
  requestJanes: {
    __typename?: 'JaneConnection';
    totalCount: number;
    pageSize: number;
    pageCount: number;
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      startCursor?: string | null;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
    nodes: Array<{
      __typename?: 'Jane';
      firstName: string;
      lastName: string;
      isMobile: boolean;
      pendingSignup: boolean;
      id: string;
      agencyCommunity?: {
        __typename?: 'AgencyCommunity';
        name: string;
        agency: { __typename?: 'Agency'; name: string };
      } | null;
      avatarUrls: { __typename?: 'AvatarUrl'; origin?: string | null };
      customerReviews: {
        __typename?: 'CustomerReviews';
        averageRating?: number | null;
        count: number;
      };
      primaryPosition?: {
        __typename?: 'Position';
        details: { __typename?: 'PositionDetails'; name: string; id: number };
        agencyDetails?: {
          __typename?: 'AgencyPositionDetails';
          openRate: any;
          openPayout: any;
        } | null;
      } | null;
      positions: Array<{
        __typename?: 'Position';
        details: { __typename?: 'PositionDetails'; id: number; name: string };
        agencyDetails?: { __typename?: 'AgencyPositionDetails'; openRate: any } | null;
      }>;
    }>;
  };
};

export type RequestTeamMembersCountQueryVariables = Exact<{
  orderId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<FilterableJaneAttributes>;
  breakTime?: InputMaybe<Scalars['String']['input']>;
}>;

export type RequestTeamMembersCountQuery = {
  __typename?: 'Query';
  requestJanes: { __typename?: 'JaneConnection'; totalCount: number };
};

export type RequestTeamMembersRecurringQueryVariables = Exact<{
  orderId?: InputMaybe<Scalars['ID']['input']>;
  positionId: Scalars['Int']['input'];
  filter?: InputMaybe<FilterableJaneAttributes>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  recurring: RecurringOrderAttributes;
  breakTime?: InputMaybe<Scalars['String']['input']>;
}>;

export type RequestTeamMembersRecurringQuery = {
  __typename?: 'Query';
  requestJanes: {
    __typename?: 'JaneConnection';
    totalCount: number;
    pageSize: number;
    pageCount: number;
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      startCursor?: string | null;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
    nodes: Array<{
      __typename?: 'Jane';
      firstName: string;
      lastName: string;
      isMobile: boolean;
      pendingSignup: boolean;
      id: string;
      agencyCommunity?: {
        __typename?: 'AgencyCommunity';
        name: string;
        agency: { __typename?: 'Agency'; name: string };
      } | null;
      avatarUrls: { __typename?: 'AvatarUrl'; origin?: string | null };
      customerReviews: {
        __typename?: 'CustomerReviews';
        averageRating?: number | null;
        count: number;
      };
      primaryPosition?: {
        __typename?: 'Position';
        details: { __typename?: 'PositionDetails'; name: string; id: number };
        agencyDetails?: {
          __typename?: 'AgencyPositionDetails';
          openRate: any;
          openPayout: any;
        } | null;
      } | null;
      conflictingDays: Array<{ __typename?: 'OrderSchedule'; startTime: any }>;
      positions: Array<{
        __typename?: 'Position';
        details: { __typename?: 'PositionDetails'; id: number; name: string };
        agencyDetails?: { __typename?: 'AgencyPositionDetails'; openRate: any } | null;
      }>;
    }>;
  };
};

export type ScheduleTimeOffsQueryVariables = Exact<{
  filter?: InputMaybe<FilterableTimeOffAttributes>;
}>;

export type ScheduleTimeOffsQuery = {
  __typename?: 'Query';
  fetchTimeOffs: {
    __typename?: 'TimeOffConnection';
    currentPage?: number | null;
    pageCount: number;
    pageSize: number;
    totalCount: number;
    pageInfo: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
    nodes: Array<{
      __typename?: 'TimeOff';
      isEditable: boolean;
      id: string;
      startTime: any;
      endTime: any;
      displayId: number;
      jane: { __typename?: 'Jane'; id: string };
      title: { __typename?: 'TimeOffTitle'; name: TimeOffTitleEnum; value: any };
    }>;
  };
};

export type FetchSchedulingGroupsQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterableGroupAttributes>;
}>;

export type FetchSchedulingGroupsQuery = {
  __typename?: 'Query';
  fetchCommunity: {
    __typename: 'Community';
    id: number;
    name: string;
    groups: {
      __typename: 'GroupUnionConnection';
      pageCount: number;
      nodes: Array<
        | { __typename?: 'DynamicGroup' }
        | {
            __typename?: 'StaticGroup';
            id: string;
            displayId: number;
            name: string;
            createdAt: any;
            updatedAt: any;
          }
      >;
      pageInfo: {
        __typename?: 'PageInfo';
        endCursor?: string | null;
        startCursor?: string | null;
        hasPreviousPage: boolean;
        hasNextPage: boolean;
      };
    };
  };
};

export type SchedulingPageQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  byMultipleFields?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortableJanesAttributes> | SortableJanesAttributes>;
}>;

export type SchedulingPageQuery = {
  __typename?: 'Query';
  fetchJanes: {
    __typename?: 'JaneConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      startCursor?: string | null;
      hasPreviousPage: boolean;
      hasNextPage: boolean;
    };
    edges: Array<{
      __typename?: 'JaneEdge';
      node?: { __typename?: 'Jane'; firstName: string; lastName: string; id: string } | null;
    }>;
  };
};

export type SchedulingTabNavigationInputQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  byMultipleFields?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortableJanesAttributes> | SortableJanesAttributes>;
}>;

export type SchedulingTabNavigationInputQuery = {
  __typename?: 'Query';
  fetchJanes: {
    __typename?: 'JaneConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      startCursor?: string | null;
      hasPreviousPage: boolean;
      hasNextPage: boolean;
    };
    edges: Array<{ __typename?: 'JaneEdge'; node?: { __typename?: 'Jane'; id: string } | null }>;
  };
};

export type SearchTeamMembersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  byMultipleFields?: InputMaybe<Scalars['String']['input']>;
  withServiceableCommunity?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  byAgencyCommunity?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  external?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Array<SortableJanesAttributes> | SortableJanesAttributes>;
}>;

export type SearchTeamMembersQuery = {
  __typename?: 'Query';
  fetchJanes: {
    __typename?: 'JaneConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      startCursor?: string | null;
      hasPreviousPage: boolean;
      hasNextPage: boolean;
    };
    edges: Array<{
      __typename?: 'JaneEdge';
      node?: {
        __typename?: 'Jane';
        firstName: string;
        lastName: string;
        isMobile: boolean;
        pendingSignup: boolean;
        id: string;
        primaryCommunity?: { __typename?: 'Community'; id: string } | null;
        agencyCommunity?: { __typename?: 'AgencyCommunity'; id: number } | null;
        avatarUrls: { __typename?: 'AvatarUrl'; small?: string | null };
      } | null;
    }>;
  };
};

export type SearchTeamMembersForGroupQueryVariables = Exact<{
  groupsFilter: FilterableGroupAttributes;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  byMultipleFields?: InputMaybe<Scalars['String']['input']>;
  withServiceableCommunity?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  byAgencyCommunity?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  external?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Array<SortableJanesAttributes> | SortableJanesAttributes>;
}>;

export type SearchTeamMembersForGroupQuery = {
  __typename?: 'Query';
  fetchJanes: {
    __typename: 'JaneConnection';
    pageInfo: {
      __typename: 'PageInfo';
      endCursor?: string | null;
      startCursor?: string | null;
      hasPreviousPage: boolean;
      hasNextPage: boolean;
    };
    edges: Array<{
      __typename: 'JaneEdge';
      node?: {
        __typename: 'Jane';
        firstName: string;
        lastName: string;
        isMobile: boolean;
        pendingSignup: boolean;
        id: string;
        staticGroups: Array<{
          __typename?: 'StaticGroup';
          id: string;
          displayId: number;
          name: string;
        }>;
        primaryCommunity?: { __typename?: 'Community'; id: string } | null;
        agencyCommunity?: { __typename?: 'AgencyCommunity'; id: number } | null;
        avatarUrls: { __typename: 'AvatarUrl'; small?: string | null };
      } | null;
    }>;
  };
};

export type SendToAgenciesOrderDetailsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type SendToAgenciesOrderDetailsQuery = {
  __typename?: 'Query';
  fetchOrder: {
    __typename?: 'Order';
    startAt?: any | null;
    endAt?: any | null;
    recurrence?: {
      __typename?: 'Recurrence';
      weekdays?: Array<WeekdaysEnum> | null;
      frequency?: RecurringFrequencyEnum | null;
      expirationDate?: any | null;
    } | null;
    position: { __typename?: 'PositionDetails'; name: string };
    rate?: { __typename?: 'OrderRate'; max?: number | null; min?: number | null } | null;
    estimatedTotalCharge?: {
      __typename?: 'OrderRate';
      max?: number | null;
      min?: number | null;
      rateLabel: any;
    } | null;
    dedicatedPool?: { __typename?: 'Pool'; name: string } | null;
  };
};

export type SendToAgenciesPositionMinMaxQueryVariables = Exact<{
  positionId: Scalars['ID']['input'];
}>;

export type SendToAgenciesPositionMinMaxQuery = {
  __typename?: 'Query';
  fetchPosition: {
    __typename?: 'PositionDetails';
    openPriceRange?: { __typename?: 'PriceRange'; min?: any | null; max?: any | null } | null;
  };
};

export type SendToAgenciesRequestTeamMemberSelectedJanePriceRangeQueryVariables = Exact<{
  janeId: Scalars['ID']['input'];
  positionId: Scalars['Int']['input'];
}>;

export type SendToAgenciesRequestTeamMemberSelectedJanePriceRangeQuery = {
  __typename?: 'Query';
  fetchJane: {
    __typename?: 'Jane';
    positions: Array<{
      __typename?: 'Position';
      agencyDetails?: { __typename?: 'AgencyPositionDetails'; openRate: any } | null;
    }>;
  };
};

export type SendToAgenciesSummaryViewQueryVariables = Exact<{
  jane_id: Scalars['ID']['input'];
  positionId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SendToAgenciesSummaryViewQuery = {
  __typename?: 'Query';
  fetchJane: {
    __typename?: 'Jane';
    firstName: string;
    lastName: string;
    isMobile: boolean;
    pendingSignup: boolean;
    belongsToPool: boolean;
    avatarUrls: { __typename?: 'AvatarUrl'; small?: string | null };
    positions: Array<{
      __typename?: 'Position';
      details: { __typename?: 'PositionDetails'; id: number; name: string };
      agencyDetails?: {
        __typename?: 'AgencyPositionDetails';
        openRate: any;
        positionDetails: {
          __typename?: 'PositionDetails';
          openPriceRange?: {
            __typename?: 'PriceRange';
            rangeLabel?: string | null;
            rawMin?: number | null;
            rawMax?: number | null;
          } | null;
        };
      } | null;
    }>;
  };
};

export type SendToAgenciesSummaryViewTeamMembersCountQueryVariables = Exact<{
  orderId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<FilterableJaneAttributes>;
  breakTime?: InputMaybe<Scalars['String']['input']>;
}>;

export type SendToAgenciesSummaryViewTeamMembersCountQuery = {
  __typename?: 'Query';
  requestJanes: { __typename?: 'JaneConnection'; totalCount: number };
};

export type SendToSelectedAgenciesFetchAgenciesByOrderIdQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  byName?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  byRateLessThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
}>;

export type SendToSelectedAgenciesFetchAgenciesByOrderIdQuery = {
  __typename?: 'Query';
  fetchAgencyCommunities: {
    __typename?: 'AgencyCommunityConnection';
    totalCount: number;
    pageSize: number;
    pageCount: number;
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      startCursor?: string | null;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
    nodes: Array<{
      __typename?: 'AgencyCommunity';
      id: number;
      name: string;
      averageRating: { __typename?: 'AverageRating'; count: number; value?: number | null };
      availableJanes: { __typename?: 'AvailableJanes'; count: number };
      agency: {
        __typename?: 'Agency';
        liability?: { __typename?: 'Liability'; licenceNumber?: string | null } | null;
        avatarUrls: {
          __typename?: 'AvatarUrl';
          large?: string | null;
          origin?: string | null;
          small?: string | null;
        };
      };
      agencyPositionDetails: Array<{ __typename?: 'AgencyPositionDetails'; openRate: any }>;
    }>;
  };
};

export type SendToSelectedAgenciesFetchAgenciesByOrderIdNonPaginatedQueryVariables = Exact<{
  orderId?: InputMaybe<Scalars['ID']['input']>;
  selectedAgencyCommunities?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;

export type SendToSelectedAgenciesFetchAgenciesByOrderIdNonPaginatedQuery = {
  __typename?: 'Query';
  fetchAgencyCommunities: {
    __typename?: 'AgencyCommunityConnection';
    nodes: Array<{
      __typename?: 'AgencyCommunity';
      id: number;
      name: string;
      availableJanes: { __typename?: 'AvailableJanes'; count: number };
      agency: {
        __typename?: 'Agency';
        liability?: { __typename?: 'Liability'; licenceNumber?: string | null } | null;
      };
      agencyPositionDetails: Array<{ __typename?: 'AgencyPositionDetails'; openRate: any }>;
    }>;
  };
};

export type FetchGroupDetailsQueryVariables = Exact<{
  groupId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;

export type FetchGroupDetailsQuery = {
  __typename?: 'Query';
  node?:
    | { __typename: 'CalloutList' }
    | { __typename: 'CalloutListJane' }
    | { __typename: 'CommunitiesPosition' }
    | {
        __typename: 'DynamicGroup';
        id: string;
        name: string;
        updatedAt: any;
        createdAt: any;
        displayId: number;
        criteria: {
          __typename?: 'DynamicGroupCriteria';
          employmentStatuses: Array<GroupEmploymentStatusEnum>;
          positionTypes: Array<PositionTypeEnum>;
          maximumPerDayMinutes?: number | null;
          maximumPerPeriodMinutes?: number | null;
          minimumPerDayMinutes: number;
          minimumPerPeriodMinutes: number;
          locationDistribution: LocationDistributionEnum;
        };
      }
    | { __typename: 'GroupJane' }
    | { __typename: 'GroupRule' }
    | { __typename: 'LastCallJane' }
    | { __typename: 'Organization' }
    | { __typename: 'ShiftDistributionRule' }
    | {
        __typename: 'StaticGroup';
        id: string;
        name: string;
        updatedAt: any;
        createdAt: any;
        displayId: number;
        groupJanes: {
          __typename?: 'GroupJaneConnection';
          pageCount: number;
          nodes: Array<{
            __typename?: 'GroupJane';
            id: string;
            displayId: number;
            jane: {
              __typename: 'Jane';
              firstName: string;
              lastName: string;
              isMobile: boolean;
              pendingSignup: boolean;
              id: string;
              avatarUrls: { __typename?: 'AvatarUrl'; small?: string | null };
            };
          }>;
          pageInfo: {
            __typename?: 'PageInfo';
            endCursor?: string | null;
            startCursor?: string | null;
            hasPreviousPage: boolean;
            hasNextPage: boolean;
          };
        };
      }
    | { __typename: 'TimeFrame' }
    | { __typename: 'TimeOff' }
    | null;
};

export type FetchGroupsQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterableGroupAttributes>;
}>;

export type FetchGroupsQuery = {
  __typename?: 'Query';
  fetchCommunity: {
    __typename: 'Community';
    id: number;
    displayId: string;
    name: string;
    groups: {
      __typename: 'GroupUnionConnection';
      pageCount: number;
      nodes: Array<
        | {
            __typename: 'DynamicGroup';
            id: string;
            displayId: number;
            name: string;
            createdAt: any;
            updatedAt: any;
          }
        | {
            __typename: 'StaticGroup';
            id: string;
            displayId: number;
            name: string;
            createdAt: any;
            updatedAt: any;
          }
      >;
      pageInfo: {
        __typename?: 'PageInfo';
        endCursor?: string | null;
        startCursor?: string | null;
        hasPreviousPage: boolean;
        hasNextPage: boolean;
      };
    };
  };
};

export type SettingsPageFetchOpenShiftsQueryVariables = Exact<{
  positionId: Scalars['ID']['input'];
  orderFilter?: InputMaybe<FilterableOrderAttributes>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;

export type SettingsPageFetchOpenShiftsQuery = {
  __typename?: 'Query';
  fetchPosition: {
    __typename?: 'PositionDetails';
    id: number;
    name: string;
    serviceableCommunities: Array<{ __typename?: 'Community'; name: string; displayId: string }>;
    configuredShifts: {
      __typename?: 'OrderConnection';
      totalCount: number;
      pageSize: number;
      pageCount: number;
      pageInfo: {
        __typename?: 'PageInfo';
        endCursor?: string | null;
        startCursor?: string | null;
        hasPreviousPage: boolean;
        hasNextPage: boolean;
      };
      nodes: Array<{
        __typename?: 'Order';
        isAway?: boolean | null;
        totalDuration?: number | null;
        startAt?: any | null;
        endAt?: any | null;
        acceptedBySharedTeamMember?: boolean | null;
        id: number;
        status: { __typename?: 'OrderStatus'; name: any; value: OrderStatusEnum };
        position: { __typename?: 'PositionDetails'; name: string; id: number };
        orderSchedule: { __typename?: 'OrderSchedule'; id: number };
        recurrence?: {
          __typename?: 'Recurrence';
          id: number;
          frequency?: RecurringFrequencyEnum | null;
        } | null;
        community: { __typename?: 'Community'; id: number; name: string };
        mainJane?: {
          __typename?: 'Jane';
          firstName: string;
          lastName: string;
          isMobile: boolean;
          pendingSignup: boolean;
          id: string;
          primaryCommunity?: { __typename?: 'Community'; id: string } | null;
          avatarUrls: { __typename?: 'AvatarUrl'; small?: string | null };
        } | null;
      }>;
    };
  };
};

export type SettingsPageFetchPositionByIdQueryVariables = Exact<{
  positionId: Scalars['ID']['input'];
  type?: InputMaybe<PositionTypeEnum>;
  orderFilter?: InputMaybe<FilterableOrderAttributes>;
  teamMemberFilter?: InputMaybe<FilterableJaneAttributes>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;

export type SettingsPageFetchPositionByIdQuery = {
  __typename?: 'Query';
  fetchPosition: {
    __typename?: 'PositionDetails';
    id: number;
    name: string;
    serviceableCommunities: Array<{ __typename?: 'Community'; name: string; displayId: string }>;
    teamMembers: {
      __typename?: 'JaneConnection';
      totalCount: number;
      pageSize: number;
      pageCount: number;
      pageInfo: {
        __typename?: 'PageInfo';
        endCursor?: string | null;
        startCursor?: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
      };
      nodes: Array<{
        __typename?: 'Jane';
        displayId: string;
        firstName: string;
        lastName: string;
        pendingSignup: boolean;
        isMobile: boolean;
        communityName: string;
        avatarUrls: { __typename?: 'AvatarUrl'; origin?: string | null };
        accessStatus: { __typename?: 'AccessStatus'; name: AccessStatusEnum };
        primaryCommunity?: { __typename?: 'Community'; id: number; name: string } | null;
        secondaryCommunities: Array<{ __typename?: 'Community'; displayId: string; name: string }>;
        primaryPosition?: {
          __typename?: 'Position';
          details: { __typename?: 'PositionDetails'; name: string; id: number };
        } | null;
        secondaryPositions: Array<{
          __typename?: 'Position';
          details: { __typename?: 'PositionDetails'; name: string; id: number };
        }>;
      }>;
    };
    configuredShifts: { __typename?: 'OrderConnection'; totalCount: number };
  };
};

export type FetchCommunityQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type FetchCommunityQuery = {
  __typename?: 'Query';
  fetchCommunity: {
    __typename?: 'Community';
    id: number;
    name: string;
    availabilityStatus: number;
    checkInProcedure?: string | null;
    document?: string | null;
    locationHistory?: string | null;
    policies?: string | null;
    vaccinationRequired: boolean;
    vaccinationRequiredLastUpdated?: any | null;
    vaccinationRequiredLastUpdatedBy?: string | null;
    communityFeatures?: Array<{
      __typename?: 'CommunityFeature';
      enabled: boolean;
      id: number;
      feature?: { __typename?: 'Feature'; enabled: boolean; id: number; name: string } | null;
    }> | null;
    location?: { __typename?: 'Location'; id: number } | null;
    positions: Array<{ __typename?: 'PositionDetails'; name: string }>;
  };
};

export type ShiftCardFetchOrderQueryVariables = Exact<{
  orderId: Scalars['Int']['input'];
}>;

export type ShiftCardFetchOrderQuery = {
  __typename?: 'Query';
  fetchOrder: {
    __typename?: 'Order';
    biddable: boolean;
    biddingTimeEndsAt?: any | null;
    awardingTimeStartsAt?: any | null;
    priority: OrderPriorityEnum;
    isReviewAllowed: boolean;
    canSendToAgency: boolean;
    canAssign: boolean;
    autoRebid: boolean;
    acceptedBySharedTeamMember?: boolean | null;
    sentToAgencies: boolean;
    dedicated: boolean;
    allowOvertime: boolean;
    auditTrailVersion: AuditTrailVersionEnum;
    startAt?: any | null;
    endAt?: any | null;
    id: number;
    orderSchedule: { __typename?: 'OrderSchedule'; id: number };
    bidders: Array<{ __typename?: 'Jane'; firstName: string; lastName: string; id: string }>;
    activities: Array<{
      __typename?: 'OrderActivity';
      event: { __typename?: 'Event'; name: ActivityEventEnum };
    }>;
    currentlyActiveCalloutList?: {
      __typename?: 'CalloutList';
      id: string;
      isCompleted: boolean;
      createdAt: any;
      updatedAt: any;
      totalJanes: number;
      waitingForManualApproval: boolean;
      estimatedCompletedAt?: any | null;
      totalNotifiedAndSkipped: number;
    } | null;
    status: { __typename?: 'OrderStatus'; name: any; value: OrderStatusEnum };
    community: {
      __typename?: 'Community';
      id: number;
      name: string;
      location?: { __typename?: 'Location'; timeZone?: string | null } | null;
    };
    position: { __typename?: 'PositionDetails'; name: string; id: number };
    mainJane?: {
      __typename?: 'Jane';
      firstName: string;
      lastName: string;
      isMobile: boolean;
      pendingSignup: boolean;
      id: string;
      primaryCommunity?: { __typename?: 'Community'; id: string } | null;
      avatarUrls: {
        __typename?: 'AvatarUrl';
        small?: string | null;
        origin?: string | null;
        large?: string | null;
      };
      agencyCommunity?: { __typename?: 'AgencyCommunity'; id: number } | null;
    } | null;
    review?: { __typename?: 'Review'; rating?: number | null } | null;
    recurrence?: {
      __typename?: 'Recurrence';
      id: number;
      frequency?: RecurringFrequencyEnum | null;
    } | null;
  };
};

export type ShiftDistributionRulesGroupsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<FilterableShiftDistributionRuleAttributes>;
}>;

export type ShiftDistributionRulesGroupsQuery = {
  __typename?: 'Query';
  fetchShiftDistributionRules: {
    __typename: 'ShiftDistributionRuleConnection';
    totalCount: number;
    pageInfo: {
      __typename: 'PageInfo';
      endCursor?: string | null;
      startCursor?: string | null;
      hasPreviousPage: boolean;
      hasNextPage: boolean;
    };
    nodes: Array<{
      __typename: 'ShiftDistributionRule';
      id: string;
      displayId: number;
      skipWaitTimeThresholdMinutes: number;
      createdAt: any;
      updatedAt: any;
      community: { __typename?: 'Community'; displayId: string; name: string };
      groupRules: Array<{
        __typename?: 'GroupRule';
        rank: number;
        waitTimeMinutes?: number | null;
        id: number;
        group:
          | { __typename?: 'DynamicGroup'; name: string; id: number }
          | { __typename?: 'StaticGroup'; name: string; id: number };
      }>;
      position?: { __typename?: 'PositionDetails'; id: number; name: string } | null;
    }>;
  };
};

export type FetchSharingDetailsQueryVariables = Exact<{ [key: string]: never }>;

export type FetchSharingDetailsQuery = {
  __typename: 'Query';
  fetchCommunities: {
    __typename: 'CommunityConnection';
    nodes: Array<{
      __typename: 'Community';
      id: number;
      name: string;
      communityFeatures?: Array<{
        __typename?: 'CommunityFeature';
        enabled: boolean;
        id: number;
        feature?: { __typename?: 'Feature'; enabled: boolean; id: number; name: string } | null;
      }> | null;
    }>;
  };
};

export type FetchTieringDetailsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type FetchTieringDetailsQuery = {
  __typename?: 'Query';
  fetchCommunity: {
    __typename?: 'Community';
    id: number;
    name: string;
    organization?: { __typename?: 'Organization'; name: string } | null;
    communityFeatures?: Array<{
      __typename?: 'CommunityFeature';
      enabled: boolean;
      id: number;
      feature?: { __typename?: 'Feature'; enabled: boolean; id: number; name: string } | null;
    }> | null;
    escalationTimes?: Array<{
      __typename?: 'EscalationTime';
      createdAt: any;
      id: string;
      priority: EscalationTimePriorityEnum;
      priorityTime: number;
      updatedAt: any;
    }> | null;
    biddingTimes?: Array<{
      __typename?: 'BiddingTime';
      id: string;
      leadTime: number;
      priorityTime: number;
    }> | null;
    leadTimes?: Array<{
      __typename?: 'LeadTime';
      createdAt: any;
      id: string;
      priority: LeadTimePriorityEnum;
      priorityTime: number;
      updatedAt: any;
    }> | null;
  };
};

export type ShiftModalOrderDetailsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type ShiftModalOrderDetailsQuery = {
  __typename?: 'Query';
  fetchOrder: {
    __typename?: 'Order';
    relayId: string;
    canAssign: boolean;
    biddable: boolean;
    autoRebid: boolean;
    createdAt: any;
    biddingTimeEndsAt?: any | null;
    awardingTimeStartsAt?: any | null;
    priority: OrderPriorityEnum;
    acceptedBySharedTeamMember?: boolean | null;
    allowOvertime: boolean;
    auditTrailVersion: AuditTrailVersionEnum;
    canSendToAgency: boolean;
    dedicated: boolean;
    description?: string | null;
    endAt?: any | null;
    isAway?: boolean | null;
    isEditable: boolean;
    isDeletable: boolean;
    isJaneReleaseAllowed: boolean;
    isReviewAllowed: boolean;
    noShow: boolean;
    resident?: string | null;
    sentToAgencies: boolean;
    startAt?: any | null;
    startDate?: any | null;
    totalDuration?: number | null;
    id: number;
    draftShift?: { __typename?: 'DraftShift'; id: number; description?: string | null } | null;
    bidders: Array<{ __typename?: 'Jane'; firstName: string; lastName: string; id: string }>;
    currentlyActiveCalloutList?: {
      __typename?: 'CalloutList';
      id: string;
      isCompleted: boolean;
      createdAt: any;
      updatedAt: any;
      totalJanes: number;
      waitingForManualApproval: boolean;
      estimatedCompletedAt?: any | null;
      totalNotifiedAndSkipped: number;
      manualApprovalIndexes: Array<{
        __typename?: 'ManualApprovalIndex';
        index: number;
        groupName: string;
      }>;
    } | null;
    activities: Array<{
      __typename?: 'OrderActivity';
      createdAt: any;
      flag?: string | null;
      message?: string | null;
      metadata?: {
        __typename?: 'ActivitiesMetaValue';
        calloutListId?: string | null;
        qualifiedAgencyJanesCount?: number | null;
        reasonMessage?: string | null;
        reasonCategory?: string | null;
        acceptedFor?: { __typename?: 'AcceptedFor'; name: string } | null;
        feedableEdits?: Array<{
          __typename?: 'FeedableEditMetaValue';
          fieldName?: string | null;
          fieldType?: FeedableEditDropdownEnum | null;
          newValuePretty?: string | null;
          oldValuePretty?: string | null;
          newValue?: string | null;
          oldValue?: string | null;
        }> | null;
      } | null;
      event: { __typename?: 'Event'; name: ActivityEventEnum; value: any };
      user?:
        | {
            __typename?: 'Admin';
            firstName: string;
            lastName: string;
            avatarUrls: { __typename?: 'AvatarUrl'; origin?: string | null };
          }
        | {
            __typename?: 'AgencyUser';
            firstName: string;
            lastName: string;
            avatarUrls: { __typename?: 'AvatarUrl'; origin?: string | null };
          }
        | {
            __typename?: 'B2bCustomer';
            firstName: string;
            lastName: string;
            avatarUrls: { __typename?: 'AvatarUrl'; origin?: string | null };
          }
        | {
            __typename?: 'Jane';
            firstName: string;
            lastName: string;
            communityName: string;
            isMobile: boolean;
            pendingSignup: boolean;
            avatarUrls: { __typename?: 'AvatarUrl'; origin?: string | null };
          }
        | {
            __typename?: 'SecondaryUser';
            firstName: string;
            lastName: string;
            avatarUrls: { __typename?: 'AvatarUrl'; origin?: string | null };
          }
        | {
            __typename?: 'User';
            firstName: string;
            lastName: string;
            communityName: string;
            title: string;
            isMobile: boolean;
            avatarUrls: { __typename?: 'AvatarUrl'; origin?: string | null };
          }
        | null;
      order: {
        __typename?: 'Order';
        mainJane?: { __typename?: 'Jane'; shorthandName: string; communityName: string } | null;
      };
    }>;
    community: {
      __typename: 'Community';
      id: number;
      name: string;
      b2bUserShiftEditThreshold?: number | null;
      secondaryUserShiftEditThreshold?: number | null;
      customFields: Array<{
        __typename?: 'CustomField';
        id: number;
        name: string;
        fieldType: CustomFieldTypeEnum;
        mobile: boolean;
        placeholder: string;
        prefillDefault: boolean;
        customFieldOptions?: Array<{ __typename?: 'CustomFieldOption'; value: string }> | null;
      }>;
      location?: { __typename?: 'Location'; timeZone?: string | null } | null;
    };
    customFields: Array<{
      __typename?: 'CustomFieldValue';
      customFieldId: number;
      mobile: boolean;
      name: string;
      value: string;
    }>;
    estimatedTotalCharge?: {
      __typename?: 'OrderRate';
      max?: number | null;
      min?: number | null;
      rateLabel: any;
    } | null;
    review?: {
      __typename?: 'Review';
      comment?: string | null;
      rating?: number | null;
      updatedAt: any;
    } | null;
    location?: {
      __typename?: 'Location';
      streetNumber?: string | null;
      street?: string | null;
      city?: string | null;
      state?: string | null;
      zipCode?: string | null;
      latitude?: number | null;
      longitude?: number | null;
      fullAddress?: string | null;
    } | null;
    mainJane?: {
      __typename?: 'Jane';
      firstName: string;
      lastName: string;
      communityName: string;
      acceptedByAgency: boolean;
      isMobile: boolean;
      pendingSignup: boolean;
      id: string;
      primaryCommunity?: { __typename?: 'Community'; id: string } | null;
      avatarUrls: { __typename?: 'AvatarUrl'; small?: string | null };
      agencyCommunity?: {
        __typename?: 'AgencyCommunity';
        id: number;
        name: string;
        contactPhone: string;
      } | null;
    } | null;
    orderSchedule: {
      __typename?: 'OrderSchedule';
      id: number;
      breakTime: string;
      mainOrderJane?: {
        __typename?: 'OrderJane';
        assignedBy?: { __typename?: 'User'; displayId: string } | null;
      } | null;
      timeSheet?: {
        __typename?: 'TimeSheet';
        id: number;
        notes?: string | null;
        status: { __typename?: 'TimeSheetStatus'; value: TimeSheetStatusEnum };
      } | null;
    };
    dedicatedPool?: { __typename?: 'Pool'; id: string } | null;
    position: {
      __typename?: 'PositionDetails';
      id: number;
      name: string;
      openShiftPolicy: OpenShiftPolicyEnum;
      openPriceRange?: {
        __typename?: 'PriceRange';
        max?: any | null;
        min?: any | null;
        rangeLabel?: string | null;
      } | null;
    };
    rate?: {
      __typename?: 'OrderRate';
      max?: number | null;
      min?: number | null;
      rateLabel: any;
    } | null;
    recurrence?: {
      __typename?: 'Recurrence';
      id: number;
      frequency?: RecurringFrequencyEnum | null;
      recurrenceLabel?: string | null;
      interval?: number | null;
      weekdays?: Array<WeekdaysEnum> | null;
      expirationDate?: any | null;
    } | null;
    futureShifts: Array<{
      __typename?: 'Order';
      id: number;
      orderSchedule: { __typename?: 'OrderSchedule'; id: number };
    }>;
    status: { __typename?: 'OrderStatus'; name: any; value: OrderStatusEnum };
  };
};

export type ShiftModalOrderDetailsCalloutListQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ShiftModalOrderDetailsCalloutListQuery = {
  __typename?: 'Query';
  node?:
    | ({ __typename?: 'CalloutList'; id: string } & {
        ' $fragmentRefs'?: { CalloutListFragmentFragment: CalloutListFragmentFragment };
      })
    | { __typename?: 'CalloutListJane'; id: string }
    | { __typename?: 'CommunitiesPosition'; id: number }
    | { __typename?: 'DynamicGroup'; id: string }
    | { __typename?: 'GroupJane'; id: string }
    | { __typename?: 'GroupRule'; id: string }
    | { __typename?: 'LastCallJane'; id: string }
    | { __typename?: 'Organization'; id: number }
    | { __typename?: 'ShiftDistributionRule'; id: string }
    | { __typename?: 'StaticGroup'; id: string }
    | { __typename?: 'TimeFrame'; id: string }
    | { __typename?: 'TimeOff'; id: string }
    | null;
};

export type CalloutListFragmentFragment = {
  __typename: 'CalloutList';
  totalJanes: number;
  totalNotifiedAndSkipped: number;
  waitingForManualApproval: boolean;
  updatedAt: any;
  estimatedCompletedAt?: any | null;
  id: string;
  manualApprovalIndexes: Array<{
    __typename?: 'ManualApprovalIndex';
    groupName: string;
    index: number;
  }>;
  order: {
    __typename?: 'Order';
    biddable: boolean;
    orderSchedule: { __typename?: 'OrderSchedule'; id: number };
    location?: { __typename?: 'Location'; timeZone?: string | null } | null;
  };
  calloutListJanes: {
    __typename?: 'CalloutListJaneConnection';
    currentPage?: number | null;
    pageCount: number;
    pageSize: number;
    totalCount: number;
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      startCursor?: string | null;
      hasPreviousPage: boolean;
      hasNextPage: boolean;
    };
    nodes: Array<{
      __typename?: 'CalloutListJane';
      estimatedCalloutTime?: any | null;
      notifiedAt?: any | null;
      calloutStatus: { __typename?: 'CalloutStatus'; name: any; value: CalloutStatusEnum };
      jane: {
        __typename?: 'Jane';
        id: string;
        isMobile: boolean;
        pendingSignup: boolean;
        firstName: string;
        lastName: string;
        accessStatus: { __typename?: 'AccessStatus'; name: AccessStatusEnum; value: any };
        primaryCommunity?: { __typename?: 'Community'; id: number; name: string } | null;
        avatarUrls: {
          __typename?: 'AvatarUrl';
          large?: string | null;
          origin?: string | null;
          small?: string | null;
        };
        employmentStatus: { __typename?: 'EmploymentStatus'; name: UserEmploymentStatusEnum };
      };
      manualApproval?: { __typename?: 'ManualApproval'; approvedAt: any } | null;
      notNotifiedLogs: Array<{
        __typename?: 'CalloutNotNotifiedLog';
        createdAt: any;
        updatedAt: any;
      }>;
    }>;
  };
} & { ' $fragmentName'?: 'CalloutListFragmentFragment' };

export type ShiftModalRequestSelectAgenciesQueryVariables = Exact<{
  byName?: InputMaybe<Scalars['String']['input']>;
  byRateLessThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  sort?: InputMaybe<Array<SortableAgencyCommunityAttributes> | SortableAgencyCommunityAttributes>;
}>;

export type ShiftModalRequestSelectAgenciesQuery = {
  __typename?: 'Query';
  fetchAgencyCommunities: {
    __typename?: 'AgencyCommunityConnection';
    nodes: Array<{
      __typename?: 'AgencyCommunity';
      name: string;
      availableJanes: {
        __typename?: 'AvailableJanes';
        count: number;
        janes: {
          __typename?: 'JaneConnection';
          nodes: Array<{ __typename?: 'Jane'; shorthandName: string; id: string }>;
        };
      };
    }>;
  };
};

export type ShiftModalTimeSheetDetailsQueryVariables = Exact<{
  orderScheduleId: Scalars['Int']['input'];
}>;

export type ShiftModalTimeSheetDetailsQuery = {
  __typename?: 'Query';
  fetchTimeSheet: {
    __typename?: 'OrderSchedule';
    id: number;
    startTime: any;
    endTime: any;
    breakTime: string;
    actualStart?: any | null;
    actualEnd?: any | null;
    timeSheet?: {
      __typename?: 'TimeSheet';
      id: number;
      approvedAt?: any | null;
      approvedBy?: string | null;
      approvedEndTime?: any | null;
      approvedStartTime?: any | null;
      approvedUnpaidBreakTime?: string | null;
      autoApproved: boolean;
      clockInOffSite: boolean;
      clockOutOffSite: boolean;
      clockInDistance?: number | null;
      clockOutDistance?: number | null;
      clockIn?: any | null;
      clockOut?: any | null;
      createdAt: any;
      price?: number | null;
      unpaidBreakTime: string;
      updatedAt: any;
      acceptedHourlyRate?: { __typename?: 'Currency'; rawCurrency?: number | null } | null;
      approvedCustomerCost?: { __typename?: 'Currency'; rawCurrency?: number | null } | null;
      approvedTotalTime?: {
        __typename?: 'TimeInterval';
        rawTime?: number | null;
        time?: any | null;
      } | null;
      clockInStatus?: {
        __typename: 'ClockInStatus';
        prettyValue: any;
        value: ClockInStatusEnum;
      } | null;
      clockOutStatus?: {
        __typename: 'ClockOutStatus';
        prettyValue: any;
        value: ClockOutStatusEnum;
      } | null;
      status: { __typename?: 'TimeSheetStatus'; name: any; value: TimeSheetStatusEnum };
    } | null;
  };
};

export type ShiftSummaryJaneRowFetchJaneQueryVariables = Exact<{
  janeId: Scalars['ID']['input'];
  positionId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ShiftSummaryJaneRowFetchJaneQuery = {
  __typename?: 'Query';
  fetchJane: {
    __typename?: 'Jane';
    firstName: string;
    lastName: string;
    isMobile: boolean;
    pendingSignup: boolean;
    avatarUrls: { __typename?: 'AvatarUrl'; origin?: string | null; small?: string | null };
    positions: Array<{
      __typename?: 'Position';
      details: { __typename?: 'PositionDetails'; id: number; name: string };
      agencyDetails?: { __typename?: 'AgencyPositionDetails'; openRate: any } | null;
    }>;
  };
};

export type ShiftSummaryViewTeamMembersQueryVariables = Exact<{
  byJaneIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type ShiftSummaryViewTeamMembersQuery = {
  __typename?: 'Query';
  fetchJanes: {
    __typename?: 'JaneConnection';
    nodes: Array<{
      __typename?: 'Jane';
      firstName: string;
      lastName: string;
      isMobile: boolean;
      pendingSignup: boolean;
      id: string;
      avatarUrls: { __typename?: 'AvatarUrl'; origin?: string | null };
    }>;
  };
};

export type ShiftsCalendarPageQueryVariables = Exact<{
  groupBy: Array<GroupCountableOrderAttributes> | GroupCountableOrderAttributes;
  filter?: InputMaybe<FilterableOrderAttributes>;
}>;

export type ShiftsCalendarPageQuery = {
  __typename?: 'Query';
  groupCountOrders: Array<{
    __typename?: 'GroupCountedOrders';
    group: { __typename?: 'Reflected'; fieldName: string; fieldType: string; fieldValue: any };
    counted: Array<{
      __typename?: 'Counted';
      value: number;
      subGroups: Array<{
        __typename?: 'Reflected';
        fieldName: string;
        fieldType: string;
        fieldValue: any;
      }>;
    }>;
  }>;
};

export type ShiftPageDaySelectionQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortableOrderAttributes> | SortableOrderAttributes>;
  filter?: InputMaybe<FilterableOrderAttributes>;
}>;

export type ShiftPageDaySelectionQuery = {
  __typename?: 'Query';
  fetchOrders: {
    __typename?: 'OrderConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      startCursor?: string | null;
      hasPreviousPage: boolean;
      hasNextPage: boolean;
    };
    edges: Array<{
      __typename?: 'OrderEdge';
      node?: {
        __typename?: 'Order';
        allowOvertime: boolean;
        biddable: boolean;
        biddingTimeEndsAt?: any | null;
        awardingTimeStartsAt?: any | null;
        priority: OrderPriorityEnum;
        autoRebid: boolean;
        isReviewAllowed: boolean;
        canSendToAgency: boolean;
        sentToAgencies: boolean;
        acceptedBySharedTeamMember?: boolean | null;
        startAt?: any | null;
        endAt?: any | null;
        createdAt: any;
        dedicated: boolean;
        id: number;
        orderSchedule: { __typename?: 'OrderSchedule'; id: number };
        bidders: Array<{ __typename?: 'Jane'; firstName: string; lastName: string; id: string }>;
        activities: Array<{
          __typename?: 'OrderActivity';
          event: { __typename?: 'Event'; name: ActivityEventEnum };
        }>;
        currentlyActiveCalloutList?: {
          __typename?: 'CalloutList';
          id: string;
          isCompleted: boolean;
          createdAt: any;
          updatedAt: any;
          totalJanes: number;
          waitingForManualApproval: boolean;
          estimatedCompletedAt?: any | null;
          totalNotifiedAndSkipped: number;
        } | null;
        status: { __typename?: 'OrderStatus'; name: any; value: OrderStatusEnum };
        community: {
          __typename: 'Community';
          id: number;
          name: string;
          location?: { __typename?: 'Location'; timeZone?: string | null } | null;
        };
        position: { __typename?: 'PositionDetails'; name: string };
        mainJane?: {
          __typename?: 'Jane';
          firstName: string;
          lastName: string;
          isMobile: boolean;
          pendingSignup: boolean;
          id: string;
          primaryCommunity?: { __typename?: 'Community'; id: string } | null;
          avatarUrls: { __typename?: 'AvatarUrl'; small?: string | null };
          agencyCommunity?: { __typename?: 'AgencyCommunity'; id: number } | null;
        } | null;
        recurrence?: {
          __typename?: 'Recurrence';
          id: number;
          frequency?: RecurringFrequencyEnum | null;
        } | null;
      } | null;
    }>;
  };
};

export type ShiftsListPageQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortableOrderAttributes> | SortableOrderAttributes>;
  filter?: InputMaybe<FilterableOrderAttributes>;
}>;

export type ShiftsListPageQuery = {
  __typename?: 'Query';
  fetchOrders: {
    __typename?: 'OrderConnection';
    pageCount: number;
    totalCount: number;
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      startCursor?: string | null;
      hasPreviousPage: boolean;
      hasNextPage: boolean;
    };
    edges: Array<{
      __typename?: 'OrderEdge';
      cursor: string;
      node?: {
        __typename?: 'Order';
        totalDuration?: number | null;
        dedicated: boolean;
        allowOvertime: boolean;
        biddable: boolean;
        biddingTimeEndsAt?: any | null;
        awardingTimeStartsAt?: any | null;
        acceptedBySharedTeamMember?: boolean | null;
        sentToAgencies: boolean;
        startAt?: any | null;
        endAt?: any | null;
        createdAt: any;
        id: number;
        rate?: {
          __typename?: 'OrderRate';
          min?: number | null;
          max?: number | null;
          rateLabel: any;
        } | null;
        bidders: Array<{ __typename?: 'Jane'; firstName: string; lastName: string; id: string }>;
        estimatedTotalCharge?: {
          __typename?: 'OrderRate';
          max?: number | null;
          min?: number | null;
          rateLabel: any;
        } | null;
        orderSchedule: {
          __typename?: 'OrderSchedule';
          id: number;
          breakTime: string;
          totalTime?: number | null;
        };
        status: { __typename?: 'OrderStatus'; name: any; value: OrderStatusEnum };
        recurrence?: { __typename?: 'Recurrence'; id: number } | null;
        community: {
          __typename: 'Community';
          id: number;
          name: string;
          location?: {
            __typename?: 'Location';
            city?: string | null;
            state?: string | null;
            timeZone?: string | null;
          } | null;
        };
        position: { __typename?: 'PositionDetails'; name: string };
        mainJane?: {
          __typename?: 'Jane';
          firstName: string;
          lastName: string;
          isMobile: boolean;
          pendingSignup: boolean;
          id: string;
          primaryCommunity?: { __typename?: 'Community'; id: string } | null;
          avatarUrls: { __typename?: 'AvatarUrl'; small?: string | null };
          agencyCommunity?: { __typename?: 'AgencyCommunity'; id: number; name: string } | null;
        } | null;
      } | null;
    }>;
  };
};

export type TeamMemberPageQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  external?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<FilterableJaneAttributes>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortableJanesAttributes> | SortableJanesAttributes>;
}>;

export type TeamMemberPageQuery = {
  __typename?: 'Query';
  fetchJanes: {
    __typename?: 'JaneConnection';
    pageCount: number;
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      startCursor?: string | null;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
    edges: Array<{
      __typename?: 'JaneEdge';
      node?: {
        __typename?: 'Jane';
        firstName: string;
        lastName: string;
        isMobile: boolean;
        pendingSignup: boolean;
        employeeNumber?: string | null;
        phone?: string | null;
        email: string;
        organizationSeniorityRanking?: number | null;
        lastActivityAt?: any | null;
        id: string;
        avatarUrls: { __typename?: 'AvatarUrl'; origin?: string | null };
        primaryPosition?: {
          __typename?: 'Position';
          details: { __typename?: 'PositionDetails'; name: string };
        } | null;
        positions: Array<{
          __typename?: 'Position';
          details: { __typename?: 'PositionDetails'; name: string };
        }>;
        secondaryPositions: Array<{
          __typename?: 'Position';
          details: { __typename?: 'PositionDetails'; id: number; name: string };
        }>;
        secondaryCommunities: Array<{ __typename?: 'Community'; name: string; displayId: string }>;
        primaryCommunity?: { __typename?: 'Community'; name: string; displayId: string } | null;
        employmentStatus: { __typename?: 'EmploymentStatus'; name: UserEmploymentStatusEnum };
        accessStatus: { __typename?: 'AccessStatus'; name: AccessStatusEnum };
        rankingSeniorityDate?: {
          __typename?: 'RankingSeniorityDate';
          seniorityDays: number;
          seniorityHours: number;
          seniorityMonths: number;
          seniorityYears: number;
        } | null;
      } | null;
    }>;
  };
};

export type TeamMemberPageSenorityMethodQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
}>;

export type TeamMemberPageSenorityMethodQuery = {
  __typename?: 'Query';
  fetchCommunity: {
    __typename?: 'Community';
    organization?: {
      __typename?: 'Organization';
      id: number;
      name: string;
      seniorityMethod: SeniorityMethodEnum;
    } | null;
  };
};

export type TeamMemberCountQueryVariables = Exact<{
  byPositionId?: InputMaybe<Scalars['Int']['input']>;
  byFacilityId?: InputMaybe<Scalars['Int']['input']>;
  isDedicated?: InputMaybe<Scalars['Boolean']['input']>;
  byStartTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  byEndTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  allowOvertime?: InputMaybe<Scalars['Boolean']['input']>;
  breakTime?: InputMaybe<Scalars['String']['input']>;
}>;

export type TeamMemberCountQuery = {
  __typename?: 'Query';
  requestJanes: { __typename?: 'JaneConnection'; totalCount: number };
};

export type TeamMembersPageFetchJanesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  byMultipleFields?: InputMaybe<Scalars['String']['input']>;
  withServiceableCommunity?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  byAgencyCommunity?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  external?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Array<SortableJanesAttributes> | SortableJanesAttributes>;
}>;

export type TeamMembersPageFetchJanesQuery = {
  __typename?: 'Query';
  fetchJanes: {
    __typename?: 'JaneConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      startCursor?: string | null;
      hasPreviousPage: boolean;
      hasNextPage: boolean;
    };
    edges: Array<{
      __typename?: 'JaneEdge';
      node?: {
        __typename?: 'Jane';
        firstName: string;
        lastName: string;
        isMobile: boolean;
        organizationSeniorityRanking?: number | null;
        pendingSignup: boolean;
        id: string;
        primaryCommunity?: { __typename?: 'Community'; id: string } | null;
        agencyCommunity?: { __typename?: 'AgencyCommunity'; id: number } | null;
        accessStatus: { __typename?: 'AccessStatus'; name: AccessStatusEnum };
        avatarUrls: { __typename?: 'AvatarUrl'; small?: string | null };
      } | null;
    }>;
  };
};

export type TimeFrameLocationSettingsPageQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
}>;

export type TimeFrameLocationSettingsPageQuery = {
  __typename?: 'Query';
  fetchCommunity: {
    __typename?: 'Community';
    id: number;
    timeFrame: {
      __typename?: 'TimeFrame';
      morningStartsAt: string;
      eveningStartsAt: string;
      nightStartsAt: string;
    };
  };
};

export type TimeOffFetchJaneQueryVariables = Exact<{
  janeId: Scalars['ID']['input'];
}>;

export type TimeOffFetchJaneQuery = {
  __typename?: 'Query';
  fetchJane: {
    __typename?: 'Jane';
    firstName: string;
    lastName: string;
    communityName: string;
    isMobile: boolean;
    pendingSignup: boolean;
    avatarUrls: { __typename?: 'AvatarUrl'; origin?: string | null; small?: string | null };
  };
};

export type TimeOffModalFetchTimeOffByIdQueryVariables = Exact<{
  timeOffId: Scalars['ID']['input'];
}>;

export type TimeOffModalFetchTimeOffByIdQuery = {
  __typename?: 'Query';
  fetchTimeOff: {
    __typename?: 'TimeOff';
    id: string;
    displayId: number;
    isEditable: boolean;
    startTime: any;
    endTime: any;
    notes: string;
    activities: Array<{
      __typename?: 'TimeOffActivity';
      createdAt: any;
      user?:
        | {
            __typename?: 'Admin';
            firstName: string;
            lastName: string;
            avatarUrls: { __typename?: 'AvatarUrl'; origin?: string | null };
          }
        | {
            __typename?: 'AgencyUser';
            firstName: string;
            lastName: string;
            avatarUrls: { __typename?: 'AvatarUrl'; origin?: string | null };
          }
        | {
            __typename?: 'B2bCustomer';
            firstName: string;
            lastName: string;
            avatarUrls: { __typename?: 'AvatarUrl'; origin?: string | null };
          }
        | {
            __typename?: 'Jane';
            firstName: string;
            lastName: string;
            communityName: string;
            isMobile: boolean;
            pendingSignup: boolean;
            avatarUrls: { __typename?: 'AvatarUrl'; origin?: string | null };
          }
        | {
            __typename?: 'SecondaryUser';
            firstName: string;
            lastName: string;
            avatarUrls: { __typename?: 'AvatarUrl'; origin?: string | null };
          }
        | {
            __typename?: 'User';
            firstName: string;
            lastName: string;
            communityName: string;
            title: string;
            isMobile: boolean;
            avatarUrls: { __typename?: 'AvatarUrl'; origin?: string | null };
          }
        | null;
      event: { __typename?: 'Event'; name: ActivityEventEnum; value: any };
      metadata?: {
        __typename?: 'ActivitiesMetaValue';
        calloutListId?: string | null;
        qualifiedAgencyJanesCount?: number | null;
        reasonCategory?: string | null;
        reasonMessage?: string | null;
        acceptedFor?: { __typename?: 'AcceptedFor'; name: string } | null;
        feedableEdits?: Array<{
          __typename?: 'FeedableEditMetaValue';
          fieldName?: string | null;
          fieldType?: FeedableEditDropdownEnum | null;
          oldValuePretty?: string | null;
          newValuePretty?: string | null;
          newValue?: string | null;
          oldValue?: string | null;
        }> | null;
      } | null;
    }>;
    community: { __typename?: 'Community'; displayId: string; name: string };
    customFields: Array<{
      __typename?: 'CustomFieldValue';
      name: string;
      value: string;
      customFieldId: number;
    }>;
    jane: {
      __typename?: 'Jane';
      isMobile: boolean;
      pendingSignup: boolean;
      communityName: string;
      firstName: string;
      lastName: string;
      id: string;
      avatarUrls: { __typename?: 'AvatarUrl'; origin?: string | null; small?: string | null };
    };
    title: { __typename?: 'TimeOffTitle'; name: TimeOffTitleEnum; value: any };
  };
};

export type TimesheetCardQueryVariables = Exact<{
  orderScheduleId: Scalars['Int']['input'];
}>;

export type TimesheetCardQuery = {
  __typename?: 'Query';
  fetchTimeSheet: {
    __typename?: 'OrderSchedule';
    id: number;
    startTime: any;
    endTime: any;
    status: OrderScheduleStatusEnum;
    totalTime?: number | null;
    order: {
      __typename?: 'Order';
      dedicated: boolean;
      allowOvertime: boolean;
      id: number;
      orderSchedule: { __typename?: 'OrderSchedule'; id: number };
      community: {
        __typename: 'Community';
        id: number;
        name: string;
        location?: { __typename?: 'Location'; timeZone?: string | null } | null;
      };
      status: { __typename?: 'OrderStatus'; value: OrderStatusEnum; name: any };
      position: { __typename?: 'PositionDetails'; name: string };
    };
    mainJane?: {
      __typename?: 'Jane';
      firstName: string;
      lastName: string;
      isMobile: boolean;
      pendingSignup: boolean;
      communityName: string;
      avatarUrls: { __typename?: 'AvatarUrl'; small?: string | null };
      agencyCommunity?: { __typename?: 'AgencyCommunity'; name: string; id: number } | null;
    } | null;
    timeSheet?: {
      __typename?: 'TimeSheet';
      id: number;
      clockIn?: any | null;
      clockInOffSite: boolean;
      clockOutOffSite: boolean;
      clockOut?: any | null;
      isEdited: boolean;
      approvedAt?: any | null;
      approvedBy?: string | null;
      approvedStartTime?: any | null;
      approvedEndTime?: any | null;
      approvedUnpaidBreakTime?: string | null;
      updatedAt: any;
      status: { __typename?: 'TimeSheetStatus'; name: any; value: TimeSheetStatusEnum };
      clockInStatus?: {
        __typename: 'ClockInStatus';
        prettyValue: any;
        value: ClockInStatusEnum;
      } | null;
      clockOutStatus?: {
        __typename: 'ClockOutStatus';
        prettyValue: any;
        value: ClockOutStatusEnum;
      } | null;
      approvedCustomerCost?: {
        __typename?: 'Currency';
        rawCurrency?: number | null;
        currency?: any | null;
      } | null;
    } | null;
  };
};

export type TimesheetsPageQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<SortableTimeSheetAttributes> | SortableTimeSheetAttributes>;
  filter?: InputMaybe<FilterableTimeSheetAttributes>;
}>;

export type TimesheetsPageQuery = {
  __typename?: 'Query';
  fetchTimeSheets: {
    __typename?: 'OrderScheduleConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      startCursor?: string | null;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
    edges: Array<{
      __typename?: 'OrderScheduleEdge';
      cursor: string;
      node?: {
        __typename?: 'OrderSchedule';
        id: number;
        startTime: any;
        endTime: any;
        status: OrderScheduleStatusEnum;
        totalTime?: number | null;
        order: {
          __typename?: 'Order';
          dedicated: boolean;
          id: number;
          orderSchedule: { __typename?: 'OrderSchedule'; id: number };
          community: {
            __typename: 'Community';
            id: number;
            name: string;
            location?: { __typename?: 'Location'; timeZone?: string | null } | null;
          };
          position: { __typename?: 'PositionDetails'; name: string };
        };
        mainJane?: {
          __typename?: 'Jane';
          firstName: string;
          lastName: string;
          isMobile: boolean;
          pendingSignup: boolean;
          communityName: string;
          avatarUrls: { __typename?: 'AvatarUrl'; small?: string | null };
          agencyCommunity?: { __typename?: 'AgencyCommunity'; name: string; id: number } | null;
        } | null;
        timeSheet?: {
          __typename?: 'TimeSheet';
          id: number;
          clockInOffSite: boolean;
          clockOutOffSite: boolean;
          clockIn?: any | null;
          clockOut?: any | null;
          isEdited: boolean;
          approvedAt?: any | null;
          approvedBy?: string | null;
          approvedStartTime?: any | null;
          approvedEndTime?: any | null;
          approvedUnpaidBreakTime?: string | null;
          updatedAt: any;
          status: { __typename?: 'TimeSheetStatus'; name: any; value: TimeSheetStatusEnum };
          clockInStatus?: {
            __typename: 'ClockInStatus';
            prettyValue: any;
            value: ClockInStatusEnum;
          } | null;
          clockOutStatus?: {
            __typename: 'ClockOutStatus';
            prettyValue: any;
            value: ClockOutStatusEnum;
          } | null;
          approvedCustomerCost?: {
            __typename?: 'Currency';
            rawCurrency?: number | null;
            currency?: any | null;
          } | null;
        } | null;
      } | null;
    }>;
  };
};

export type UserProfilePageQueryVariables = Exact<{ [key: string]: never }>;

export type UserProfilePageQuery = {
  __typename?: 'Query';
  me:
    | {
        __typename?: 'AgencyUser';
        id: string;
        firstName: string;
        lastName: string;
        phone?: string | null;
        email: string;
        locale: string;
      }
    | {
        __typename?: 'B2bCustomer';
        id: string;
        adpCustomIdentifier?: string | null;
        firstName: string;
        lastName: string;
        phone?: string | null;
        email: string;
        locale: string;
      }
    | { __typename?: 'Jane' }
    | {
        __typename?: 'SecondaryUser';
        id: string;
        adpCustomIdentifier?: string | null;
        firstName: string;
        lastName: string;
        phone?: string | null;
        email: string;
        locale: string;
      };
};

export type WeeklyDashboardNeedsAttentionQueryVariables = Exact<{
  filterTimesheets?: InputMaybe<FilterableTimeSheetAttributes>;
}>;

export type WeeklyDashboardNeedsAttentionQuery = {
  __typename?: 'Query';
  timeSheets: { __typename?: 'OrderScheduleConnection'; totalCount: number };
  timeOffs: { __typename?: 'TimeOffConnection'; totalCount: number };
};

export type WeeklyDashboardNeedsAttentionBiddingShiftsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  sortOrders?: InputMaybe<Array<SortableOrderAttributes> | SortableOrderAttributes>;
  Biddablefilter?: InputMaybe<FilterableOrderAttributes>;
}>;

export type WeeklyDashboardNeedsAttentionBiddingShiftsQuery = {
  __typename?: 'Query';
  biddableShifts: {
    __typename?: 'OrderConnection';
    totalCount: number;
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      startCursor?: string | null;
      hasPreviousPage: boolean;
      hasNextPage: boolean;
    };
    nodes: Array<{
      __typename?: 'Order';
      biddable: boolean;
      biddingTimeEndsAt?: any | null;
      awardingTimeStartsAt?: any | null;
      priority: OrderPriorityEnum;
      isReviewAllowed: boolean;
      canSendToAgency: boolean;
      canAssign: boolean;
      autoRebid: boolean;
      acceptedBySharedTeamMember?: boolean | null;
      sentToAgencies: boolean;
      dedicated: boolean;
      allowOvertime: boolean;
      auditTrailVersion: AuditTrailVersionEnum;
      startAt?: any | null;
      endAt?: any | null;
      id: number;
      bidders: Array<{ __typename?: 'Jane'; firstName: string; lastName: string; id: string }>;
      orderSchedule: { __typename?: 'OrderSchedule'; id: number };
      activities: Array<{
        __typename?: 'OrderActivity';
        event: { __typename?: 'Event'; name: ActivityEventEnum };
      }>;
      currentlyActiveCalloutList?: {
        __typename?: 'CalloutList';
        id: string;
        isCompleted: boolean;
        createdAt: any;
        updatedAt: any;
        totalJanes: number;
        waitingForManualApproval: boolean;
        estimatedCompletedAt?: any | null;
        totalNotifiedAndSkipped: number;
      } | null;
      status: { __typename?: 'OrderStatus'; name: any; value: OrderStatusEnum };
      community: {
        __typename?: 'Community';
        id: number;
        name: string;
        location?: { __typename?: 'Location'; timeZone?: string | null } | null;
      };
      position: { __typename?: 'PositionDetails'; name: string; id: number };
      mainJane?: {
        __typename?: 'Jane';
        firstName: string;
        lastName: string;
        isMobile: boolean;
        pendingSignup: boolean;
        id: string;
        primaryCommunity?: { __typename?: 'Community'; id: string } | null;
        avatarUrls: {
          __typename?: 'AvatarUrl';
          small?: string | null;
          origin?: string | null;
          large?: string | null;
        };
        agencyCommunity?: { __typename?: 'AgencyCommunity'; id: number } | null;
      } | null;
      recurrence?: {
        __typename?: 'Recurrence';
        id: number;
        frequency?: RecurringFrequencyEnum | null;
      } | null;
    }>;
  };
};

export type WeeklyDashboardNeedsAttentionUpcommingShiftsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  sortOrders?: InputMaybe<Array<SortableOrderAttributes> | SortableOrderAttributes>;
  filter?: InputMaybe<FilterableOrderAttributes>;
}>;

export type WeeklyDashboardNeedsAttentionUpcommingShiftsQuery = {
  __typename?: 'Query';
  upcomingShifts: {
    __typename?: 'OrderConnection';
    totalCount: number;
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      startCursor?: string | null;
      hasPreviousPage: boolean;
      hasNextPage: boolean;
    };
    nodes: Array<{
      __typename?: 'Order';
      biddable: boolean;
      biddingTimeEndsAt?: any | null;
      awardingTimeStartsAt?: any | null;
      priority: OrderPriorityEnum;
      isReviewAllowed: boolean;
      canSendToAgency: boolean;
      canAssign: boolean;
      autoRebid: boolean;
      acceptedBySharedTeamMember?: boolean | null;
      sentToAgencies: boolean;
      dedicated: boolean;
      allowOvertime: boolean;
      auditTrailVersion: AuditTrailVersionEnum;
      startAt?: any | null;
      endAt?: any | null;
      id: number;
      bidders: Array<{ __typename?: 'Jane'; firstName: string; lastName: string; id: string }>;
      orderSchedule: { __typename?: 'OrderSchedule'; id: number };
      activities: Array<{
        __typename?: 'OrderActivity';
        event: { __typename?: 'Event'; name: ActivityEventEnum };
      }>;
      currentlyActiveCalloutList?: {
        __typename?: 'CalloutList';
        id: string;
        isCompleted: boolean;
        createdAt: any;
        updatedAt: any;
        totalJanes: number;
        waitingForManualApproval: boolean;
        estimatedCompletedAt?: any | null;
        totalNotifiedAndSkipped: number;
      } | null;
      status: { __typename?: 'OrderStatus'; name: any; value: OrderStatusEnum };
      community: {
        __typename?: 'Community';
        id: number;
        name: string;
        location?: { __typename?: 'Location'; timeZone?: string | null } | null;
      };
      position: { __typename?: 'PositionDetails'; name: string; id: number };
      mainJane?: {
        __typename?: 'Jane';
        firstName: string;
        lastName: string;
        isMobile: boolean;
        pendingSignup: boolean;
        id: string;
        primaryCommunity?: { __typename?: 'Community'; id: string } | null;
        avatarUrls: {
          __typename?: 'AvatarUrl';
          small?: string | null;
          origin?: string | null;
          large?: string | null;
        };
        agencyCommunity?: { __typename?: 'AgencyCommunity'; id: number } | null;
      } | null;
      recurrence?: {
        __typename?: 'Recurrence';
        id: number;
        frequency?: RecurringFrequencyEnum | null;
      } | null;
    }>;
  };
};

export type WeeklyDashboardNeedsReviewQueryVariables = Exact<{
  communityId: Scalars['Int']['input'];
}>;

export type WeeklyDashboardNeedsReviewQuery = {
  __typename?: 'Query';
  needsReview: {
    __typename?: 'NeedsReview';
    pendingSignups: number;
    unpublishedShifts: number;
    flaggedTimeSheets: number;
    newThreads: number;
  };
};

export type WeeklyDashboardOverviewQueryVariables = Exact<{
  communityId: Scalars['Int']['input'];
}>;

export type WeeklyDashboardOverviewQuery = {
  __typename?: 'Query';
  dashboardWeeklyOverview: {
    __typename?: 'DashboardWeeklyOverview';
    pendingOrders: number;
    pendingOrdersToday: number;
    weekEndsAt: any;
    weekStartsAt: any;
    fulfillmentRate: number;
    fulfillmentRateChange: number;
    agencySpent: number;
    agencySpentChange: number;
    weeklyOvertimeHours: number;
    weeklyOvertimeHoursChange: number;
    dailyOvertimeHours: number;
  };
};

export type WeeklyDashboardTeamMembersTabQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterableOrderAttributes>;
  communityId: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SortableOrderAttributes> | SortableOrderAttributes>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;

export type WeeklyDashboardTeamMembersTabQuery = {
  __typename?: 'Query';
  fetchOrdersWithJanesMetadata: {
    __typename?: 'OrdersWithJanesMetadata';
    aggregateJanesByTypes: {
      __typename?: 'AggregateJanesByTypes';
      internal: number;
      shared: number;
      agency: number;
    };
    orders: {
      __typename?: 'OrderConnection';
      pageCount: number;
      pageInfo: {
        __typename?: 'PageInfo';
        endCursor?: string | null;
        startCursor?: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
      };
      nodes: Array<{
        __typename?: 'Order';
        id: number;
        position: { __typename?: 'PositionDetails'; name: string; id: number };
        status: { __typename?: 'OrderStatus'; name: any; value: OrderStatusEnum };
        orderSchedule: {
          __typename?: 'OrderSchedule';
          id: number;
          startTime: any;
          endTime: any;
          timeSheet?: {
            __typename?: 'TimeSheet';
            id: number;
            status: { __typename?: 'TimeSheetStatus'; name: any; value: TimeSheetStatusEnum };
            clockInStatus?: {
              __typename: 'ClockInStatus';
              prettyValue: any;
              value: ClockInStatusEnum;
            } | null;
          } | null;
        };
        mainJane?: {
          __typename?: 'Jane';
          id: string;
          firstName: string;
          lastName: string;
          isMobile: boolean;
          pendingSignup: boolean;
          accessStatus: { __typename?: 'AccessStatus'; name: AccessStatusEnum; value: any };
          avatarUrls: { __typename?: 'AvatarUrl'; origin?: string | null };
          agencyCommunity?: { __typename?: 'AgencyCommunity'; id: number } | null;
          primaryCommunity?: { __typename?: 'Community'; name: string; id: string } | null;
        } | null;
      }>;
    };
  };
};

export const CalloutListFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'calloutListFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CalloutList' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalJanes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalNotifiedAndSkipped' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingForManualApproval' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'estimatedCompletedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'manualApprovalIndexes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'groupName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'index' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'order' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'orderSchedule' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'biddable' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'timeZone' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'calloutListJanes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'currentPage' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'pageCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'calloutStatus' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'estimatedCalloutTime' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'jane' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'accessStatus' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'primaryCommunity' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUrls' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'large' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'employmentStatus' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'manualApproval' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'approvedAt' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'notifiedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notNotifiedLogs' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CalloutListFragmentFragment, unknown>;
export const Mutation_AssignAgencyTeamMemberAssignOrderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MUTATION_assignAgencyTeamMemberAssignOrder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'janeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignOrder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'orderId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'janeId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'janeId' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'clientMutationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Mutation_AssignAgencyTeamMemberAssignOrderMutation,
  Mutation_AssignAgencyTeamMemberAssignOrderMutationVariables
>;
export const Mutation_DeleteTimeOffByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MUTATION_deleteTimeOffById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'timeOffId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteTimeOff' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timeOffId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'timeOffId' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'clientMutationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Mutation_DeleteTimeOffByIdMutation,
  Mutation_DeleteTimeOffByIdMutationVariables
>;
export const Mutation_ManuallyApproveCalloutDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MUTATION_manuallyApproveCallout' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'calloutListId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'enableOvertime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'EnableOvertimeStrategyEnum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approveCallout' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'calloutListId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'calloutListId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'enableOvertime' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'enableOvertime' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'clientMutationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Mutation_ManuallyApproveCalloutMutation,
  Mutation_ManuallyApproveCalloutMutationVariables
>;
export const Mutation_UpdateOrganizationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MUTATION_updateOrganization' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'seniorityMethod' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SeniorityMethodEnum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateOrganization' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organizationId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organizationAttributes' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'seniorityMethod' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'seniorityMethod' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'seniorityMethod' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Mutation_UpdateOrganizationMutation,
  Mutation_UpdateOrganizationMutationVariables
>;
export const Query_AgencyFilterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'QUERY_agencyFilter' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchAgencies' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byName' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'byName' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Query_AgencyFilterQuery, Query_AgencyFilterQueryVariables>;
export const AgencyMemberPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'agencyMemberPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'external' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterableJaneAttributes' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortableJanesAttributes' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchJanes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'external' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'external' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'displayId' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'agencyCommunity' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUrls' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'primaryPosition' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'details' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'positions' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'details' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'employmentStatus' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'accessStatus' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'pageCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AgencyMemberPageQuery, AgencyMemberPageQueryVariables>;
export const AssignToAgencyTeamMemberFetchAgencyJaneAvailabilityByJaneIdOrderIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {
        kind: 'Name',
        value: 'assignToAgencyTeamMemberFetchAgencyJaneAvailabilityByJaneIdOrderId',
      },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'janeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderRelayId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'breakTime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchOrder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'displayId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'canAssign' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestJanes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byId' },
                      value: {
                        kind: 'ListValue',
                        values: [{ kind: 'Variable', name: { kind: 'Name', value: 'janeId' } }],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'relevantForOrder' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'orderId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'orderRelayId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'withBreakTime' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'breakTime' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'displayId' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssignToAgencyTeamMemberFetchAgencyJaneAvailabilityByJaneIdOrderIdQuery,
  AssignToAgencyTeamMemberFetchAgencyJaneAvailabilityByJaneIdOrderIdQueryVariables
>;
export const AssignToAgencyTeamMemberFetchAgencyJaneByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'assignToAgencyTeamMemberFetchAgencyJaneById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'janeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchJane' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'janeId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relayId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'avatarUrls' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'agencyCommunity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agency' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssignToAgencyTeamMemberFetchAgencyJaneByIdQuery,
  AssignToAgencyTeamMemberFetchAgencyJaneByIdQueryVariables
>;
export const AssignToAgencyTeamMemberFetchAgencyJanesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'assignToAgencyTeamMemberFetchAgencyJanes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byMultipleFields' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byPositionId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byAgencyCommunityId' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'breakTime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestJanes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byMultipleFields' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'byMultipleFields' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byAgencyCommunity' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'byAgencyCommunityId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'relevantForOrder' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'orderId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'withBreakTime' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'breakTime' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agencyCommunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'agency' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'displayId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customerReviews' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'averageRating' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUrls' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'origin' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'positions' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'filter' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'forDetails' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'byAgencyServicedPosition' },
                                        value: {
                                          kind: 'Variable',
                                          name: { kind: 'Name', value: 'byPositionId' },
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'details' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'janePayout' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'agencyDetails' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'openRate' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssignToAgencyTeamMemberFetchAgencyJanesQuery,
  AssignToAgencyTeamMemberFetchAgencyJanesQueryVariables
>;
export const AssignToAgencyTeamMemberFetchAgencyJanesCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'assignToAgencyTeamMemberFetchAgencyJanesCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byAgencyCommunityId' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'breakTime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestJanes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byAgencyCommunity' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'byAgencyCommunityId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'relevantForOrder' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'orderId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'withBreakTime' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'breakTime' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'totalCount' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssignToAgencyTeamMemberFetchAgencyJanesCountQuery,
  AssignToAgencyTeamMemberFetchAgencyJanesCountQueryVariables
>;
export const AvailableShiftsMapViewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'availableShiftsMapView' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterableOrderAttributes' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'aggregateOrdersByLocation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'group' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'communityId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AvailableShiftsMapViewQuery, AvailableShiftsMapViewQueryVariables>;
export const AvailableTeamMembersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'availableTeamMembers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchOrder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'community' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'orderAvailabilities' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'first' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'last' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'after' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'before' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageInfo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'jane' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'id' },
                                    name: { kind: 'Name', value: 'displayId' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'shorthandName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'communityName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatarUrls' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'belongsToPool' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AvailableTeamMembersQuery, AvailableTeamMembersQueryVariables>;
export const B2bDepartmentsNavigationFetchDepartmentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'b2bDepartmentsNavigationFetchDepartments' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'B2bCustomer' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'serviceablePositions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'department' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SecondaryUser' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'serviceablePositions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'department' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  B2bDepartmentsNavigationFetchDepartmentsQuery,
  B2bDepartmentsNavigationFetchDepartmentsQueryVariables
>;
export const B2bPositionsSettingsPageFetchLocationsPerPositionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'b2bPositionsSettingsPageFetchLocationsPerPosition' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'positionId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchPosition' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'positionId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceableCommunities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'displayId' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  B2bPositionsSettingsPageFetchLocationsPerPositionQuery,
  B2bPositionsSettingsPageFetchLocationsPerPositionQueryVariables
>;
export const B2bPositionsSettingsPageFetchPositionsByDepartmentIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'b2bPositionsSettingsPageFetchPositionsByDepartmentId' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'B2bCustomer' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'serviceablePositions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'department' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'openShiftPolicy' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'serviceableCommunities' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SecondaryUser' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'serviceablePositions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'department' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'openShiftPolicy' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SecondaryUser' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'serviceablePositions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'department' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'openShiftPolicy' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'serviceableCommunities' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  B2bPositionsSettingsPageFetchPositionsByDepartmentIdQuery,
  B2bPositionsSettingsPageFetchPositionsByDepartmentIdQueryVariables
>;
export const CommunityBudgetAllocationsForPositionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'communityBudgetAllocationsForPosition' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'positionId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCommunity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeBudgetAllocation' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'forPosition' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'positionId' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'occupancy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'morningErrorMargin' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'morningRatio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eveningErrorMargin' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eveningRatio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nightErrorMargin' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nightRatio' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextBudgetAllocation' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'forPosition' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'positionId' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'occupancy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'morningErrorMargin' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'morningRatio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eveningErrorMargin' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eveningRatio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nightErrorMargin' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nightRatio' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CommunityBudgetAllocationsForPositionQuery,
  CommunityBudgetAllocationsForPositionQueryVariables
>;
export const CommunityCustomFieldsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'communityCustomFields' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'FilterableCustomFieldAttributes' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCustomFields' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobile' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prefillDefault' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastEditedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customFieldOptions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'communities' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organization' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'activities' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CommunityCustomFieldsQuery, CommunityCustomFieldsQueryVariables>;
export const CommunityGroupsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'communityGroups' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterableGroupAttributes' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCommunity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'groups' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'first' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'last' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'after' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'before' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'StaticGroup' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'DynamicGroup' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'pageCount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageInfo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CommunityGroupsQuery, CommunityGroupsQueryVariables>;
export const CommunityLocationsSettingsPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'communityLocationsSettingsPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PositionTypeEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderFilter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterableOrderAttributes' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'teamMemberFilter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterableJaneAttributes' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCommunity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locationPositions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'department' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamMembers' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'filter' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'teamMemberFilter' },
                            },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'type' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'configuredShifts' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'filter' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'orderFilter' },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CommunityLocationsSettingsPageQuery,
  CommunityLocationsSettingsPageQueryVariables
>;
export const CommunityTimeFramesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'communityTimeFrames' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCommunity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'timeFrame' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'eveningStartsAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'morningStartsAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nightStartsAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CommunityTimeFramesQuery, CommunityTimeFramesQueryVariables>;
export const CompanyProfilePageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'companyProfilePage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AgencyUser' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agency' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'directDeposit' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'chequeImageUrl' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'hstNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'liability' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'coverageAmount' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'insuranceNumber' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'licenceNumber' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'insuranceDocuments' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'documentUrls' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'origin' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastEditedBy' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'AgencyUser' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'firstName' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'lastName' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'User' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'displayId' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'firstName' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'lastName' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'B2bCustomer' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'communities' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'location' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'fullAddress' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'flat' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'main' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompanyProfilePageQuery, CompanyProfilePageQueryVariables>;
export const ContinueCalloutDialogDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'continueCalloutDialog' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchOrder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'displayId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'allowOvertime' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currentlyActiveCalloutList' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'manualApprovalIndexes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'groupName' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContinueCalloutDialogQuery, ContinueCalloutDialogQueryVariables>;
export const CreateCustomFieldFetchCommunitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'createCustomFieldFetchCommunities' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'withId' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'SortableCommunityAttributes' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCommunities' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byName' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'byName' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'withId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'withId' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateCustomFieldFetchCommunitiesQuery,
  CreateCustomFieldFetchCommunitiesQueryVariables
>;
export const RequestTeamMemberViewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'requestTeamMemberView' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'external' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortableJanesAttributes' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byEmploymentStatus' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'UserEmploymentStatusEnum' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byMultipleFields' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byPositionIdArray' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byPositionIdInt' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byFacilityId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byAgency' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isDedicated' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byStartTime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ISO8601DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byEndTime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ISO8601DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'allowOvertime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'breakTime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestJanes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'external' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'external' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byAgency' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'byAgency' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byMultipleFields' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'byMultipleFields' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byEmploymentStatus' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'byEmploymentStatus' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'relevantForOrder' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byPositionId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'byPositionIdInt' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byFacilityId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'byFacilityId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'isDedicated' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'isDedicated' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byStartTime' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'byStartTime' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byEndTime' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'byEndTime' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'allowOvertime' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'allowOvertime' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'withBreakTime' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'breakTime' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'displayId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agencyCommunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'agency' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUrls' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'origin' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'primaryCommunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customerReviews' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'averageRating' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'primaryPosition' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'agencyDetails' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'openRate' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'positions' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'filter' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'forDetails' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'byId' },
                                        value: {
                                          kind: 'Variable',
                                          name: { kind: 'Name', value: 'byPositionIdArray' },
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'details' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'janePayout' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'agencyDetails' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'openRate' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RequestTeamMemberViewQuery, RequestTeamMemberViewQueryVariables>;
export const RequestTeamMemberRecurringViewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'requestTeamMemberRecurringView' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'external' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortableJanesAttributes' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byEmploymentStatus' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'UserEmploymentStatusEnum' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byMultipleFields' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byPositionIdArray' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byPositionIdInt' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byFacilityId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byAgency' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'recurring' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RecurringOrderAttributes' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isDedicated' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byStartTime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ISO8601DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byEndTime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ISO8601DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'breakTime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestJanes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'external' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'external' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byAgency' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'byAgency' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byMultipleFields' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'byMultipleFields' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byEmploymentStatus' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'byEmploymentStatus' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'relevantForOrder' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byPositionId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'byPositionIdInt' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byFacilityId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'byFacilityId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'isDedicated' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'isDedicated' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byStartTime' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'byStartTime' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byEndTime' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'byEndTime' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'allowOvertime' },
                      value: { kind: 'BooleanValue', value: false },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'withBreakTime' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'breakTime' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'displayId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agencyCommunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'agency' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUrls' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'origin' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'primaryCommunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customerReviews' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'averageRating' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'primaryPosition' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'agencyDetails' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'openRate' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conflictingDays' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'recurring' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'recurring' } },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'positions' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'filter' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'forDetails' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'byId' },
                                        value: {
                                          kind: 'Variable',
                                          name: { kind: 'Name', value: 'byPositionIdArray' },
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'details' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'janePayout' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'agencyDetails' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'openRate' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RequestTeamMemberRecurringViewQuery,
  RequestTeamMemberRecurringViewQueryVariables
>;
export const CustomFieldsSettingsFetchCustomFieldsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'customFieldsSettingsFetchCustomFields' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCustomFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'allFacilities' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobile' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'communities' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastEditedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CustomFieldsSettingsFetchCustomFieldsQuery,
  CustomFieldsSettingsFetchCustomFieldsQueryVariables
>;
export const FetchFacilitiesCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchFacilitiesCount' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCommunities' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchFacilitiesCountQuery, FetchFacilitiesCountQueryVariables>;
export const DashboardAvailableShiftsPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'dashboardAvailableShiftsPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sortOrders' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortableOrderAttributes' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterableOrderAttributes' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fastGroupOrders' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'groupBy' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'field' },
                      value: { kind: 'EnumValue', value: 'startDate' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortOrders' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sortOrders' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'group' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'orders' },
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'orderSchedule' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'allowOvertime' } },
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'displayId' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'dedicated' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isReviewAllowed' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canSendToAgency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canAssign' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'acceptedBySharedTeamMember' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'sentToAgencies' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'community' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'location' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'timeZone' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'position' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mainJane' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'id' },
                                    name: { kind: 'Name', value: 'displayId' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'primaryCommunity' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          alias: { kind: 'Name', value: 'id' },
                                          name: { kind: 'Name', value: 'displayId' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatarUrls' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'large' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'agencyCommunity' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'review' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'recurrence' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DashboardAvailableShiftsPageQuery,
  DashboardAvailableShiftsPageQueryVariables
>;
export const DashboardMyUpcomingShiftsPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'dashboardMyUpcomingShiftsPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sortOrders' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortableOrderAttributes' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterableOrderAttributes' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fastGroupOrders' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'groupBy' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'field' },
                      value: { kind: 'EnumValue', value: 'startDate' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortOrders' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sortOrders' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'group' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'orders' },
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'orderSchedule' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'displayId' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'dedicated' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isReviewAllowed' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canSendToAgency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canAssign' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'acceptedBySharedTeamMember' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'sentToAgencies' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'community' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'location' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'timeZone' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'position' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mainJane' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'id' },
                                    name: { kind: 'Name', value: 'displayId' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'primaryCommunity' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          alias: { kind: 'Name', value: 'id' },
                                          name: { kind: 'Name', value: 'displayId' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatarUrls' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'large' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'agencyCommunity' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'review' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'recurrence' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DashboardMyUpcomingShiftsPageQuery,
  DashboardMyUpcomingShiftsPageQueryVariables
>;
export const DashboardPastShiftsPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'dashboardPastShiftsPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sortOrders' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortableOrderAttributes' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterableOrderAttributes' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fastGroupOrders' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'groupBy' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'field' },
                      value: { kind: 'EnumValue', value: 'startDate' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortOrders' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sortOrders' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'group' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'orders' },
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'currentlyActiveCalloutList' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isCompleted' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalJanes' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'waitingForManualApproval' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'estimatedCompletedAt' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'totalNotifiedAndSkipped' },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'biddable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'biddingTimeEndsAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'awardingTimeStartsAt' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'bidders' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'id' },
                                    name: { kind: 'Name', value: 'displayId' },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'autoRebid' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'orderSchedule' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'activities' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'event' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'allowOvertime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'auditTrailVersion' } },
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'displayId' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'canAssign' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isReviewAllowed' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canSendToAgency' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'acceptedBySharedTeamMember' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'sentToAgencies' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'dedicated' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'community' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'location' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'timeZone' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'position' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mainJane' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'id' },
                                    name: { kind: 'Name', value: 'displayId' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'primaryCommunity' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          alias: { kind: 'Name', value: 'id' },
                                          name: { kind: 'Name', value: 'displayId' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatarUrls' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: '__typename' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'large' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'agencyCommunity' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: '__typename' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'review' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'recurrence' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DashboardPastShiftsPageQuery, DashboardPastShiftsPageQueryVariables>;
export const DashboardRecentlyCreatedShiftsPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'dashboardRecentlyCreatedShiftsPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sortOrders' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortableOrderAttributes' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterableOrderAttributes' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fastGroupOrders' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'groupBy' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'field' },
                      value: { kind: 'EnumValue', value: 'createdAt' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortOrders' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sortOrders' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'group' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'orders' },
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'currentlyActiveCalloutList' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isCompleted' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalJanes' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'waitingForManualApproval' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'estimatedCompletedAt' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'totalNotifiedAndSkipped' },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'biddable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'biddingTimeEndsAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'awardingTimeStartsAt' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'bidders' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'id' },
                                    name: { kind: 'Name', value: 'displayId' },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'autoRebid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'orderSchedule' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'allowOvertime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'auditTrailVersion' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dedicated' } },
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'displayId' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'isReviewAllowed' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canSendToAgency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canAssign' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'acceptedBySharedTeamMember' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'sentToAgencies' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'activities' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'event' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'community' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'location' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'timeZone' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'position' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mainJane' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'id' },
                                    name: { kind: 'Name', value: 'displayId' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'primaryCommunity' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          alias: { kind: 'Name', value: 'id' },
                                          name: { kind: 'Name', value: 'displayId' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatarUrls' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'large' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'agencyCommunity' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'review' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'recurrence' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DashboardRecentlyCreatedShiftsPageQuery,
  DashboardRecentlyCreatedShiftsPageQueryVariables
>;
export const TodaysTeamMemberTimeframesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'todaysTeamMemberTimeframes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCommunity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'timeFrame' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'morningStartsAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eveningStartsAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nightStartsAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TodaysTeamMemberTimeframesQuery,
  TodaysTeamMemberTimeframesQueryVariables
>;
export const DashboardUpcomingShiftsPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'dashboardUpcomingShiftsPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sortOrders' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortableOrderAttributes' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterableOrderAttributes' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fastGroupOrders' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'groupBy' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'field' },
                      value: { kind: 'EnumValue', value: 'startDate' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortOrders' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sortOrders' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'group' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'orders' },
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'currentlyActiveCalloutList' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isCompleted' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalJanes' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'waitingForManualApproval' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'estimatedCompletedAt' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'totalNotifiedAndSkipped' },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'biddable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'biddingTimeEndsAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'awardingTimeStartsAt' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'bidders' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'id' },
                                    name: { kind: 'Name', value: 'displayId' },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'autoRebid' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'orderSchedule' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'allowOvertime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'auditTrailVersion' } },
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'displayId' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'dedicated' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isReviewAllowed' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canSendToAgency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canAssign' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'acceptedBySharedTeamMember' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'sentToAgencies' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'activities' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'event' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'community' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'location' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'timeZone' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'position' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mainJane' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'id' },
                                    name: { kind: 'Name', value: 'displayId' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'primaryCommunity' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          alias: { kind: 'Name', value: 'id' },
                                          name: { kind: 'Name', value: 'displayId' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatarUrls' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'large' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'agencyCommunity' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'review' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'recurrence' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DashboardUpcomingShiftsPageQuery,
  DashboardUpcomingShiftsPageQueryVariables
>;
export const EditCustomFieldFetchCustomFieldByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'editCustomFieldFetchCustomFieldById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fetchCustomFieldId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCustomField' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'fetchCustomFieldId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allFacilities' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'communities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mobile' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customFieldOptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'value' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                { kind: 'Field', name: { kind: 'Name', value: 'prefillDefault' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EditCustomFieldFetchCustomFieldByIdQuery,
  EditCustomFieldFetchCustomFieldByIdQueryVariables
>;
export const FetchAgencyCommunitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchAgencyCommunities' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchAgency' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'agencyCommunities' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'byName' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'byName' } },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchAgencyCommunitiesQuery, FetchAgencyCommunitiesQueryVariables>;
export const FetchCommunitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchCommunities' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'SortableCommunityAttributes' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'FilterableCommunitiesAttributes' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCommunities' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchCommunitiesQuery, FetchCommunitiesQueryVariables>;
export const FetchCommunitiesPaginatedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchCommunitiesPaginated' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCommunities' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'field' },
                      value: { kind: 'EnumValue', value: 'name' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'direction' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'nulls' },
                      value: { kind: 'EnumValue', value: 'last' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byName' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'byName' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'currentPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pageCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchCommunitiesPaginatedQuery,
  FetchCommunitiesPaginatedQueryVariables
>;
export const FetchCommunityBiddingPeriodDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchCommunityBiddingPeriod' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCommunity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'biddingTimes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priorityTime' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leadTimes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priorityTime' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchCommunityBiddingPeriodQuery,
  FetchCommunityBiddingPeriodQueryVariables
>;
export const FetchDynamicGroupEmploymentStatusesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchDynamicGroupEmploymentStatuses' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchMetadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dynamicGroupCriteriaEmploymentStatuses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchDynamicGroupEmploymentStatusesQuery,
  FetchDynamicGroupEmploymentStatusesQueryVariables
>;
export const FetchFilteredCommunitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchFilteredCommunities' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'FilterableCommunitiesAttributes' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCommunities' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'field' },
                      value: { kind: 'EnumValue', value: 'name' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'direction' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'nulls' },
                      value: { kind: 'EnumValue', value: 'last' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'currentPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pageCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchFilteredCommunitiesQuery, FetchFilteredCommunitiesQueryVariables>;
export const FetchMeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchMe' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'B2bCustomer' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'accessLevelId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accessStatus' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'adpCustomIdentifier' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'agencyCustomer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'availabilityStatus' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUrls' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'large' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'communities' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'contactEmail' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'contactName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'contactPhone' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'location' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'flat' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'streetNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'completedOnboardingSteps' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPools' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'industry' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'payrollManagement' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'serviceablePositions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tieringStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userRole' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userType' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AgencyUser' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agency' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'agencyCommunities' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'communityPositions' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'openPayout' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'openRate' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'positionDetails' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'directDeposit' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'liability' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'coverageAmount' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'insuranceDocuments' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'archived' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'documentUrls' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'large' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'origin' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'small' },
                                              },
                                            ],
                                          },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'insuranceNumber' },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'agencyId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUrls' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'large' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPools' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'janes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'payrollManagement' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accessStatus' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SecondaryUser' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'accessLevelId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accessStatus' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'adpCustomIdentifier' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'agencyCustomer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'availabilityStatus' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUrls' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'large' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'communities' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'contactEmail' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'contactName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'contactPhone' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'location' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'flat' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'streetNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'completedOnboardingSteps' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPools' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'industry' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'invitedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'payrollManagement' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'serviceablePositions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tieringStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unreadConversations' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userRole' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userType' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchMeQuery, FetchMeQueryVariables>;
export const FetchOrderBiddersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchOrderBidders' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byMultipleFields' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byEmploymentStatus' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'UserEmploymentStatusEnum' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchOrder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'orderSchedule' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'biddable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'biddingTimeEndsAt' } },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'displayId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'biddable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'awardingTimeStartsAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'status' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bidders' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'byMultipleFields' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'byMultipleFields' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'byEmploymentStatus' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'byEmploymentStatus' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orderRank' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organizationSeniorityRanking' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'displayId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUrls' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'origin' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'employmentStatus' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalWeeklyHours' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'orderId' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'weeklyHours' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'primaryPosition' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'details' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchOrderBiddersQuery, FetchOrderBiddersQueryVariables>;
export const FetchOrderCanAssignDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchOrderCanAssign' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchOrder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canAssign' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchOrderCanAssignQuery, FetchOrderCanAssignQueryVariables>;
export const FetchSecondaryCommunitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchSecondaryCommunities' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'withEnabledFeatures' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'withoutEnabledFeatures' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCommunities' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'field' },
                      value: { kind: 'EnumValue', value: 'name' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'direction' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'nulls' },
                      value: { kind: 'EnumValue', value: 'last' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byName' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'byName' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'withEnabledFeatures' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'withEnabledFeatures' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'withoutEnabledFeatures' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'withoutEnabledFeatures' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'currentPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pageCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchSecondaryCommunitiesQuery,
  FetchSecondaryCommunitiesQueryVariables
>;
export const FetchTeamMemberByIdTeamMembersPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchTeamMemberByIdTeamMembersPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'teamMemberId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchJane' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'teamMemberId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'displayId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'invitation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'avatarUrls' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'origin' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'primaryPosition' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'positions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'secondaryPositions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'employmentStatus' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accessStatus' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchTeamMemberByIdTeamMembersPageQuery,
  FetchTeamMemberByIdTeamMembersPageQueryVariables
>;
export const FetchTimeOffCustomFieldsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchTimeOffCustomFields' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'FilterableCustomFieldAttributes' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCustomFields' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobile' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prefillDefault' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastEditedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customFieldOptions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'communities' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organization' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'activities' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchTimeOffCustomFieldsQuery, FetchTimeOffCustomFieldsQueryVariables>;
export const FetchLocaleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchLocale' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'B2bCustomer' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AgencyUser' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SecondaryUser' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchLocaleQuery, FetchLocaleQueryVariables>;
export const GeneralAgencyLocationSettingsPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'generalAgencyLocationSettingsPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'agencyId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'agencyCommunityId' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchAgency' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'agencyId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'agencyCommunities' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'withId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'agencyCommunityId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contactEmail' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'wsib' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'regulatoryId' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'documents' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'originalFilename' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'archive' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'urls' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: '__typename' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'large' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'flat' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fullAddress' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'streetNumber' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GeneralAgencyLocationSettingsPageQuery,
  GeneralAgencyLocationSettingsPageQueryVariables
>;
export const GeneralLocationSettingsPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'generalLocationSettingsPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCommunity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactEmail' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fullAddress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetNumber' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GeneralLocationSettingsPageQuery,
  GeneralLocationSettingsPageQueryVariables
>;
export const GroupedPositionsSettingsPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'groupedPositionsSettingsPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sortAllocatedPositionsByCommunity' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groupPositions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byName' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'byName' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'groupBy' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'field' },
                      value: { kind: 'EnumValue', value: 'departmentOrWorkTeam' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortAllocatedPositionsByCommunity' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sortAllocatedPositionsByCommunity' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'group' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'items' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'department' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GroupedPositionsSettingsPageQuery,
  GroupedPositionsSettingsPageQueryVariables
>;
export const JaneModalJaneDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'janeModalJaneDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchJane' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'displayId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'invitation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastSendAttempt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'invitationId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'agencyCommunity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'communityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                { kind: 'Field', name: { kind: 'Name', value: 'employeeStartDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'avatarUrls' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'fullAddress' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'usersCommunities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'community' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'displayId' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shiftParticipation' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'primaryPosition' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'positions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'secondaryPositions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'employmentStatus' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shorthandName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accessStatus' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerReviews' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'averageRating' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reviews' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'jane' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatarUrls' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'shorthandName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'communityName' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'reviewer' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatarUrls' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'order' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'community' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'displayId' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'primaryCommunity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'displayId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'birthDay' } },
                { kind: 'Field', name: { kind: 'Name', value: 'birthMonth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hourlyRate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'employeeNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rankingSeniorityDate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'seniorityDays' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'seniorityHours' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'seniorityMonths' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'seniorityYears' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'organizationSeniorityRanking' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<JaneModalJaneDetailsQuery, JaneModalJaneDetailsQueryVariables>;
export const LocationDropdownDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'locationDropdownData' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SecondaryUser' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'communities' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'location' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'B2bCustomer' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'communities' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'location' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AgencyUser' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agency' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'agencyCommunities' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'location' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'latitude' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'longitude' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'timeZone' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LocationDropdownDataQuery, LocationDropdownDataQueryVariables>;
export const LocationNameLabelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'locationNameLabel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCommunity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LocationNameLabelQuery, LocationNameLabelQueryVariables>;
export const OrganizationSettingsPageSenorityMethodDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'organizationSettingsPageSenorityMethod' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCommunity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'relayId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'seniorityMethod' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastEditedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'B2bCustomer' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'SecondaryUser' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'User' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrganizationSettingsPageSenorityMethodQuery,
  OrganizationSettingsPageSenorityMethodQueryVariables
>;
export const PositionByDepartmentSelectInputDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'positionByDepartmentSelectInput' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'FilterablePositionAttributes' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groupPositions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'groupBy' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'field' },
                      value: { kind: 'EnumValue', value: 'departmentOrWorkTeam' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'group' } },
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'positions' },
                              name: { kind: 'Name', value: 'items' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'openShiftPolicy' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PositionByDepartmentSelectInputQuery,
  PositionByDepartmentSelectInputQueryVariables
>;
export const PositionNameLabelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'positionNameLabel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchPosition' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'openPriceRange' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PositionNameLabelQuery, PositionNameLabelQueryVariables>;
export const PositionsByDepartmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'positionsByDepartment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'FilterablePositionAttributes' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groupPositions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'groupBy' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'field' },
                      value: { kind: 'EnumValue', value: 'departmentOrWorkTeam' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'group' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'positions' },
                              name: { kind: 'Name', value: 'items' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PositionsByDepartmentQuery, PositionsByDepartmentQueryVariables>;
export const PositionsPriceRangesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'positionsPriceRanges' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'FilterablePositionAttributes' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'communityId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchPositions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hasPools' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'communityId' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'communityId' },
                                  },
                                },
                              ],
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'openShiftPolicy' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'openPriceRange' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PositionsPriceRangesQuery, PositionsPriceRangesQueryVariables>;
export const PositionsSettingsPageFetchCommunityByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'positionsSettingsPageFetchCommunityById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'agencyId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ForAgencyCommunityAttributes' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchAgency' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'agencyId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'agencyCommunities' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'positions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'workTeam' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'clientCost' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PositionsSettingsPageFetchCommunityByIdQuery,
  PositionsSettingsPageFetchCommunityByIdQueryVariables
>;
export const PositionsSettingsPageFetchPositionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'positionsSettingsPageFetchPositions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'communityId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AgencyUser' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agency' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'agencyCommunities' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'filter' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'withId' },
                                        value: {
                                          kind: 'ListValue',
                                          values: [
                                            {
                                              kind: 'Variable',
                                              name: { kind: 'Name', value: 'communityId' },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'agencyPositionDetails' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'openRate' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'positionDetails' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'id' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'name' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'prettyWorkTeam' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'workTeam' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'updatedAt' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PositionsSettingsPageFetchPositionsQuery,
  PositionsSettingsPageFetchPositionsQueryVariables
>;
export const RequestTeamMembersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'requestTeamMembers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'positionId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterableJaneAttributes' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'breakTime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestJanes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'external' },
                value: { kind: 'BooleanValue', value: true },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'relevantForOrder' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'orderId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'withBreakTime' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'breakTime' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pageCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agencyCommunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'agency' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'displayId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUrls' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'origin' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customerReviews' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'averageRating' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'primaryPosition' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'details' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'agencyDetails' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'openRate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'openPayout' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'positions' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'filter' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'forDetails' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'byAgencyServicedPosition' },
                                        value: {
                                          kind: 'Variable',
                                          name: { kind: 'Name', value: 'positionId' },
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'details' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'agencyDetails' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'openRate' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RequestTeamMembersQuery, RequestTeamMembersQueryVariables>;
export const RequestTeamMembersCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'requestTeamMembersCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterableJaneAttributes' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'breakTime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestJanes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'external' },
                value: { kind: 'BooleanValue', value: true },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'relevantForOrder' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'orderId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'withBreakTime' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'breakTime' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'totalCount' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RequestTeamMembersCountQuery, RequestTeamMembersCountQueryVariables>;
export const RequestTeamMembersRecurringDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'requestTeamMembersRecurring' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'positionId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterableJaneAttributes' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'recurring' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RecurringOrderAttributes' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'breakTime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestJanes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'external' },
                value: { kind: 'BooleanValue', value: true },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'relevantForOrder' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'orderId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'withBreakTime' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'breakTime' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pageCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agencyCommunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'agency' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'displayId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUrls' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'origin' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customerReviews' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'averageRating' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'primaryPosition' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'details' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'agencyDetails' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'openRate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'openPayout' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conflictingDays' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'recurring' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'recurring' } },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'positions' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'filter' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'forDetails' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'byAgencyServicedPosition' },
                                        value: {
                                          kind: 'Variable',
                                          name: { kind: 'Name', value: 'positionId' },
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'details' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'agencyDetails' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'openRate' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RequestTeamMembersRecurringQuery,
  RequestTeamMembersRecurringQueryVariables
>;
export const ScheduleTimeOffsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'scheduleTimeOffs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterableTimeOffAttributes' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchTimeOffs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'field' },
                      value: { kind: 'EnumValue', value: 'startTime' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'direction' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'currentPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pageCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'isEditable' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'jane' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'displayId' },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'title' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScheduleTimeOffsQuery, ScheduleTimeOffsQueryVariables>;
export const FetchSchedulingGroupsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchSchedulingGroups' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterableGroupAttributes' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCommunity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'groups' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'first' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'last' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'after' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'before' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'StaticGroup' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'pageCount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageInfo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchSchedulingGroupsQuery, FetchSchedulingGroupsQueryVariables>;
export const SchedulingPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'schedulingPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byMultipleFields' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortableJanesAttributes' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchJanes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byMultipleFields' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'byMultipleFields' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byStatus' },
                      value: { kind: 'EnumValue', value: 'approved' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'displayId' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SchedulingPageQuery, SchedulingPageQueryVariables>;
export const SchedulingTabNavigationInputDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'schedulingTabNavigationInput' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byMultipleFields' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortableJanesAttributes' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchJanes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byMultipleFields' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'byMultipleFields' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byStatus' },
                      value: { kind: 'EnumValue', value: 'approved' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'displayId' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SchedulingTabNavigationInputQuery,
  SchedulingTabNavigationInputQueryVariables
>;
export const SearchTeamMembersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'searchTeamMembers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byMultipleFields' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'withServiceableCommunity' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byAgencyCommunity' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'external' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortableJanesAttributes' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchJanes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byMultipleFields' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'byMultipleFields' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'withServiceableCommunity' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'withServiceableCommunity' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byStatus' },
                      value: { kind: 'EnumValue', value: 'approved' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byAgencyCommunity' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'byAgencyCommunity' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'external' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'external' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'displayId' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'primaryCommunity' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'id' },
                                    name: { kind: 'Name', value: 'displayId' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'agencyCommunity' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUrls' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchTeamMembersQuery, SearchTeamMembersQueryVariables>;
export const SearchTeamMembersForGroupDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'searchTeamMembersForGroup' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupsFilter' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterableGroupAttributes' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byMultipleFields' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'withServiceableCommunity' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byAgencyCommunity' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'external' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortableJanesAttributes' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchJanes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byMultipleFields' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'byMultipleFields' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byStatus' },
                      value: { kind: 'EnumValue', value: 'approved' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'withServiceableCommunity' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'withServiceableCommunity' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byAgencyCommunity' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'byAgencyCommunity' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'external' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'external' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'displayId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'staticGroups' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'filter' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'groupsFilter' },
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'primaryCommunity' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'id' },
                                    name: { kind: 'Name', value: 'displayId' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'agencyCommunity' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUrls' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SearchTeamMembersForGroupQuery,
  SearchTeamMembersForGroupQueryVariables
>;
export const SendToAgenciesOrderDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'sendToAgenciesOrderDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchOrder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recurrence' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'weekdays' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expirationDate' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'position' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'estimatedTotalCharge' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rateLabel' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dedicatedPool' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendToAgenciesOrderDetailsQuery,
  SendToAgenciesOrderDetailsQueryVariables
>;
export const SendToAgenciesPositionMinMaxDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'sendToAgenciesPositionMinMax' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'positionId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchPosition' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'positionId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'openPriceRange' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendToAgenciesPositionMinMaxQuery,
  SendToAgenciesPositionMinMaxQueryVariables
>;
export const SendToAgenciesRequestTeamMemberSelectedJanePriceRangeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'sendToAgenciesRequestTeamMemberSelectedJanePriceRange' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'janeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'positionId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchJane' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'janeId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'positions' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'forDetails' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'byAgencyServicedPosition' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'positionId' },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agencyDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'openRate' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendToAgenciesRequestTeamMemberSelectedJanePriceRangeQuery,
  SendToAgenciesRequestTeamMemberSelectedJanePriceRangeQueryVariables
>;
export const SendToAgenciesSummaryViewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'sendToAgenciesSummaryView' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jane_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'positionId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchJane' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'jane_id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'avatarUrls' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'small' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'belongsToPool' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'positions' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'forDetails' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'byAgencyServicedPosition' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'positionId' },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agencyDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'openRate' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'positionDetails' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'openPriceRange' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'rangeLabel' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'rawMin' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'rawMax' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendToAgenciesSummaryViewQuery,
  SendToAgenciesSummaryViewQueryVariables
>;
export const SendToAgenciesSummaryViewTeamMembersCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'sendToAgenciesSummaryViewTeamMembersCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterableJaneAttributes' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'breakTime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestJanes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'external' },
                value: { kind: 'BooleanValue', value: true },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'relevantForOrder' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'orderId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'withBreakTime' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'breakTime' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'totalCount' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendToAgenciesSummaryViewTeamMembersCountQuery,
  SendToAgenciesSummaryViewTeamMembersCountQueryVariables
>;
export const SendToSelectedAgenciesFetchAgenciesByOrderIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'sendToSelectedAgenciesFetchAgenciesByOrderId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byRateLessThanOrEqualTo' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchAgencyCommunities' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'forAgencyCommunities' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'byName' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'byName' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'availableJaneFilters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'filter' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'byRateLessThanOrEqualTo' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'byRateLessThanOrEqualTo' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'relevantForOrder' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'orderId' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'ListValue',
                  values: [
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'field' },
                          value: { kind: 'EnumValue', value: 'openRate' },
                        },
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'direction' },
                          value: { kind: 'EnumValue', value: 'asc' },
                        },
                      ],
                    },
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'field' },
                          value: { kind: 'EnumValue', value: 'name' },
                        },
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'direction' },
                          value: { kind: 'EnumValue', value: 'asc' },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pageCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'averageRating' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'availableJanes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agency' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'liability' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'licenceNumber' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUrls' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'large' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agencyPositionDetails' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'filter' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'servicingOrder' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'orderId' },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'openRate' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendToSelectedAgenciesFetchAgenciesByOrderIdQuery,
  SendToSelectedAgenciesFetchAgenciesByOrderIdQueryVariables
>;
export const SendToSelectedAgenciesFetchAgenciesByOrderIdNonPaginatedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'sendToSelectedAgenciesFetchAgenciesByOrderIdNonPaginated' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'selectedAgencyCommunities' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchAgencyCommunities' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'forAgencyCommunities' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'withId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'selectedAgencyCommunities' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'availableJaneFilters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'relevantForOrder' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'orderId' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'availableJanes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agency' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'liability' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'licenceNumber' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agencyPositionDetails' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'filter' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'servicingOrder' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'orderId' },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'openRate' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendToSelectedAgenciesFetchAgenciesByOrderIdNonPaginatedQuery,
  SendToSelectedAgenciesFetchAgenciesByOrderIdNonPaginatedQueryVariables
>;
export const FetchGroupDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchGroupDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'node' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'groupId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'StaticGroup' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'groupJanes' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'last' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'after' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'before' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nodes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayId' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'jane' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          alias: { kind: 'Name', value: 'id' },
                                          name: { kind: 'Name', value: 'displayId' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'firstName' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'lastName' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'isMobile' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'pendingSignup' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'avatarUrls' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'small' },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: '__typename' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'pageCount' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'pageInfo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasPreviousPage' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'DynamicGroup' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'criteria' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'employmentStatuses' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'positionTypes' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'maximumPerDayMinutes' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'maximumPerPeriodMinutes' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'minimumPerDayMinutes' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'minimumPerPeriodMinutes' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'locationDistribution' },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchGroupDetailsQuery, FetchGroupDetailsQueryVariables>;
export const FetchGroupsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchGroups' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterableGroupAttributes' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCommunity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'groups' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'first' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'last' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'after' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'before' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'StaticGroup' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'DynamicGroup' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'pageCount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageInfo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchGroupsQuery, FetchGroupsQueryVariables>;
export const SettingsPageFetchOpenShiftsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'settingsPageFetchOpenShifts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'positionId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderFilter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterableOrderAttributes' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchPosition' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'positionId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceableCommunities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'configuredShifts' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'orderFilter' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'after' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'before' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'first' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'last' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pageCount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageInfo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'displayId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'isAway' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalDuration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'position' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'orderSchedule' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'recurrence' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'community' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'acceptedBySharedTeamMember' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mainJane' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'id' },
                                    name: { kind: 'Name', value: 'displayId' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'primaryCommunity' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          alias: { kind: 'Name', value: 'id' },
                                          name: { kind: 'Name', value: 'displayId' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatarUrls' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SettingsPageFetchOpenShiftsQuery,
  SettingsPageFetchOpenShiftsQueryVariables
>;
export const SettingsPageFetchPositionByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'settingsPageFetchPositionById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'positionId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PositionTypeEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderFilter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterableOrderAttributes' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'teamMemberFilter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterableJaneAttributes' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchPosition' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'positionId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceableCommunities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'teamMembers' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'teamMemberFilter' },
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'after' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'before' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'first' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'last' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pageCount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageInfo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUrls' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'accessStatus' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'primaryCommunity' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'communityName' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'secondaryCommunities' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'primaryPosition' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'details' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'secondaryPositions' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'details' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'configuredShifts' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'orderFilter' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'totalCount' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SettingsPageFetchPositionByIdQuery,
  SettingsPageFetchPositionByIdQueryVariables
>;
export const FetchCommunityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchCommunity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCommunity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'availabilityStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'checkInProcedure' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'communityFeatures' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feature' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'document' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'locationHistory' } },
                { kind: 'Field', name: { kind: 'Name', value: 'policies' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'positions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'vaccinationRequired' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vaccinationRequiredLastUpdated' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vaccinationRequiredLastUpdatedBy' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchCommunityQuery, FetchCommunityQueryVariables>;
export const ShiftCardFetchOrderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'shiftCardFetchOrder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchOrder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'orderSchedule' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'biddable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'biddingTimeEndsAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'awardingTimeStartsAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bidders' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'displayId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'displayId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isReviewAllowed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canSendToAgency' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'event' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'canAssign' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoRebid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'acceptedBySharedTeamMember' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sentToAgencies' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dedicated' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowOvertime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'auditTrailVersion' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currentlyActiveCalloutList' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isCompleted' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalJanes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'waitingForManualApproval' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'estimatedCompletedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalNotifiedAndSkipped' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'status' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'community' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'position' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mainJane' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'displayId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'primaryCommunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'displayId' },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUrls' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'large' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agencyCommunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'review' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'rating' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recurrence' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShiftCardFetchOrderQuery, ShiftCardFetchOrderQueryVariables>;
export const ShiftDistributionRulesGroupsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'shiftDistributionRulesGroups' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'FilterableShiftDistributionRuleAttributes' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchShiftDistributionRules' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'skipWaitTimeThresholdMinutes' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'community' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'groupRules' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'displayId' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'waitTimeMinutes' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'group' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'StaticGroup' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          alias: { kind: 'Name', value: 'id' },
                                          name: { kind: 'Name', value: 'displayId' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'DynamicGroup' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          alias: { kind: 'Name', value: 'id' },
                                          name: { kind: 'Name', value: 'displayId' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'position' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ShiftDistributionRulesGroupsQuery,
  ShiftDistributionRulesGroupsQueryVariables
>;
export const FetchSharingDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchSharingDetails' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCommunities' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeSharedCommunities' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'communityFeatures' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'feature' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchSharingDetailsQuery, FetchSharingDetailsQueryVariables>;
export const FetchTieringDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchTieringDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCommunity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'communityFeatures' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feature' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'escalationTimes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priorityTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'biddingTimes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priorityTime' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leadTimes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priorityTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchTieringDetailsQuery, FetchTieringDetailsQueryVariables>;
export const ShiftModalOrderDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'shiftModalOrderDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchOrder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relayId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canAssign' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'draftShift' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'biddable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoRebid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'biddingTimeEndsAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'awardingTimeStartsAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bidders' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'displayId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currentlyActiveCalloutList' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isCompleted' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalJanes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'waitingForManualApproval' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'estimatedCompletedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalNotifiedAndSkipped' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'manualApprovalIndexes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'index' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'groupName' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'acceptedFor' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'calloutListId' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'qualifiedAgencyJanesCount' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'reasonMessage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'reasonCategory' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'feedableEdits' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fieldType' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'newValuePretty' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'oldValuePretty' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'newValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'oldValue' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'event' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'User' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'communityName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatarUrls' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'Jane' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'communityName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatarUrls' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'B2bCustomer' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatarUrls' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'AgencyUser' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatarUrls' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'SecondaryUser' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatarUrls' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'Admin' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatarUrls' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'order' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mainJane' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'shorthandName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'communityName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'flag' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'acceptedBySharedTeamMember' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowOvertime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'auditTrailVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canSendToAgency' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'community' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'b2bUserShiftEditThreshold' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'secondaryUserShiftEditThreshold' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customFields' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fieldType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'mobile' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'prefillDefault' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'customFieldOptions' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'customFieldId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobile' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'dedicated' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowOvertime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'estimatedTotalCharge' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rateLabel' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'displayId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isAway' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEditable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDeletable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isJaneReleaseAllowed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isReviewAllowed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noShow' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'review' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'streetNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fullAddress' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mainJane' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'displayId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'communityName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'primaryCommunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'displayId' },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'acceptedByAgency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUrls' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'small' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agencyCommunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'contactPhone' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'orderSchedule' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'breakTime' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mainOrderJane' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'assignedBy' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayId' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timeSheet' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dedicatedPool' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'position' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'openShiftPolicy' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'openPriceRange' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'rangeLabel' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rateLabel' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recurrence' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'recurrenceLabel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'interval' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weekdays' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expirationDate' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'futureShifts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'orderSchedule' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'displayId' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'resident' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sentToAgencies' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'status' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalDuration' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShiftModalOrderDetailsQuery, ShiftModalOrderDetailsQueryVariables>;
export const ShiftModalOrderDetailsCalloutListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'shiftModalOrderDetailsCalloutList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'node' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'calloutListFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'calloutListFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CalloutList' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalJanes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalNotifiedAndSkipped' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingForManualApproval' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'estimatedCompletedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'manualApprovalIndexes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'groupName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'index' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'order' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'orderSchedule' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'biddable' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'timeZone' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'calloutListJanes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'currentPage' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'pageCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'calloutStatus' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'estimatedCalloutTime' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'jane' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'accessStatus' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'primaryCommunity' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUrls' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'large' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'employmentStatus' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'manualApproval' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'approvedAt' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'notifiedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notNotifiedLogs' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ShiftModalOrderDetailsCalloutListQuery,
  ShiftModalOrderDetailsCalloutListQueryVariables
>;
export const ShiftModalRequestSelectAgenciesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'shiftModalRequestSelectAgencies' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byRateLessThanOrEqualTo' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'SortableAgencyCommunityAttributes' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchAgencyCommunities' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'forAgencyCommunities' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'byName' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'byName' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'availableJaneFilters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'filter' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'byRateLessThanOrEqualTo' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'byRateLessThanOrEqualTo' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'relevantForOrder' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'orderId' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'availableJanes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'janes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nodes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          alias: { kind: 'Name', value: 'id' },
                                          name: { kind: 'Name', value: 'displayId' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'shorthandName' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ShiftModalRequestSelectAgenciesQuery,
  ShiftModalRequestSelectAgenciesQueryVariables
>;
export const ShiftModalTimeSheetDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'shiftModalTimeSheetDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderScheduleId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchTimeSheet' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderScheduleId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'breakTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actualStart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actualEnd' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'timeSheet' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'acceptedHourlyRate' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'rawCurrency' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'approvedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'approvedBy' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'approvedCustomerCost' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'rawCurrency' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'approvedEndTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'approvedStartTime' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'approvedTotalTime' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'rawTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'time' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'approvedUnpaidBreakTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'autoApproved' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'clockInOffSite' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'clockOutOffSite' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'clockInDistance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'clockOutDistance' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'clockInStatus' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'prettyValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'clockOutStatus' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'prettyValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'clockIn' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'clockOut' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'unpaidBreakTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ShiftModalTimeSheetDetailsQuery,
  ShiftModalTimeSheetDetailsQueryVariables
>;
export const ShiftSummaryJaneRowFetchJaneDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'shiftSummaryJaneRowFetchJane' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'janeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'positionId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchJane' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'janeId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'avatarUrls' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'positions' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'forDetails' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'byAgencyServicedPosition' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'positionId' },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agencyDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'openRate' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ShiftSummaryJaneRowFetchJaneQuery,
  ShiftSummaryJaneRowFetchJaneQueryVariables
>;
export const ShiftSummaryViewTeamMembersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'shiftSummaryViewTeamMembers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byJaneIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchJanes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'byJaneIds' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byStatus' },
                      value: {
                        kind: 'ListValue',
                        values: [{ kind: 'EnumValue', value: 'approved' }],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'displayId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUrls' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'origin' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ShiftSummaryViewTeamMembersQuery,
  ShiftSummaryViewTeamMembersQueryVariables
>;
export const ShiftsCalendarPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'shiftsCalendarPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupBy' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'GroupCountableOrderAttributes' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterableOrderAttributes' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groupCountOrders' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'groupBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'groupBy' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'group' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fieldValue' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'counted' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subGroups' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fieldType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fieldValue' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShiftsCalendarPageQuery, ShiftsCalendarPageQueryVariables>;
export const ShiftPageDaySelectionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'shiftPageDaySelection' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortableOrderAttributes' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterableOrderAttributes' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchOrders' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'displayId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'orderSchedule' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'allowOvertime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'biddable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'biddingTimeEndsAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'awardingTimeStartsAt' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'bidders' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'id' },
                                    name: { kind: 'Name', value: 'displayId' },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'autoRebid' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'activities' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'event' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'isReviewAllowed' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canSendToAgency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sentToAgencies' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'acceptedBySharedTeamMember' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'currentlyActiveCalloutList' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isCompleted' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalJanes' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'waitingForManualApproval' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'estimatedCompletedAt' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'totalNotifiedAndSkipped' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dedicated' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'community' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'location' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'timeZone' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'position' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mainJane' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'id' },
                                    name: { kind: 'Name', value: 'displayId' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'primaryCommunity' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          alias: { kind: 'Name', value: 'id' },
                                          name: { kind: 'Name', value: 'displayId' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatarUrls' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'agencyCommunity' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'recurrence' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShiftPageDaySelectionQuery, ShiftPageDaySelectionQueryVariables>;
export const ShiftsListPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'shiftsListPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortableOrderAttributes' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterableOrderAttributes' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchOrders' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'pageCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'rate' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'rateLabel' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalDuration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dedicated' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'allowOvertime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'biddable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'biddingTimeEndsAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'awardingTimeStartsAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'bidders' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'id' },
                                    name: { kind: 'Name', value: 'displayId' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'estimatedTotalCharge' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'min' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'rateLabel' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'orderSchedule' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'orderSchedule' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'breakTime' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalTime' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'displayId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'acceptedBySharedTeamMember' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'sentToAgencies' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'recurrence' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'community' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'location' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'timeZone' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'position' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mainJane' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'id' },
                                    name: { kind: 'Name', value: 'displayId' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'primaryCommunity' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          alias: { kind: 'Name', value: 'id' },
                                          name: { kind: 'Name', value: 'displayId' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatarUrls' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'agencyCommunity' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'cursor' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShiftsListPageQuery, ShiftsListPageQueryVariables>;
export const TeamMemberPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'teamMemberPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'external' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterableJaneAttributes' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortableJanesAttributes' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchJanes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'external' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'external' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'displayId' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUrls' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'primaryPosition' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'details' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'positions' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'details' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'secondaryPositions' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'details' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'secondaryCommunities' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayId' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'primaryCommunity' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayId' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'employmentStatus' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'employeeNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'accessStatus' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'rankingSeniorityDate' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'seniorityDays' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'seniorityHours' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'seniorityMonths' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'seniorityYears' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationSeniorityRanking' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'pageCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TeamMemberPageQuery, TeamMemberPageQueryVariables>;
export const TeamMemberPageSenorityMethodDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'teamMemberPageSenorityMethod' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCommunity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'seniorityMethod' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TeamMemberPageSenorityMethodQuery,
  TeamMemberPageSenorityMethodQueryVariables
>;
export const TeamMemberCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'teamMemberCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byPositionId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byFacilityId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isDedicated' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byStartTime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ISO8601DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byEndTime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ISO8601DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'allowOvertime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'breakTime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestJanes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'relevantForOrder' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byPositionId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'byPositionId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byFacilityId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'byFacilityId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'isDedicated' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'isDedicated' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byStartTime' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'byStartTime' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byEndTime' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'byEndTime' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'allowOvertime' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'allowOvertime' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'withBreakTime' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'breakTime' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'totalCount' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TeamMemberCountQuery, TeamMemberCountQueryVariables>;
export const TeamMembersPageFetchJanesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'teamMembersPageFetchJanes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byMultipleFields' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'withServiceableCommunity' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'byAgencyCommunity' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'external' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortableJanesAttributes' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchJanes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byMultipleFields' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'byMultipleFields' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'withServiceableCommunity' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'withServiceableCommunity' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'byAgencyCommunity' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'byAgencyCommunity' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'external' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'external' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'displayId' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationSeniorityRanking' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'primaryCommunity' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'id' },
                                    name: { kind: 'Name', value: 'displayId' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'agencyCommunity' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'accessStatus' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUrls' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TeamMembersPageFetchJanesQuery,
  TeamMembersPageFetchJanesQueryVariables
>;
export const TimeFrameLocationSettingsPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'timeFrameLocationSettingsPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCommunity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'timeFrame' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'morningStartsAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eveningStartsAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nightStartsAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TimeFrameLocationSettingsPageQuery,
  TimeFrameLocationSettingsPageQueryVariables
>;
export const TimeOffFetchJaneDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'timeOffFetchJane' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'janeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchJane' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'janeId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'communityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'avatarUrls' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TimeOffFetchJaneQuery, TimeOffFetchJaneQueryVariables>;
export const TimeOffModalFetchTimeOffByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'timeOffModalFetchTimeOffById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'timeOffId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchTimeOff' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'timeOffId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'timeOffId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEditable' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'User' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'communityName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatarUrls' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'Jane' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'communityName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatarUrls' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'B2bCustomer' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatarUrls' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'AgencyUser' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatarUrls' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'SecondaryUser' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatarUrls' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'Admin' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatarUrls' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'event' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'acceptedFor' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'calloutListId' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'qualifiedAgencyJanesCount' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'feedableEdits' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fieldType' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'oldValuePretty' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'newValuePretty' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'newValue' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'oldValue' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'reasonCategory' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'reasonMessage' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'community' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'customFieldId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'displayId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'jane' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUrls' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'communityName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'displayId' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'title' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TimeOffModalFetchTimeOffByIdQuery,
  TimeOffModalFetchTimeOffByIdQueryVariables
>;
export const TimesheetCardDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'timesheetCard' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderScheduleId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchTimeSheet' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderScheduleId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalTime' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'order' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'orderSchedule' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'displayId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'community' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'location' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'position' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'dedicated' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'allowOvertime' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mainJane' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUrls' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'small' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agencyCommunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'communityName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'timeSheet' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'clockIn' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'clockInStatus' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'prettyValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'clockInOffSite' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'clockOutOffSite' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'clockOutStatus' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'prettyValue' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'clockOut' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'approvedCustomerCost' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'rawCurrency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isEdited' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'approvedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'approvedBy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'approvedStartTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'approvedEndTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'approvedUnpaidBreakTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TimesheetCardQuery, TimesheetCardQueryVariables>;
export const TimesheetsPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'timesheetsPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'SortableTimeSheetAttributes' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'FilterableTimeSheetAttributes' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchTimeSheets' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalTime' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'order' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'orderSchedule' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'id' },
                                    name: { kind: 'Name', value: 'displayId' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'community' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: '__typename' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'location' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'timeZone' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'position' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'dedicated' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mainJane' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatarUrls' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'agencyCommunity' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'communityName' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'timeSheet' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'status' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'clockInStatus' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: '__typename' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'prettyValue' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'clockOutStatus' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: '__typename' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'prettyValue' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'clockInOffSite' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'clockOutOffSite' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'clockIn' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'clockOut' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'approvedCustomerCost' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'rawCurrency' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'currency' },
                                        },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isEdited' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'approvedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'approvedBy' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'approvedStartTime' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'approvedEndTime' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'approvedUnpaidBreakTime' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'cursor' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TimesheetsPageQuery, TimesheetsPageQueryVariables>;
export const UserProfilePageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'userProfilePage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AgencyUser' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'B2bCustomer' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'adpCustomIdentifier' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SecondaryUser' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'adpCustomIdentifier' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserProfilePageQuery, UserProfilePageQueryVariables>;
export const WeeklyDashboardNeedsAttentionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'weeklyDashboardNeedsAttention' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filterTimesheets' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'FilterableTimeSheetAttributes' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'timeSheets' },
            name: { kind: 'Name', value: 'fetchTimeSheets' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filterTimesheets' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'totalCount' } }],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'timeOffs' },
            name: { kind: 'Name', value: 'fetchTimeOffs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'field' },
                      value: { kind: 'EnumValue', value: 'startTime' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'direction' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'totalCount' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WeeklyDashboardNeedsAttentionQuery,
  WeeklyDashboardNeedsAttentionQueryVariables
>;
export const WeeklyDashboardNeedsAttentionBiddingShiftsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'weeklyDashboardNeedsAttentionBiddingShifts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sortOrders' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortableOrderAttributes' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'Biddablefilter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterableOrderAttributes' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'biddableShifts' },
            name: { kind: 'Name', value: 'fetchOrders' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sortOrders' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'Biddablefilter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'biddable' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'biddingTimeEndsAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'awardingTimeStartsAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bidders' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'displayId' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'displayId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isReviewAllowed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSendToAgency' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'orderSchedule' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'activities' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'event' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssign' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'autoRebid' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'acceptedBySharedTeamMember' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'sentToAgencies' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dedicated' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'allowOvertime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'auditTrailVersion' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currentlyActiveCalloutList' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCompleted' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalJanes' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'waitingForManualApproval' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'estimatedCompletedAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalNotifiedAndSkipped' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'community' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'location' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'position' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mainJane' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'displayId' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'primaryCommunity' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'id' },
                                    name: { kind: 'Name', value: 'displayId' },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUrls' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'large' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'agencyCommunity' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recurrence' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WeeklyDashboardNeedsAttentionBiddingShiftsQuery,
  WeeklyDashboardNeedsAttentionBiddingShiftsQueryVariables
>;
export const WeeklyDashboardNeedsAttentionUpcommingShiftsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'weeklyDashboardNeedsAttentionUpcommingShifts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sortOrders' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortableOrderAttributes' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterableOrderAttributes' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'upcomingShifts' },
            name: { kind: 'Name', value: 'fetchOrders' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sortOrders' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'biddable' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'biddingTimeEndsAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'awardingTimeStartsAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bidders' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'displayId' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'displayId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isReviewAllowed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSendToAgency' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'orderSchedule' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'activities' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'event' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssign' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'autoRebid' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'acceptedBySharedTeamMember' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'sentToAgencies' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dedicated' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'allowOvertime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'auditTrailVersion' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currentlyActiveCalloutList' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCompleted' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalJanes' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'waitingForManualApproval' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'estimatedCompletedAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalNotifiedAndSkipped' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'community' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'location' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'position' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mainJane' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'displayId' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'primaryCommunity' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'id' },
                                    name: { kind: 'Name', value: 'displayId' },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUrls' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'large' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'agencyCommunity' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recurrence' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WeeklyDashboardNeedsAttentionUpcommingShiftsQuery,
  WeeklyDashboardNeedsAttentionUpcommingShiftsQueryVariables
>;
export const WeeklyDashboardNeedsReviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'weeklyDashboardNeedsReview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'communityId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'needsReview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'communityId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'communityId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'pendingSignups' } },
                { kind: 'Field', name: { kind: 'Name', value: 'unpublishedShifts' } },
                { kind: 'Field', name: { kind: 'Name', value: 'flaggedTimeSheets' } },
                { kind: 'Field', name: { kind: 'Name', value: 'newThreads' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WeeklyDashboardNeedsReviewQuery,
  WeeklyDashboardNeedsReviewQueryVariables
>;
export const WeeklyDashboardOverviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'weeklyDashboardOverview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'communityId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dashboardWeeklyOverview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'communityId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'communityId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'pendingOrders' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pendingOrdersToday' } },
                { kind: 'Field', name: { kind: 'Name', value: 'weekEndsAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'weekStartsAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fulfillmentRate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fulfillmentRateChange' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agencySpent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agencySpentChange' } },
                { kind: 'Field', name: { kind: 'Name', value: 'weeklyOvertimeHours' } },
                { kind: 'Field', name: { kind: 'Name', value: 'weeklyOvertimeHoursChange' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dailyOvertimeHours' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WeeklyDashboardOverviewQuery, WeeklyDashboardOverviewQueryVariables>;
export const WeeklyDashboardTeamMembersTabDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'weeklyDashboardTeamMembersTab' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterableOrderAttributes' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'communityId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortableOrderAttributes' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchOrdersWithJanesMetadata' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'communityId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'communityId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregateJanesByTypes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'internal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shared' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'agency' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'orders' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'after' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'before' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'first' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'last' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageInfo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'pageCount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'displayId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'position' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'orderSchedule' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'timeSheet' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'status' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'name' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'value' },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'clockInStatus' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: '__typename' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'prettyValue' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'value' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mainJane' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isMobile' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pendingSignup' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'accessStatus' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatarUrls' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'origin' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'agencyCommunity' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'primaryCommunity' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          alias: { kind: 'Name', value: 'id' },
                                          name: { kind: 'Name', value: 'displayId' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WeeklyDashboardTeamMembersTabQuery,
  WeeklyDashboardTeamMembersTabQueryVariables
>;
